/* eslint-disable default-case */
import { times, forEach, isArray, omit } from 'lodash';
import ArrowDropUpIcon from '@material-ui/icons/ArrowDropUp';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import {
  SEGMENT_FILTER_META,
  SEGMENT_FILTER_CATEGORIES,
  TOP_N_VALUE,
  LH_GRADE_VIEW_NAME,
  GEO_DIMENSION_EXPLORE,
  CONTENT_RECOMMENDATIONS_EXCEL_EXPORT_META,
  BORDER_PROPERTIES,
  SUB_HEADER_PROPERTIES,
  DATA_ROW_PROPERTIES,
  CR_EXCEL_COMMON_META,
  EXTRACT_SEGMENT_FILTER_PARAMS,
  RANK_BUCKETS_FILTERS,
} from '../constants/formMeta/growthTrends';
import { isSameDay, isAfter, isBefore, max } from 'date-fns';
import { getDomainWithoutSuffix, getSubdomain } from 'tldts';
import {
  COUNTRY_CODES,
  GOOGLE_FETCH_FAVICON_API,
  SITE_USABILITY_METRICS,
  SITE_USABILITY_SUMMARY_METRIC,
  SITE_REPORT_SUMMARY,
  CONTENT_RECOMMENDATION_EXPLORE,
  RESOLUTION_ENTITY_TYPE,
  chargebeeDayPassPlans,
  SUBSCRIPTION_STATUS,
} from '../constants/common';
import { CREATE_NEW_PAGE_USING, KEYWORD_DATA_SOURCE } from '../constants/content-recommendations';
import { getTestDriveDomain } from '../utility/services/authActions';
import utility from '../utility/services/utility';
import TrendsHelper from '../utility/services/trendsHelper';
import { get, has, isNull, uniq, capitalize } from 'lodash';
import moment from 'moment-timezone';
import {
  format,
  differenceInMonths,
  startOfWeek,
  startOfMonth,
  startOfQuarter,
  differenceInCalendarDays,
  subDays,
  subYears,
  addWeeks,
  getWeekOfMonth,
  addDays,
  subMonths,
  endOfMonth,
} from 'date-fns';
import ExcelJS from 'exceljs';
import saveAs from 'file-saver';
import ApiService from '../api/restApi';
import {
  RESOLVE_RECOMMENDATION_OPTIONS,
  RECOMMENDATION_STATUS_OPTIONS,
  CR_CHANGE_STATUS,
} from '../constants/formMeta/recommendation';
import { addUrl, topicsDataForExcel } from './excelHelper';
import { DATE_RANGE_META, CUSTOM_RANGE } from '../constants/formMeta/growthTrends';
import { getSchema } from './services/authActions';
import { formatAllTabData, mappedPageLevelAndKeywordTopics, safelyParse } from './cr-common';
import { v4 as uuidv4 } from 'uuid';
import { dispatchGetSegmentDataWithType } from './services/api/common';
import { getHostNameList } from './validation/urls';
import { trackAnalyticsEvent } from '../constants/analyticsMeta';

/**
 * Type only imports for JSDoc
 * See https://www.typescriptlang.org/docs/handbook/jsdoc-supported-types.html#import-types for more info
 * @typedef { import("./types").SegmentLimitFilters } SegmentLimitFilters
 * @typedef { import("./types").CustomerInfoSchema } CustomerInfoSchema
 *
 */

const {
  DEFAULT_ROW_HEIGHT,
  DATA_TABLE_START_INDEX,
  TABLE_DATA_ROW_HEIGHT,
  DEFAULT_COLUMN_WIDTH,
  DATA_COLUMN_WIDTH,
  SUMMARY_TABLE_ROW_HEIGHT,
  SUMMARY_TABLE_HEADER_HEIGHT,
} = CR_EXCEL_COMMON_META;
const METRIC_COLOR_MAPPING = {
  negative: { cssClass: 'negative-trend', key: 'negative' },
  positive: { cssClass: 'positive-trend', key: 'positive' },
  '% Change': {
    start1: '#198038',
    end1: '#198038',
    start2: '#6FDC8C',
    end2: '#6FDC8C',
    cssClass: 'negative-trend',
    key: '% Change',
  },
  Clicks: {
    start1: '#FFB000',
    end1: '#FFB000',
    start2: '#FFE785',
    end2: '#FFE785',
    cssClass: 'clicks',
    key: 'Clicks',
    isLight: true,
  },
  Position: {
    start1: '#FF9518',
    end1: '#FF6200',
    start2: '#FFD5A3',
    end2: '#FFC099',
    cssClass: 'position',
    key: 'Position',
  },
  CTR: { start1: '#5CD7ED', end1: '#19AADE', start2: '#BEEFF8', end2: '#A3DDF2', cssClass: 'ctr', key: 'CTR' },
  Impressions: {
    start1: '#FF6600',
    end1: '#FF6600',
    start2: '#FFA970',
    end2: '#FFA970',
    cssClass: 'impressions',
    key: 'Impressions',
  },
  'Market Share': {
    start1: '#845D51',
    end1: '#845D51',
    start2: '#B79C94',
    end2: '#B79C94',
    cssClass: 'market-share',
    key: 'Market Share',
  },
  Visitors: {
    start1: '#3CDDA3',
    end1: '#1E826F',
    start2: '#B2E3DA',
    end2: '#B7CFCA',
    cssClass: 'visitors',
    key: 'Visitors',
  },
  Conversions: {
    start1: '#DDBA3C',
    end1: '#B29C4B',
    start2: '#E3D9B6',
    end2: '#D6D0B7',
    cssClass: 'conversions',
    key: 'Conversions',
  },
  'Performance Score': {
    start1: '#3658CE',
    end1: '#3658CE',
    start2: '#98AAE6',
    end2: '#98AAE6',
    cssClass: 'performance',
    key: 'Performance Score',
  },
  'Best Practices Score': {
    start1: '#D30072',
    end1: '#D30072',
    start2: '#FFB3DC',
    end2: '#FFB3DC',
    cssClass: 'best-practice',
    key: 'Best Practices Score',
  },
  'SEO Compliance Score': {
    start1: '#C17400',
    end1: '#C17400',
    start2: '#FFCC80',
    end2: '#FFCC80',
    cssClass: 'seo',
    key: 'SEO Compliance Score',
  },
  'Accessibility Score': {
    start1: '#A900F9',
    end1: '#A900F9',
    start2: '#E6B3FF',
    end2: '#E6B3FF',
    cssClass: 'accesibility',
    key: 'Accessibility Score',
  },
  'Mobile Friendly Score': {
    start1: '#FFB351',
    end1: '#FFB351',
    start2: '#FFB351',
    end2: '#FFB351',
    cssClass: 'mobile',
    key: 'Mobile Friendly Score',
  },
};
export const SOLID_BAR_COLORS = [
  {
    start1: '#012749',
    end1: '#012749',
    start2: '#BAE6FF',
    end2: '#BAE6FF',
    key: 'option-1',
    cssClass: 'option-1',
    metric: '',
  },
  {
    start1: '#D12771',
    end1: '#D12771',
    start2: '#E590B7',
    end2: '#E590B7',
    key: 'option-2',
    cssClass: 'option-2',
    metric: '',
  },
  {
    start1: '#8A3FFC',
    end1: '#8A3FFC',
    start2: '#D4BBFF',
    end2: '#D4BBFF',
    key: 'option-3',
    cssClass: 'option-3',
    metric: '',
  },
  {
    start1: '#33B1FF',
    end1: '#33B1FF',
    start2: '#00DBD8',
    end2: '#00DBD8',
    key: 'option-4',
    cssClass: 'option-4',
    metric: '',
  },
  {
    start1: '#BA4E00',
    end1: '#BA4E00',
    start2: '#FF7800',
    end2: '#FF7800',
    key: 'option-5',
    cssClass: 'option-5', // this class is not added
    metric: '',
  },
];

const RANDOM_COLOR = [
  // TO BE DELETED
  {
    start1: '#CC1C5B',
    end1: '#651362',
    start2: '#E0BDCA',
    end2: '#CCBBCB',
    key: 'option-1',
    cssClass: 'option-1',
    metric: '',
  },
  {
    start1: '#BCFF50',
    end1: '#9FD348',
    start2: '#9FD348',
    end2: '#D7E2C6',
    key: 'option-2',
    cssClass: 'option-2',
    metric: '',
  },
  {
    start1: '#00FFD1',
    end1: '#17C9A9',
    start2: '#B8EAE1',
    end2: '#BCE0D9',
    key: 'option-3',
    cssClass: 'option-3',
    metric: '',
  },
  {
    start1: '#E76B37',
    end1: '#1E826F',
    start2: '#E5C0B0',
    end2: '#BDAAA2',
    key: 'option-4',
    cssClass: 'option-4',
    metric: '',
  },
];
export const filterTypes = {
  device: { value: '{value}', children: 'Is Equal to' },
  intent: { value: '{value}', children: 'Is Equal to' },
  country: { value: '{value}', children: 'Is Equal to' },
  sources: { value: '{value}', children: 'Is Equal to' },
  category: { value: '{value}', children: 'Is Equal to' },
  pages: { value: '{value}', children: 'Is Equal to' },
  queries: { value: '{value}', children: 'Is Equal to' },
  keyword_serp_features: { value: '%{value}%', children: 'Include' },
  distinct_search_type: { value: '{value}', children: 'Is Equal to' },
  goals_concat: { value: '{value}', children: 'Is Equal to' },
  domain: { value: '{value}', children: 'Is Equal to' },
  language: { value: '{value}', children: 'Is Equal to' },
  adgroup_name: { value: '{value}', children: 'Is Equal to' },
  campaign_name: { value: '{value}', children: 'Is Equal to' },
  campaign_type: { value: '{value}', children: 'Is Equal to' },
  page_experience: { value: '{value}', children: 'Is Equal to' },
  keyword_country: { value: '{value}', children: 'Is Equal to' },
  keyword_state: { value: '{value}', children: 'Is Equal to' },
  keyword_city: { value: '{value}', children: 'Is Equal to' },
  page_country: { value: '{value}', children: 'Is Equal to' },
  page_state: { value: '{value}', children: 'Is Equal to' },
  page_city: { value: '{value}', children: 'Is Equal to' },
};
export const RANKING_FACTOR_COLORS = [...SOLID_BAR_COLORS];

export const HTML_URL_EXCLUDE_STRING = ['#:~:text=', '#:~:', ':text=', '&'];

export function numberFormatter(value, decimals = 2) {
  if (value) {
    return Math.abs(Number(value)) >= 1.0e9
      ? Math.round((Number(value) / 1.0e9) * 100) / 100 + 'B'
      : // Six Zeroes for Millions
      Math.abs(Number(value)) >= 1.0e6
      ? Math.round((Number(value) / 1.0e6) * 100) / 100 + 'M'
      : // Three Zeroes for Thousands
      Math.abs(Number(value)) >= 1.0e3
      ? Math.round((Number(value) / 1.0e3) * 100) / 100 + 'K'
      : Number(Number(value).toFixed(2));
    // : Math.round(Number(value) * 10 * decimals) / (10 * decimals);
  } else {
    return 0;
  }
}

export const removeBadStringAndEncodeUrl = (urls, isEncode = true) => {
  const encodeUrls = urls?.map((url) => {
    const foundSubstring = HTML_URL_EXCLUDE_STRING?.find((substring) => url?.includes(substring));
    const finalUrl = foundSubstring ? url?.split(foundSubstring)?.[0] : url;
    return isEncode ? encodeURIComponent(finalUrl) : finalUrl;
  });
  return encodeUrls;
};

export const numberWithTwoDecimals = (value) => {
  if (typeof value === 'number') {
    return value ? Number(value.toFixed(2)) : 0;
  } else if (typeof value === 'string') {
    return value ? Number(parseFloat(value).toFixed(2)) : 0;
  } else {
    return value;
  }
};

/**
 * @param {any[]} chartsData
 * @returns {any[]}
 */
export function removeViewNameFromChartsData(chartsData) {
  let allKeys, formattedObj, formattedKey, value;

  const genericChartData = chartsData?.map((obj) => {
    formattedObj = {};
    allKeys = Object.keys(obj);
    allKeys.forEach((key) => {
      value = obj[key];
      formattedKey = key.split('.')[1] ? key.split('.')[1] : key;
      formattedObj[formattedKey] = value;
    });
    return formattedObj;
  });

  return genericChartData;
}

export const mapTabNameToParameter = (tabName, viewName, drillByValue) => {
  switch (tabName) {
    case 'year':
    case 'quarter':
    case 'month':
    case 'week':
    case 'day':
      return `${viewName}.dynamic_timeframe`;
    case 'intent':
      return `intent_lookup.intent`;
    case 'category':
      return `content_lookup.category`;
    case 'sources':
      return `${viewName}.source_medium`;
    case 'domain':
      return `${viewName}.site`;
    case 'countries':
      return `${viewName}.country`;
    case 'keyword city tags':
      return `${viewName}.keyword_city`;
    case 'keyword state tags':
      return `${viewName}.keyword_state`;
    case 'keyword country tags':
      return `${viewName}.keyword_country`;
    case 'page city tags':
      return `${viewName}.page_city`;
    case 'page state tags':
      return `${viewName}.page_state`;
    case 'page country tags':
      return `${viewName}.page_country`;
    case 'language':
      return 'intent_lookup.query_language';
    case 'devices':
      return `${viewName}.device`;
    case 'pages':
      return `${viewName}.page`;
    case 'queries':
      return `intent_lookup.query`;
    case 'subcategory1':
      return `content_lookup.subcategory1`;
    case 'subcategory2':
      return `content_lookup.subcategory2`;
    case 'date_granularity':
      return `${viewName}.date_granularity`;
    case 'selected_period':
      return `${viewName}.selected_period`;
    case 'comparison_period':
      return `${viewName}.comparison_period`;
    case 'competitors':
      return `${viewName}.competitor_site`;
    case 'top 3 competitors':
      return `${viewName}.competitor_site`;
    case `top ${TOP_N_VALUE}`:
      switch (drillByValue) {
        case `Top ${TOP_N_VALUE} Categories`:
          return 'top_category.other_bucket_threshold';
        case `Top ${TOP_N_VALUE} Pages`:
          return 'top_pages.other_bucket_threshold';
        case `Top ${TOP_N_VALUE} Queries`:
          return 'top_query.other_bucket_threshold';
        case `Top ${TOP_N_VALUE} Subcategories`:
          return 'top_subcategory.other_bucket_threshold';
        case `Top ${TOP_N_VALUE} Category - Intent Combinations`:
          return 'top_category_intent.other_bucket_threshold';
        case `Top ${TOP_N_VALUE} Intent - Sub-Category 1`:
          return 'top_intent_subcategory.other_bucket_threshold';
        case `Top ${TOP_N_VALUE} Category - Subcategory1 Combinations`:
          return 'top_category_subcategory.other_bucket_threshold';
        case `Top ${TOP_N_VALUE} Countries`:
          return 'top_countries.other_bucket_threshold';
      }
      break;
    case `categorySubCategory`:
      return `top_category_subcategory.category_subcategory`;
    case `categoryIntent`:
      return `top_category_intent.category_intent`;
    case `intentSubCategory`:
      return `top_intent_subcategory.intent_subcategory`;
    case 'page_experience':
      return `${LH_GRADE_VIEW_NAME}.lh_grade`;
    case 'city':
      return `${GEO_DIMENSION_EXPLORE}.city`;
    case 'state':
      return `${GEO_DIMENSION_EXPLORE}.state`;
    case 'adgroup_name':
      return `${viewName}.adgroup_name`;
    case 'campaign_name':
      return `${viewName}.campaign_name`;
    case 'ranking Factors':
      return `${viewName}.ranking_factor`;
    case 'other_competitor':
      return `${viewName}.competitor_domain`;
    case 'Content Type':
      return `${viewName}.content_type`;
    case 'Performance Metrics':
      return `${viewName}.performance_metrics`;
    case 'Accessibility':
      return `${viewName}.ACCESSIBILITY`;
    case 'SEO Compliance':
      return `${viewName}.SEO`;
    case 'Best Practices':
      return `${viewName}.BEST_PRACTICES`;
    case 'rank buckets':
      return `${viewName}.rank_buckets_cat`;
    case 'goals':
      return `${viewName}.goals_concat`;
  }
};

export const getMappedDimensionAndFilterParameter = (drillBy, viewName) => {
  switch (drillBy) {
    case 'category':
      return {
        dimension: 'content_lookup.category_with_other',
        filter: 'content_lookup.category_selected',
      };
    case 'subcategory1':
      return {
        dimension: 'content_lookup.subcategory1_with_other',
        filter: 'content_lookup.subcategory1_selected',
      };
    case 'subcategory2':
      return {
        dimension: 'content_lookup.subcategory2_with_other',
        filter: 'content_lookup.subcategory2_selected',
      };
    case 'intent':
      return {
        dimension: 'intent_lookup.intent_with_other',
        filter: 'intent_lookup.intent_selected',
      };
    case 'goals':
      return {
        dimension: `${viewName}.goals_concat`,
        filter: `${viewName}.goals_concat`,
      };
    case 'language':
      return {
        dimension: 'intent_lookup.query_language_with_other',
        filter: 'intent_lookup.query_language_selected',
      };
    case 'sources':
      return {
        dimension: `${viewName}.source_medium_with_other`,
        filter: `${viewName}.source_medium_selected`,
      };
    case 'domain':
      return {
        dimension: `${viewName}.site_with_other`,
        filter: `${viewName}.site_selected`,
      };
    case 'countries':
      return {
        dimension: `${viewName}.country_with_other`,
        filter: `${viewName}.country_selected`,
      };
    case 'keyword state tags':
      return {
        dimension: `${viewName}.keyword_state_with_other`,
        filter: `${viewName}.keyword_state_selected`,
      };
    case 'keyword city tags':
      return {
        dimension: `${viewName}.keyword_city_with_other`,
        filter: `${viewName}.keyword_city_selected`,
      };
    case 'keyword country tags':
      return {
        dimension: `${viewName}.keyword_country_with_other`,
        filter: `${viewName}.keyword_country_selected`,
      };
    case 'page state tags':
      return {
        dimension: `${viewName}.page_state_with_other`,
        filter: `${viewName}.page_state_selected`,
      };
    case 'page city tags':
      return {
        dimension: `${viewName}.page_city_with_other`,
        filter: `${viewName}.page_city_selected`,
      };
    case 'page country tags':
      return {
        dimension: `${viewName}.page_country_with_other`,
        filter: `${viewName}.page_country_selected`,
      };
    case 'devices':
      return {
        dimension: `${viewName}.device_with_other`,
        filter: `${viewName}.device_selected`,
      };
    case 'pages':
      return {
        dimension: `content_lookup.page_with_other`,
        filter: `content_lookup.page_selected`,
      };
    case 'queries':
      return {
        dimension: `${viewName}.keyword_with_other`,
        filter: `${viewName}.keyword_selected`,
      };
    case 'competitors':
      return {
        dimension: `${viewName}.competitor_site_filtered`,
        filter: `${viewName}.competitor_site_selected`,
      };
    case 'top 3 competitors':
      return {
        dimension: `${viewName}.competitor_site_filtered`,
        filter: `${viewName}.competitor_site_selected`,
      };
    case `Top ${TOP_N_VALUE} Categories`:
      return {
        dimension: 'top_category.top_category',
        filter: 'top_category.other_bucket_threshold',
      };
    case `Top ${TOP_N_VALUE} Intents`:
      return {
        dimension: 'top_intent.top_intent',
        filter: 'top_intent.other_bucket_threshold',
      };
    case `Top ${TOP_N_VALUE} Pages`:
      return {
        dimension: 'top_pages.top_pages',
        filter: 'top_pages.other_bucket_threshold',
      };
    case `Top ${TOP_N_VALUE} Queries`:
      return {
        dimension: 'top_query.top_queries',
        filter: 'top_query.other_bucket_threshold',
      };
    case `Top ${TOP_N_VALUE} Subcategories`:
      return {
        dimension: 'top_subcategory.top_subcategory',
        filter: 'top_subcategory.other_bucket_threshold',
      };
    case `Top ${TOP_N_VALUE} Category - Intent Combinations`:
      return {
        dimension: 'top_category_intent.top_category_intent',
        filter: 'top_category_intent.other_bucket_threshold',
      };
    case `Top ${TOP_N_VALUE} Intent - Sub-Category 1`:
      return {
        dimension: 'top_intent_subcategory.top_intent_subcategory',
        filter: 'top_intent_subcategory.other_bucket_threshold',
      };
    case `Top ${TOP_N_VALUE} Category - Subcategory1 Combinations`:
      return {
        dimension: 'top_category_subcategory.top_category_subcategory',
        filter: 'top_category_subcategory.other_bucket_threshold',
      };
    case `Top ${TOP_N_VALUE} Countries`:
      return {
        dimension: 'top_countries.top_countries',
        filter: 'top_countries.other_bucket_threshold',
      };
    case 'categorySubCategory':
      return {
        dimension: 'top_category_subcategory.category_subcategory_with_other',
        filter: 'top_category_subcategory.category_subcategory_selected',
      };
    case 'categoryIntent':
      return {
        dimension: 'top_category_intent.category_intent_with_other',
        filter: 'top_category_intent.category_intent_selected',
      };
    case 'intentSubCategory':
      return {
        dimension: 'top_intent_subcategory.intent_subcategory_with_other',
        filter: 'top_intent_subcategory.intent_subcategory_selected',
      };
    case 'page_experience':
      return {
        dimension: `${LH_GRADE_VIEW_NAME}.lh_grade_with_other`,
        filter: `${LH_GRADE_VIEW_NAME}.lh_grade_selected`,
      };
    case 'city':
      return {
        dimension: `${GEO_DIMENSION_EXPLORE}.city_with_other`,
        filter: `${GEO_DIMENSION_EXPLORE}.city_selected`,
      };
    case 'state':
      return {
        dimension: `${GEO_DIMENSION_EXPLORE}.state_with_other`,
        filter: `${GEO_DIMENSION_EXPLORE}.state_selected`,
      };
    case 'adgroup_name':
      return {
        dimension: `${viewName}.adgroup_name_with_other`,
        filter: `${viewName}.adgroup_name_selected`,
      };
    case 'campaign_name':
      return {
        dimension: `${viewName}.campaign_name_with_other`,
        filter: `${viewName}.campaign_name_selected`,
      };
    case 'other_competitor':
      return {
        dimension: `${viewName}.competitor_domain`,
        filter: `${viewName}.competitor_domain`,
      };
    case 'rank buckets':
      return {
        dimension: `${viewName}.rank_buckets_cat`,
        filter: `${viewName}.rank_buckets_cat`,
      };
  }
};

export const mapSegmentKeyToParameter = (key, viewName, segment) => {
  switch (key) {
    case 'intent_segment':
      return segment === 'segmentData_1' ? 'intent_lookup.intent_segmentA' : 'intent_lookup.intent_segmentB';
    case 'query_language_segment':
      return segment === 'segmentData_1'
        ? 'intent_lookup.query_language_segmentA'
        : 'intent_lookup.query_language_segmentB';
    case 'category_segment':
      return segment === 'segmentData_1' ? 'content_lookup.category_segmentA' : 'content_lookup.category_segmentB';
    case 'category_subcategory1_concat_segment':
      return segment === 'segmentData_1'
        ? 'content_lookup.category_subcategory1_concat_segmentA'
        : 'content_lookup.category_subcategory1_concat_segmentB';
    case 'category_subcat1_subcat2_concat_segment':
      return segment === 'segmentData_1'
        ? 'content_lookup.category_subcat1_subcat2_concat_segmentA'
        : 'content_lookup.category_subcat1_subcat2_concat_segmentB';
    case 'domain_segment':
      return segment === 'segmentData_1' ? `${viewName}.domain_segmentA` : `${viewName}.domain_segmentB`;
    case 'device_segment':
      return segment === 'segmentData_1' ? `${viewName}.device_segmentA` : `${viewName}.device_segmentB`;
    case 'country_segment':
      return segment === 'segmentData_1' ? `${viewName}.country_segmentA` : `${viewName}.country_segmentB`;
    case 'page_segment':
      return segment === 'segmentData_1' ? `${viewName}.page_segmentA` : `${viewName}.page_segmentB`;
    case 'keyword_segment':
      return segment === 'segmentData_1' ? `${viewName}.keyword_segmentA` : `${viewName}.keyword_segmentB`;
    case 'search_type_segment':
      return segment === 'segmentData_1' ? `${viewName}.search_type_segmentA` : `${viewName}.search_type_segmentB`;
    case 'goals_concat':
      return segment === 'segmentData_1' ? `${viewName}.goals_concatA` : `${viewName}.goals_concatB`;
    case 'source_medium_selected':
      return segment === 'segmentData_1' ? `${viewName}.source_medium_segmentA` : `${viewName}.source_medium_segmentB`;
    case 'keyword_list_segment':
      return segment === 'segmentData_1' ? `${viewName}.keyword_list_segmentA` : `${viewName}.keyword_list_segmentB`;
    case 'page_list_segment':
      return segment === 'segmentData_1' ? `${viewName}.page_list_segmentA` : `${viewName}.page_list_segmentB`;
    case 'keyword_state_segment':
      return segment === 'segmentData_1' ? `${viewName}.keyword_state_segmentA` : `${viewName}.keyword_state_segmentB`;
    case 'keyword_city_segment':
      return segment === 'segmentData_1' ? `${viewName}.keyword_city_segmentA` : `${viewName}.keyword_city_segmentB`;
    case 'page_state_segment':
      return segment === 'segmentData_1' ? `${viewName}.page_state_segmentA` : `${viewName}.page_state_segmentB`;
    case 'page_city_segment':
      return segment === 'segmentData_1' ? `${viewName}.page_city_segmentA` : `${viewName}.page_city_segmentB`;
    default:
      return `${viewName}.${key}`;
  }
};

export const isFilterSetFromKeywordPopExplore = (segmentData_1, segmentData_2 = {}) => {
  return (
    (segmentData_1.intent_segment && segmentData_1.intent_segment.length) ||
    (segmentData_2.intent_segment && segmentData_2.intent_segment.length) ||
    (segmentData_1.query_language_segment && segmentData_1.query_language_segment.length) ||
    (segmentData_2.query_language_segment && segmentData_2.query_language_segment.length) ||
    (segmentData_1.category_segment && segmentData_1.category_segment.length) ||
    (segmentData_2.category_segment && segmentData_2.category_segment.length) ||
    (segmentData_1.page_segment && segmentData_1.page_segment.length) ||
    (segmentData_2.page_segment && segmentData_2.page_segment.length) ||
    (segmentData_1.keyword_segment && segmentData_1.keyword_segment.length) ||
    (segmentData_2.keyword_segment && segmentData_2.keyword_segment.length) ||
    (segmentData_1.keyword_list_segment && segmentData_1.keyword_list_segment.length) ||
    (segmentData_1.page_list_segment && segmentData_1.page_list_segment.length) ||
    (segmentData_2.keyword_list_segment && segmentData_2.keyword_list_segment.length) ||
    (segmentData_2.page_list_segment && segmentData_2.page_list_segment.length)
  );
};

export const topNCombination = ['categorySubCategory', 'categoryIntent', 'intentSubCategory'];

export function capitalizeFirstLetter(string) {
  return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
}

export function capitalizeWords(string) {
  let transformedString = '',
    words = string.split(' ');

  words.forEach((w) => {
    transformedString = `${transformedString} ${capitalizeFirstLetter(w)}`;
  });

  return transformedString;
}

export function titleCaseSnakeWords(string = '') {
  return string
    ?.split('_')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join('_');
}

export function addQuoteToWords(string) {
  let transformedString = '',
    words = string.split(' ');
  words.forEach((w, i) => {
    if (i <= 0) {
      if (w.includes('{')) {
        transformedString += `Any entity in ${w}`;
      } else {
        transformedString += `'${w}'`;
      }
    } else {
      if (w.includes('{')) {
        transformedString += ` and any entity in ${w}`;
      } else {
        transformedString += ` and '${w}'`;
      }
    }
  });

  return transformedString;
}

export function numberWithCommas(x) {
  if (x && x % 1 != 0) {
    x = x.toFixed(2);
  }
  return x ? x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') : '-';
}

export const sleep = (m) => new Promise((r) => setTimeout(r, m));

export const RemoveLastUrlPartOf = (the_url, time = 1) => {
  var the_arr = the_url.split('/');
  times(time, () => the_arr.pop());
  return the_arr.join('/');
};

export const getAvatarInitials = (name) => {
  let letters = '';
  if (name) {
    const splittedArray = name.split(' ');
    if (splittedArray.length && splittedArray.length === 1) {
      letters = splittedArray[0][0];
    } else {
      letters = `${splittedArray[0][0]}${splittedArray[splittedArray.length - 1][0]}`;
    }
  }
  return letters;
};

export const prepareCategoriesData = (data, passingValueSepration = '-', isForInternalLinking = false) => {
  const resultObj = {};
  data.forEach((i) => {
    //taking out all main categories
    if (!resultObj[i.category] && i.category !== 'NA') {
      resultObj[i.category] = {};
      resultObj[i.category]['totalclicks'] = i.totalclicks;
    }
  });
  data.forEach((i) => {
    // adding subcat1's
    if (i?.subcategory1 && resultObj[i.category] && !resultObj[i.category][i.subcategory1] && i.subcategory1 !== 'NA') {
      resultObj[i.category][i.subcategory1] = [];
      resultObj[i.category][i.subcategory1]['totalclicks'] = i.totalclicks;
    }
  });
  data.forEach((i) => {
    // adding subcat2's
    if (
      i?.subcategory1 &&
      i?.subcategory2 &&
      resultObj[i.category] &&
      resultObj[i.category][i.subcategory1] &&
      !resultObj[i.category][i.subcategory2] &&
      i.subcategory2 !== 'NA'
    ) {
      resultObj[i.category][i.subcategory1][i.subcategory2] = {};
      resultObj[i.category][i.subcategory1].push(i.subcategory2);
      resultObj[i.category][i.subcategory1][i.subcategory2]['totalclicks'] = i.totalclicks;
      if (Number(resultObj[i.category][i.subcategory1]['totalclicks']) != Number(i.totalclicks)) {
        resultObj[i.category][i.subcategory1]['totalclicks'] =
          Number(resultObj[i.category][i.subcategory1]['totalclicks']) + Number(i.totalclicks);
      }
    }
  });

  var catKeyValue = [];
  Object.keys(resultObj).forEach((maincat) => {
    Object.keys(resultObj[maincat]).forEach((subcat1) => {
      if (subcat1 != 'totalclicks') {
        if (Number(resultObj[maincat]['totalclicks']) != Number(resultObj[maincat][subcat1].totalclicks)) {
          resultObj[maincat]['totalclicks'] =
            Number(resultObj[maincat]['totalclicks']) + Number(resultObj[maincat][subcat1]['totalclicks']);
        }
      }
    });
  });

  Object.keys(resultObj).forEach((maincat) => {
    catKeyValue.push({ key: maincat, value: Number(resultObj[maincat]['totalclicks']) });
  });

  if (!isForInternalLinking) {
    catKeyValue.sort(function (maincat1, maincat2) {
      return maincat2.value - maincat1.value;
    });
  }

  var maincatkey = Object.keys(catKeyValue).map((i) => {
    return catKeyValue[i].key;
  });

  var options = []; // flatteing the object for generating all options

  //used encodedValue string if category, subcategory1, subcategory2 includes any "-" by default we will replace it with /*dash*/ to ease out filtration at end

  Object.values(maincatkey).forEach((mainCat) => {
    const totalPageCountForCat =
      data?.find((catDetails) => catDetails?.category === mainCat)?.totalPageCountForCat || 0;
    options.push({
      value: mainCat,
      passingValue: mainCat,
      type: 'category',
      text: mainCat,
      totalclicks: Object.keys(resultObj[mainCat]).includes('totalclicks') ? resultObj[mainCat].totalclicks : 0,
      filterString: Object.keys(resultObj[mainCat]).includes('totalclicks') ? '{}' : JSON.stringify(resultObj[mainCat]),
      encodedValue: `${mainCat?.replace(/-/g, '/*dash*/')}`,
      pagecount: totalPageCountForCat,
    });
    Object.keys(resultObj[mainCat]).forEach((subcat1) => {
      const totalPageCountForSubCat1 =
        data?.find((catDetails) => catDetails?.category === mainCat && catDetails?.subcategory1 === subcat1)
          ?.totalPageCountForSubCat1 || 0;

      if (subcat1 != 'totalclicks') {
        options.push({
          value: `${mainCat}-${subcat1}`,
          passingValue: `${mainCat}${passingValueSepration}${subcat1}`,
          type: 'subcategory1',
          text: subcat1,
          totalclicks: Object.keys(resultObj[mainCat][subcat1]).includes('totalclicks')
            ? resultObj[mainCat][subcat1].totalclicks
            : 0,
          filterString: JSON.stringify(resultObj[mainCat][subcat1]),
          encodedValue: `${mainCat?.replace(/-/g, '/*dash*/')}-${subcat1?.replace(/-/g, '/*dash*/')}`,
          pagecount: totalPageCountForSubCat1,
        });
        resultObj[mainCat][subcat1].forEach((child) => {
          const totalPageCountForSubCat2 =
            data?.find(
              (catDetails) =>
                catDetails?.category === mainCat &&
                catDetails?.subcategory1 === subcat1 &&
                catDetails?.subcategory2 === child
            )?.totalPageCountForSubCat2 || 0;

          if (child && !options.find((i) => i.value === `${mainCat}-${subcat1}-${child}`)) {
            options.push({
              value: `${mainCat}-${subcat1}-${child}`,
              passingValue: `${mainCat}${passingValueSepration}${subcat1}${passingValueSepration}${child}`,
              text: subcat1,
              totalclicks: Object.keys(resultObj[mainCat][subcat1][child]).includes('totalclicks')
                ? resultObj[mainCat][subcat1][child].totalclicks
                : 0,
              type: 'subcategory2',
              text: child,
              filterString: child,
              pagecount: totalPageCountForSubCat2,
              encodedValue: `${mainCat?.replace(/-/g, '/*dash*/')}-${subcat1?.replace(
                /-/g,
                '/*dash*/'
              )}-${child?.replace(/-/g, '/*dash*/')}`,
            });
          }
        });
      }
    });
  });
  return options;
};

export const prepareCreatedbyData = (data) => {
  let options = [];
  data.map((item) => {
    options.push({
      value: item,
      type: 'createdby',
      text: item,
    });
  });

  return options;
};

export const prepareAuditTypeData = (data) => {
  let options = [];
  let tempArr = {};
  data.forEach((row) => {
    if (!tempArr[row.category]) {
      tempArr[row.category] = [];
    }
    if (!tempArr[row.category][row.subcategory1]) {
      tempArr[row.category][row.subcategory1] = 1;
    }
  });
  Object.keys(tempArr).forEach((cat) => {
    options.push({
      value: '',
      type: 'lh-category-disabled',
      text: cat,
    });
    Object.keys(tempArr[cat]).forEach((auditType) => {
      options.push({
        value: auditType,
        type: 'subcategory1',
        text: auditType,
      });
    });
  });
  return options;
};

// export const prepareFiltersOptions = ({ options, filterData, filters, domainWithWWW = false }) => {
//   options.forEach((k1) => {
//     Object.keys(filterData)?.forEach((k2) => {
//       if (k2.includes(k1)) {
//         const filterOptions = [];
//         filterData[k2]?.forEach((i) => {
//           if (i.top_data) {
//             let label = '';
//             if (k1 === 'domain' && i.top_data) {
//               label = i.top_data.replace(/^(?:https?:\/\/)?(?:www\.)?/i, '').replace(/\/$/, '');
//               if (domainWithWWW) {
//                 label = i.top_data;
//               }
//             } else if (['page_experience', 'performance_metrics'].includes(k1)) {
//               label = i.text;
//             } else {
//               label = i.top_data;
//             }
//             filterOptions.push({
//               text: label,
//               value: i.top_data,
//               type: k2,
//               totalclicks: Number(i.totalclicks),
//             });
//           } else if (i?.isCustomDropdownTextValue) {
//             filterOptions.push({
//               ...i,
//             });
//           }
//         });
//         filters[k1] = filters[k1]
//           ? { ...SEGMENT_FILTER_META[k1], options: [...filters[k1].options, ...filterOptions] }
//           : { ...SEGMENT_FILTER_META[k1], options: filterOptions };
//       }
//     });
//   });
// };

export const prepareFiltersOptions = ({ options, filterData, filters, domainWithWWW = false }) => {
  for (const k1 of options) {
    for (const k2 of Object.keys(filterData)) {
      if (k2.includes(k1)) {
        const filterOptions = [];
        for (const i of filterData?.[k2] || []) {
          if (i.top_data) {
            let label = '';
            if (k1 === 'domain' && i.top_data) {
              label = i.top_data.replace(/^(?:https?:\/\/)?(?:www\.)?/i, '').replace(/\/$/, '');
              if (domainWithWWW) {
                label = i.top_data;
              }
            } else if (['page_experience', 'performance_metrics'].includes(k1)) {
              label = i.text;
            } else {
              label = i.top_data;
            }
            filterOptions.push({
              text: label,
              value: i.top_data,
              type: k2,
              totalclicks: Number(i.totalclicks),
            });
          } else if (i?.isCustomDropdownTextValue) {
            filterOptions.push({
              ...i,
            });
          }
        }
        filters[k1] = filters[k1]
          ? { ...SEGMENT_FILTER_META[k1], options: [...filters[k1].options, ...filterOptions] }
          : { ...SEGMENT_FILTER_META[k1], options: filterOptions };
      }
    }
  }
};

// TODO move following 3 methods into segmentFilterHelper.ts
/**
 * @param {[CustomerInfoSchema]} customerInfo - Array having customer info for all schema's
 * @return {SegmentLimitFilters}
 */
export const getSegmentLimitsForUser = async (customerInfo, qwaSession) => {
  const schemaName = await getSchema(qwaSession);
  let index = customerInfo.findIndex((data) => {
    return data?.cust_code === schemaName;
  });
  index = index === -1 ? 0 : index;
  return get(customerInfo, `[${index}].additional_user_info.segmentLimits`) || {};
};

/**
 * @param {SegmentLimitFilters} segmentLimits - Array having customer info for all schema's
 * @param {Object} segmentFilters - Segment Filters Data
 * @return {Object} - Segment Filters Data with Overrriden values
 */
export const replaceSegmentLimitOptions = (segmentLimits, segmentFilters) => {
  Object.keys(segmentLimits).forEach((segmentKey) => {
    if (Array.isArray(segmentFilters[segmentKey]) && Array.isArray(segmentLimits[segmentKey])) {
      segmentFilters[segmentKey] = segmentFilters[segmentKey].filter((i) => {
        return segmentLimits[segmentKey].includes(i['top_data']);
      });
    }
  });
  return segmentFilters;
};

/**
 * @param {SegmentLimitFilters} segmentLimits - Array having customer info for all schema's
 * @param {string} segmentKey - Segment Filters Data
 * @return {Object} - { segmentFilterValue, segmentFilterSelections }
 */
export const getSegmentLimitFilterValues = (segmentLimits, segmentKey) => {
  const segmentFilterValue = Array.isArray(segmentLimits[segmentKey])
    ? segmentLimits[segmentKey].join(',')
    : segmentLimits[segmentKey];
  const segmentFilterSelections = Array.isArray(segmentLimits[segmentKey])
    ? segmentLimits[segmentKey]
        .filter((fValue) => getCountryName(fValue, true))
        .map((filterValue) => {
          if (segmentKey === 'country') {
            return { text: getCountryName(filterValue), value: filterValue, type: segmentKey, defaultApplied: true };
          }
          return { text: filterValue, value: filterValue, type: segmentKey, defaultApplied: true };
        })
    : { text: segmentLimits[segmentKey], value: segmentLimits[segmentKey], type: segmentKey };
  return { segmentFilterValue, segmentFilterSelections };
};

/**
 * @param {Object} segmentData - Object with  segmentData_1 and segmentData_2 values
 */
export const extractSegmentFilterParams = (segmentData) => {
  const filterData = {};
  [...EXTRACT_SEGMENT_FILTER_PARAMS].forEach((key) => {
    Object.keys(segmentData).forEach((segment, index) => {
      if (segmentData[segment] && segmentData[segment][key]) {
        if (Array.isArray(segmentData[segment][key])) {
          const valuesArray = segmentData[segment][key].map((i) => i.value);
          filterData[`${key}${index ? 'B' : 'A'}`] = valuesArray.join(',').replace(/^,|,$/g, '');
        } else {
          filterData[`${key}${index ? 'B' : 'A'}`] = segmentData[segment][key].value;
        }
      } else {
        if (segment && segment.startsWith('segmentData_')) {
          // to prevent other keys from resetting the filter value e.g id, segment_name
          filterData[`${key}${index ? 'B' : 'A'}`] = ''; // setting empty value if segment filter is not present
        }
      }
    });
  });

  Object.keys(SEGMENT_FILTER_CATEGORIES).forEach((cat) => {
    Object.keys(segmentData).forEach((segment, index) => {
      if (
        segmentData[segment] &&
        segmentData[segment]['category_segment'] &&
        segmentData[segment]['category_segment'].length
      ) {
        const valuesArray = segmentData[segment]['category_segment'].filter((i) => i.type === cat).map((i) => i.value);
        filterData[`${SEGMENT_FILTER_CATEGORIES[cat]}${index ? 'B' : 'A'}`] = valuesArray
          .join(',')
          .replace(/^,|,$/g, '');
      } else {
        filterData[`${SEGMENT_FILTER_CATEGORIES[cat]}${index ? 'B' : 'A'}`] = '';
      }
    });
  });
  return filterData;
};

export const appendHttpsIfNotPresent = (url) => {
  return url && !url.includes('https:') ? `https://${url.trim()}` : url;
};

export const removeWww = (url = '') => {
  return url.replace(/^(?:https?:\/\/)?(?:www\.)?(?:www1\.)?(?:www2\.)?/i, '').replace(/\/$/, '');
};

export const isProductionEnv = ['production'].includes(process.env.NEXT_PUBLIC_APP_ENV);

export const DAY_PASS_LITE_PLAN_ID = isProductionEnv
  ? chargebeeDayPassPlans.prod.DAY_PASS_LITE
  : chargebeeDayPassPlans.dev.DAY_PASS_LITE;

export const DAY_PASS_PLAN_ID = isProductionEnv
  ? chargebeeDayPassPlans.prod.DAY_PASS
  : chargebeeDayPassPlans.dev.DAY_PASS;

export const copyUrlToClipboard = (urlToCopy) => {
  var dummy = document.createElement('input'),
    text = urlToCopy;

  document.body.appendChild(dummy);
  dummy.value = text;
  dummy.select();
  document.execCommand('copy');
  navigator.clipboard.writeText(urlToCopy); // temp and unique solution without creating the element
  document.body.removeChild(dummy);
};

export const handlePreviousTrendSegmentData = (segmentData, isGrowthTrends = false) => {
  if (segmentData.is_branded === undefined) {
    segmentData['is_branded'] = [{ text: 'All Searches', value: null, defaultApplied: true, type: 'branded' }];
  }

  if (isGrowthTrends && get(segmentData, 'domain_segment[0].onlyForMarketShare')) {
    delete segmentData['domain_segment'];
  }

  let allKeys = Object.keys(segmentData);

  if (allKeys) {
    allKeys.forEach((key) => {
      segmentData[key].forEach((segmentValue) => {
        if (!segmentValue.text) {
          segmentValue.text = segmentValue.value;
        }
      });
    });
  }
};

export const disableMeasureForNonComparativeData = (metric2, dataArr, isSegmentComparison) => {
  let measure3Disabled = false,
    measure4Disabled = false;

  if (isSegmentComparison) {
    let prevPeriodRecordCount = 0,
      curPeriodRecordCount = 0;

    dataArr.forEach((obj) => (obj.is_in_selected_period === 'Yes' ? curPeriodRecordCount++ : prevPeriodRecordCount++));

    if (prevPeriodRecordCount != curPeriodRecordCount) {
      measure3Disabled = measure4Disabled = true;
    }
  } else {
    if (metric2 != 'none') {
      let previousPeriodNullCountForMetric1 = 0,
        previousPeriodNullCountForMetric2 = 0;
      // check for total and %-change
      // considering metric1 prev period value coming in measure_5_wrapper and metric2 prev period value in measure_6_wrapper
      dataArr.forEach((dataObj) => {
        dataObj.measure_1_wrapper && dataObj.measure_5_wrapper === null ? previousPeriodNullCountForMetric1++ : '';
        dataObj.measure_2_wrapper && dataObj.measure_6_wrapper === null ? previousPeriodNullCountForMetric2++ : '';
      });

      // if (previousPeriodNullCountForMetric1 > 1) {
      //   measure3Disabled = true;
      // }
      // if (previousPeriodNullCountForMetric2 > 1) {
      //   measure4Disabled = true;
      // }
    } else {
      let previousPeriodNullCountForMetric1 = 0;
      // check for total and %-change
      dataArr.forEach((dataObj) => {
        dataObj.measure_1_wrapper && dataObj.measure_2_wrapper === null ? previousPeriodNullCountForMetric1++ : '';
      });

      // if (previousPeriodNullCountForMetric1 > 1) {
      //   measure3Disabled = measure4Disabled = true;
      // }
    }
  }

  return {
    measure3Disabled,
    measure4Disabled,
  };
};

export const addFeatureFlags = async function ({ req }) {
  let features = {};
  let featureKeys = [];

  if (req) {
    features = req.features;
    for (let p in features) {
      if (features.hasOwnProperty(p)) {
        featureKeys.push(p);
      }
    }
  } else {
    const res = await fetch('/api/features');
    features = await res.json();
    for (let p in features) {
      if (features.hasOwnProperty(p)) {
        featureKeys.push(p);
      }
    }
  }

  return {
    features: features,
    featureKeys: featureKeys,
  };
};

export const overrideSegmentFilters = (segmentData_1, segmentData_2 = {}) => {
  let updatedSegment1 = {
    ...segmentData_1,
  };
  let updatedSegment2 = {
    ...segmentData_2,
  };

  return {
    updatedSegment1,
    updatedSegment2,
  };
};
export function processSegmentComparisonData(data, viewName, scenarioObj) {
  let chartData = [...data];
  const selectedPeriodRecords = [];
  const comparedPeriodRecords = [];
  const totalsRecord = chartData.splice(-1, 1); // removed last record
  chartData.forEach((record) => {
    const tempRecord = { ...record };
    if (record[`${viewName}.is_in_selected_period`] === 'Yes') {
      Object.values(scenarioObj.keys).forEach((measureKeys, index) => {
        tempRecord[`${viewName}.measure_${index + 1}_seg_A`] =
          record[`${measureKeys[1].replace('${viewName}', viewName)}`];
        tempRecord[`${viewName}.measure_${index + 1}_seg_B`] =
          record[`${measureKeys[2].replace('${viewName}', viewName)}`];
        if (measureKeys[3]) {
          tempRecord[`${measureKeys[3]}_seg_A`] = tempRecord
            ? tempRecord[`${measureKeys[1].replace('${viewName}', viewName)}`]
            : 0;
          tempRecord[`${measureKeys[3]}_seg_B`] = tempRecord
            ? tempRecord[`${measureKeys[2].replace('${viewName}', viewName)}`]
            : 0;
        }
      });

      selectedPeriodRecords.push(tempRecord);
    } else {
      tempRecord[`${viewName}.dynamic_timeframe`] = tempRecord[`${viewName}.compared_timeframe`];
      Object.values(scenarioObj.keys).forEach((measureKeys, index) => {
        tempRecord[`${viewName}.measure_${index + 1}_seg_A`] =
          record[`${measureKeys[1].replace('${viewName}', viewName)}`];
        tempRecord[`${viewName}.measure_${index + 1}_seg_B`] =
          record[`${measureKeys[2].replace('${viewName}', viewName)}`];
        if (measureKeys[3]) {
          tempRecord[`${measureKeys[3]}_seg_A`] = tempRecord
            ? tempRecord[`${measureKeys[1].replace('${viewName}', viewName)}`]
            : 0;
          tempRecord[`${measureKeys[3]}_seg_B`] = tempRecord
            ? tempRecord[`${measureKeys[2].replace('${viewName}', viewName)}`]
            : 0;
        }
      });
      comparedPeriodRecords.push(tempRecord);
    }
  });
  chartData = removeViewNameFromChartsData([...selectedPeriodRecords, ...comparedPeriodRecords]);
  return {
    chartData,
  };
}

export function processSegmentSummaryData(data, viewToQueryTo) {
  const selectedPeriodTotals = data.find((i) => i[`is_in_selected_period`] === 'Yes') || {};
  const comparedPeriodTotals = data.find((i) => i[`is_in_selected_period`] === 'No') || {};

  let segmentA_totals = {
    metric_1_selectedP_total: selectedPeriodTotals[`measure_1_wrapper`],
    metric_2_selectedP_total: selectedPeriodTotals[`measure_3_wrapper`],

    metric_1_comparedP_total: comparedPeriodTotals[`measure_1_wrapper`],
    metric_2_comparedP_total: comparedPeriodTotals[`measure_3_wrapper`],

    metric_1_selectedP_change_total: selectedPeriodTotals[`metric_1_segment_a_pop_change`],
    metric_1_selectedP_percentage_total: (selectedPeriodTotals[`metric_1_segment_a_pop_percentage_change`] || 0) * 100,
    metric_2_selectedP_change_total: selectedPeriodTotals[`metric_2_segment_a_pop_change`],
    metric_2_selectedP_percentage_total: (selectedPeriodTotals[`metric_2_segment_a_pop_percentage_change`] || 0) * 100,
  };
  let segmentB_totals = {
    metric_1_selectedP_total: selectedPeriodTotals[`measure_2_wrapper`],
    metric_2_selectedP_total: selectedPeriodTotals[`measure_4_wrapper`],

    metric_1_comparedP_total: comparedPeriodTotals[`measure_2_wrapper`],
    metric_2_comparedP_total: comparedPeriodTotals[`measure_4_wrapper`],

    metric_1_selectedP_change_total: selectedPeriodTotals[`metric_1_segment_b_pop_change`],
    metric_1_selectedP_percentage_total: (selectedPeriodTotals[`metric_1_segment_b_pop_percentage_change`] || 0) * 100,
    metric_2_selectedP_change_total: selectedPeriodTotals[`metric_2_segment_b_pop_change`],
    metric_2_selectedP_percentage_total: (selectedPeriodTotals[`metric_2_segment_b_pop_percentage_change`] || 0) * 100,
  };
  return { segmentA_totals, segmentB_totals };
}

export function processDrillDownDataForSegmentComparison(data, viewName, scenarioObj, columnName) {
  const selectedPeriodRecords = data.filter((i) => i[`${viewName}.is_in_selected_period`] === 'Yes');
  const result = [];
  selectedPeriodRecords.forEach((record) => {
    const tempRecord = { ...record };
    Object.values(scenarioObj.keys).forEach((measureKeys, index) => {
      tempRecord[`${viewName}.measure_${index + 1}_seg_A`] =
        record[`${measureKeys[1].replace('${viewName}', viewName)}`];
      tempRecord[`${viewName}.measure_${index + 1}_seg_B`] =
        record[`${measureKeys[2].replace('${viewName}', viewName)}`];
      if (measureKeys[3] && index === 1) {
        const prevPeridObj = data.find(
          (rec) => rec[`${viewName}.is_in_selected_period`] === 'No' && rec[columnName] === record[columnName]
        );
        tempRecord[`${viewName}.measure_${index + 1}_seg_A`] = prevPeridObj
          ? prevPeridObj[`${measureKeys[1].replace('${viewName}', viewName)}`]
          : 0;
        tempRecord[`${viewName}.measure_${index + 1}_seg_B`] = prevPeridObj
          ? prevPeridObj[`${measureKeys[2].replace('${viewName}', viewName)}`]
          : 0;
      }
    });
    result.push(tempRecord);
  });
  return result;
}

export const calculateOverallAndCummulative = (opportunityList) => {
  const updateOpportunityList = [];
  opportunityList.forEach((list, index) => {
    updateOpportunityList.push({
      ...list,
      clicksOpportunity: list.clicks_delta_percent,
      clicksOverall: list.clicks_overall_percent_change,
      clicksCummulative:
        index === 0
          ? list.clicks_overall_percent_change
          : updateOpportunityList[index - 1].clicksCummulative + list.clicks_overall_percent_change,
      conversionOverall: list.convs_overall_percent_change,
      conversionCummulative:
        index === 0
          ? list.convs_overall_percent_change
          : updateOpportunityList[index - 1].conversionCummulative + list.convs_overall_percent_change,
      conversionOpportunity: list.convs_delta_percent,
    });
  });
  return updateOpportunityList;
};

export const mapToDrillDownInfoParams = (key) => {
  switch (key) {
    case 'currentDrillBy':
      return 'currentDrillBy';
    case 'currentTabIndex':
      return 'currentTabIndex';
    case 'overridenFilterData':
      return 'overridenFilterData';
    case 'selectedCompetitors':
      return 'selectedCompetitors';
    case 'selectedDrilldownOptions':
      return 'selectedDrilldownOptions';
    default:
      return key;
  }
};

export const mapToTrendDefinitionParameter = (key) => {
  switch (key) {
    case 'category_segment':
      return 'category_segment';
    case 'country_segment':
      return 'country_segment';
    case 'intent_segment':
      return 'intent_segment';
    case 'query_language_segment':
      return 'query_language_segment';
    case 'device_segment':
      return 'device_segment';
    case 'domain_segment':
      return 'domain_segment';
    case 'source_medium_selected':
      return 'source_medium_selected';
    case 'keyword_segment':
      return 'keyword_segment';
    case 'page_segment':
      return 'page_segment';
    case 'keyword_serp_features':
      return 'keyword_serp_features';
    case 'search_type_segment':
      return 'search_type_segment';
    case 'saved_segment':
      return 'saved_segment';
    case 'keyword_list_segment':
      return 'keyword_list_segment';
    case 'page_list_segment':
      return 'page_list_segment';
    case 'saved_comparison':
      return 'saved_comparison';
    case 'is_branded':
      return 'is_branded';
    case 'page_experience':
      return 'page_experience';
    case 'adgroup_name_segment':
      return 'adgroup_name_segment';
    case 'campaign_name_segment':
      return 'campaign_name_segment';
    case 'market_share_segment':
      return 'market_share_segment';
    case 'rank_bucket_segment':
      return 'rank_bucket_segment';
    case 'keyword_city_segment':
      return 'keyword_city_segment';
    case 'keyword_state_segment':
      return 'keyword_state_segment';
  }
};

export function findDateIndex(datesArr, datesArrToFindOut, returnLastIfpassed = false) {
  let firstDate,
    secondDate,
    foundIndexArr = [],
    allPassedIndex = 0;
  datesArr.forEach((dateInParentArr, index) => {
    firstDate = dateInParentArr;
    secondDate = datesArr[index + 1];

    datesArrToFindOut.forEach((dateInToFindArr) => {
      if (isSameDay(new Date(dateInToFindArr), new Date(firstDate))) {
        foundIndexArr.push({
          index: index,
          date: dateInToFindArr,
        });
      } else if (
        secondDate &&
        isAfter(new Date(dateInToFindArr), new Date(firstDate)) &&
        isBefore(new Date(dateInToFindArr), new Date(secondDate))
      ) {
        foundIndexArr.push({
          index: index + 0.5,
          date: dateInToFindArr,
        });
      } else if (isAfter(new Date(dateInToFindArr), new Date(firstDate))) {
        allPassedIndex++;
      }
    });
  });

  if (returnLastIfpassed && allPassedIndex && allPassedIndex === datesArr.length) {
    foundIndexArr.push({
      date: datesArrToFindOut[0],
      index: datesArr.length - 1,
      isPassed: true,
    });
  }
  return foundIndexArr;
}

export const appendPositiveNegativeSign = (value) => {
  return value && !value.toString().includes('-') && !value.toString().includes('N/A') ? `+${value}` : value;
};

export const getFormattedValueAsPerMetricType = ({ value = 0, metricType }) => {
  // only for display purposes
  if (['clicks', 'impressions', 'conversions', 'pages', 'keywords', 'visitors'].includes(metricType)) {
    return `${numberFormatter(Math.round(value))}`;
  } else if (metricType === 'average^_position') {
    return `${numberFormatter(value)}`;
  } else if (['market^_share', 'average^_ctr'].includes(metricType)) {
    return `${numberFormatter(value)}%`;
  }
  return `${value}`;
};

export const extraDomainInfoFromUrl = (url) => {
  let domain = getDomainWithoutSuffix(url);
  let subDomain = getSubdomain(url);

  return {
    subDomain,
    domain,
  };
};

export const extractCompetitorName = (url) => {
  const { subDomain, domain } = extraDomainInfoFromUrl(url);
  if (domain) {
    // ignore www subdomain
    if (subDomain && subDomain != 'www') {
      return `${capitalizeFirstLetter(domain)} - ${capitalizeFirstLetter(subDomain)}`;
    } else {
      return capitalizeFirstLetter(isNumeric(domain) ? ' ' + domain : domain);
    }
  }

  return isNumeric(url) ? ' ' + url : url;
};

export function getKeyByValue(object, value) {
  return Object.keys(object).find((key) => object[key].key === value);
}

export const getCountryName = (alpha, useStrict = false) => {
  const countryData = COUNTRY_CODES.find((country) => country.alpha === alpha);
  if (countryData) {
    return countryData.name;
  } else if (!useStrict) {
    return 'N/A';
  }
};

export const convertValueToTheDropDownFormat = (selectedValues = [], options = [], isCategory = false) => {
  const selectedDropdownValues = [];
  for (const value of selectedValues) {
    if (typeof value === 'object') {
      if (value?.text === value?.value) {
        const textValueFormat = { ...value };
        const fundData = options?.find(
          (op) => op?.value === value?.value || (op?.encodedValue ? op?.encodedValue === value?.value : false)
        );

        if (fundData) {
          textValueFormat.text = fundData?.text;
        }
        selectedDropdownValues.push(textValueFormat);
      } else {
        selectedDropdownValues.push({ ...value, text: value?.text?.replace(/\/\*dash\*\//g, '-') });
      }
    } else {
      const textValueFormat = { text: value, value: value };
      const fundData = options?.find((op) => op?.value === value);
      if (fundData) {
        textValueFormat.text = fundData?.text;
        textValueFormat.value = fundData?.value;
      }
      console.log('test data', isCategory, textValueFormat, fundData);
      selectedDropdownValues.push(isCategory ? textValueFormat?.value : textValueFormat?.text);
    }
  }
  console.log('selectedDropdownValues', selectedDropdownValues);
  return selectedDropdownValues;
};

export const getLogo = (url, size) => {
  const sz = size ? `sz=${size}&` : '';
  return `${GOOGLE_FETCH_FAVICON_API}?${sz}domain=${appendHttpsIfNotPresent(url)}`;
};

/**
 *
 * @param {String} schema
 * @returns JSON containing filters from local storage OR session storage
 */
export const getFiltersFromLocalStorage = (schema) => {
  try {
    const data =
      sessionStorage.getItem(`${schema}-growthtrends-marketshare-filters`) ||
      localStorage.getItem(`${schema}-growthtrends-marketshare-filters`);
    if (data) {
      return JSON.parse(data);
    } else {
      return null;
    }
  } catch (error) {
    console.log('Error | getFiltersFromLocalStorage', error);
  }
};

export const generatePayloadForMetricData = (payload, metricGroup = []) => {
  let newFields = [],
    newFilters = {},
    nextWrapperIndex = metricGroup.length === 3 ? 4 : 5,
    metricWrapperIndex = 0;
  const viewName = payload.view;
  metricGroup.forEach((metric, index) => {
    newFields.push(`${viewName}.measure_${nextWrapperIndex + index}_wrapper`);

    newFilters[`${viewName}.metric_${index + 1}`] = metric;

    metricWrapperIndex++;
    newFilters[`${viewName}.metric_measure_${metricWrapperIndex}`] = `metric${index + 1}^_selectPeriod`;

    metricWrapperIndex++;

    newFilters[`${viewName}.metric_measure_${metricWrapperIndex}`] = `metric${index + 1}^_lastPeriod`;
  });

  return {
    ...payload,
    fields: [...payload.fields, ...newFields],
    filters: {
      ...payload.filters,
      ...newFilters,
    },
  };
};

export const calculatePOPForMetric = (data, grain, metricGroup, propsData) => {
  const metric = metricGroup;
  let obj = {},
    arr = [],
    measureIndex = 1,
    curValue,
    prevValue;

  metric.forEach((metricValue) => {
    arr = [];

    data.forEach((record) => {
      curValue = record[`measure_${measureIndex}_wrapper`];
      prevValue = record[`measure_${measureIndex + 1}_wrapper`];
      let { delta, deltaPercentage } = calculatePop(curValue, prevValue);

      arr.push({
        [grain]: record[grain],
        compared_timeframe: record.compared_timeframe,
        measure_1_wrapper: curValue,
        measure_2_wrapper: prevValue,
        measure_3_wrapper: delta,
        measure_4_wrapper: deltaPercentage,
      });
    });

    measureIndex += 2;

    obj[metricValue] = [...arr];
  });

  return obj;
};

export const calculatePop = (curValue, prevValue) => {
  let delta = null,
    deltaPercentage = null;
  // calculate delta & delta percentage if both period value exists. (Getting null if no data is available for period)
  if (curValue != null && prevValue != null) {
    curValue = curValue ? curValue : 0;
    prevValue = prevValue ? prevValue : 0;
    delta = Number(curValue - prevValue);
    deltaPercentage = prevValue ? Number(delta / prevValue) : null;
  }

  return { delta, deltaPercentage };
};

export function calculateMonthDifference(date) {
  var dateSplit = date.split(' ');
  var result = differenceInMonths(new Date(), new Date(dateSplit[2]));
  var monthDiff = differenceInMonths(new Date(dateSplit[2]), new Date(dateSplit[0]));
  if (monthDiff > 3) {
    result = result + (monthDiff - 3);
  }
  return result;
}

export function dateFormatter(date, month) {
  var dateSplit = date.split(' ');
  const fromDate = new Date(dateSplit[0]);
  const toDate = new Date(dateSplit[0]);
  fromDate.setMonth(fromDate.getMonth(fromDate) - month);
  const dateFormatToDate = format(new Date(toDate), 'yyyy/MM/dd');
  const dateFormatFromDate = format(new Date(fromDate), 'yyyy/MM/dd');
  return `${dateFormatFromDate} to ${dateFormatToDate}`;
}

export const metricBasedValueFormator = (label, value, type = '', valueSuffixFlag = '') => {
  label = label.toLowerCase();
  value = parseFloat(value);
  let formattedVal = value;
  switch (valueSuffixFlag) {
    case 'value':
      if (type === '%-change') {
        formattedVal = value;
      } else {
        //consider metric name included in the label
        if (['%', 'bounce rate', 'conversion rate', 'percentage'].some((item) => label.includes(item))) {
          formattedVal = (value * 100).toFixed(2);
        } else if (['ctr', 'market share', '% pages indexed'].some((item) => label.includes(item))) {
          formattedVal = value;
        } else if (
          ['performance score', 'accessibility score', 'best practices score', 'seo compliance score', 'score'].some(
            (item) => label.includes(item)
          )
        ) {
          formattedVal = (value * 100).toFixed(0);
        } else if (
          ['speed index', 'fcp', 'lcp', 'tti', 'ttfb', 'inp', 'average session duration'].some((item) =>
            label.includes(item)
          )
        ) {
          formattedVal = parseFloat(value).toFixed(2);
        } else if (label.includes('cls')) {
          formattedVal = parseFloat(value).toFixed(3);
        } else {
          formattedVal = value;
        }
      }
      break;
    case 'suffix':
      if (type === '%-change') {
        formattedVal = `%`;
      } else {
        //consider metric name included in the label
        if (
          ['%', 'bounce rate', 'conversion rate', 'ctr', 'market share', '% pages indexed', 'percentage'].some((item) =>
            label.includes(item)
          )
        ) {
          formattedVal = `%`;
        } else if (
          [
            'speed index',
            'fcp',
            'lcp',
            'inp',
            'max potential first input delay (fid)',
            'tti',
            'ttfb',
            'average session duration',
            'first cpu idle',
            '(fmp)',
          ].some((item) => label.includes(item))
        ) {
          formattedVal = `s`;
        } else if (label.toLowerCase().includes('cost')) {
          formattedVal = `$`;
        } else {
          formattedVal = '';
        }
      }
      break;
    default:
      if (type === '%-change') {
        formattedVal = `${numberFormatter(value)}%`;
      } else {
        //consider metric name included in the label
        if (
          ['%', 'bounce rate', 'conversion rate', 'percentage'].some((item) => label.includes(item)) &&
          !label.includes('% pages indexed')
        ) {
          formattedVal = `${numberFormatter(value * 100)}%`;
        } else if (['ctr', 'market share', '% pages indexed'].some((item) => label.includes(item))) {
          formattedVal = `${numberFormatter(value)}%`;
        } else if (
          ['performance score', 'accessibility score', 'best practices score', 'seo compliance score'].some((item) =>
            label.includes(item)
          )
        ) {
          formattedVal = `${numberFormatter((value * 100).toFixed(0))}`;
        } else if (
          [
            'speed index',
            'max potential first input delay (fid)',
            'fcp',
            'lcp',
            'inp',
            'tti',
            'ttfb',
            'average session duration',
            'first cpu idle',
            '(fmp)',
          ].some((item) => label.includes(item))
        ) {
          formattedVal = `${parseFloat(value).toFixed(2)}s`;
        } else if (label.includes('cls')) {
          formattedVal = parseFloat(value).toFixed(3);
        } else if (label.toLowerCase().includes('cost')) {
          formattedVal = value < 0 ? `-$${numberFormatter(value * -1)}` : `$${numberFormatter(value)}`;
        } else {
          formattedVal = numberFormatter(value);
        }
      }
      break;
  }
  return formattedVal;
};

/**
 * @typedef {Object} MetricColorType
 * @property {string} start1
 * @property {string} end1
 * @property {string} start2
 * @property {string} end2
 * @property {string} key
 * @property {string} cssClass
 * @property {string} metric
 */

/**
 *
 * @param {String} metric
 * @param {String} anotherMetric
 * @param {Boolean} avoidLightColor
 * @returns {MetricColorType} Object with colour codes
 */
export const getUniqueColorsForMetric = (metric, anotherMetric, avoidLightColor = false) => {
  // no more used
  let foundRecord = {},
    keyToSearch = metric;

  anotherMetric = anotherMetric instanceof Array ? anotherMetric : [anotherMetric];

  foundRecord = METRIC_COLOR_MAPPING[keyToSearch];

  if (!foundRecord || (foundRecord.isLight && avoidLightColor)) {
    foundRecord = RANDOM_COLOR.find((obj) => obj.metric === metric);

    if (!foundRecord) {
      foundRecord = RANDOM_COLOR.find((obj) => !anotherMetric.includes(obj.metric));

      foundRecord.metric = metric;
    }
  }

  return foundRecord;
};

export const getSolidColorForMetric = (
  isMetric1 = false,
  isPercentageChange = false,
  isSummaryMetricSelected = false,
  index = 0
) => {
  if (isSummaryMetricSelected) {
    return SOLID_BAR_COLORS[index];
  }
  if (isPercentageChange) {
    return {
      start1: '#012749',
      end1: '#012749',
      start2: '#BAE6FF',
      end2: '#BAE6FF',
      cssClass: 'clicks',
      key: '%-change',
    };
  }
  if (isMetric1) {
    return SOLID_BAR_COLORS[0];
  } else {
    return SOLID_BAR_COLORS[1];
  }
};

export const flattenNestedArray = (parent, key) => {
  // Key which is parent to others

  const resultantOptions = [];
  parent.forEach((option) => {
    // supports only 3 level of nesting for now
    resultantOptions.push(option);
    if (has(option, key)) {
      option[key].forEach((op) => {
        resultantOptions.push(op);
        if (has(op, key)) {
          op[key].forEach((o) => {
            resultantOptions.push(o);
          });
        }
      });
    }
  });
  return resultantOptions;
};

/**
 * Returns the available "pages" or "queries" data from Looker
 * @param {"pages" | "queries"} type
 * @param {string} searchText
 * @returns {Promise<*>}
 */
export const getQueriesPagesData = async (type, searchText, schemaName, useSimpleExplores = false) => {
  try {
    const dimension = useSimpleExplores
      ? type === 'pages'
        ? 'content_lookup_v1.distinct_page'
        : 'intent_lookup.distinct_query'
      : type === 'pages'
      ? 'keyword_page_report_and_paid_stats_combined.distinct_page'
      : 'keyword_page_report_and_paid_stats_combined.distinct_keyword';

    const filter = useSimpleExplores
      ? type === 'pages'
        ? 'content_lookup_v1.page'
        : 'intent_lookup.query'
      : type === 'pages'
      ? 'keyword_page_report_and_paid_stats_combined.page'
      : 'keyword_page_report_and_paid_stats_combined.keyword';

    const payload = {
      model: `${process.env.NEXT_PUBLIC_LOOKER_NEW_MODEL_NAME}`,
      view: useSimpleExplores
        ? type === 'pages'
          ? 'content_lookup_v1'
          : 'intent_lookup'
        : type === 'pages'
        ? 'keyword_page_report_and_paid_stats_combined'
        : 'keyword_page_report_and_paid_stats_combined',
      fields: [dimension],
      filters: {
        [filter]: `%${searchText}%`,
      },
      limit: 50,
    };

    // MVP-2566
    // Add a filter for 'domain' for external users
    const subscriberDomain = await getTestDriveDomain();

    // if domain is available, append it to the filters
    if (subscriberDomain) {
      payload.filters['keyword_page_report_and_paid_stats_combined.domain_segment'] = subscriberDomain;
    }

    const res = await ApiService.post('summary_panel', { selected_schema: schemaName, params: payload });
    let options = [];

    if (useSimpleExplores) {
      const key = type === 'pages' ? 'content_lookup_v1.distinct_page' : 'intent_lookup.distinct_query';
      options = res.data
        .map((obj) => ({
          text: obj[key]?.replace(/['"]+/g, ''),
          value: obj[key]?.replace(/['"]+/g, ''),
          type: type,
          filterString: obj[key]?.replace(/['"]+/g, ''),
        }))
        .filter(
          (v, index, self) =>
            index === self.findIndex((t) => t.text === v.text && t.value === v.value) || !validURL(v.value)
        );
    } else {
      const key =
        type === 'pages'
          ? 'keyword_page_report_and_paid_stats_combined.distinct_page'
          : 'keyword_page_report_and_paid_stats_combined.distinct_keyword';
      options = res.data
        .map((obj) => ({
          text: obj[key]?.replace(/['"]+/g, ''),
          value: obj[key]?.replace(/['"]+/g, ''),
          type: type,
          filterString: obj[key]?.replace(/['"]+/g, ''),
        }))
        .filter(
          (v, index, self) =>
            index === self.findIndex((t) => t.text === v.text && t.value === v.value) || !validURL(v.value)
        );
    }

    return options;
  } catch (err) {
    console.error('getQueriesPagesData : err ', err);
  }
};

// export const getQueriesPagesData = async (type, searchText, schemaName) => {
//   try {
//     let dimension, filter;
//     if (type === 'pages') {
//       dimension = 'keyword_page_report_and_paid_stats_combined.distinct_page';
//       filter = 'keyword_page_report_and_paid_stats_combined.page';
//     } else {
//       dimension = 'keyword_page_report_and_paid_stats_combined.distinct_keyword';
//       filter = 'keyword_page_report_and_paid_stats_combined.keyword';
//     }

//     const payload = {
//       model: `${process.env.NEXT_PUBLIC_LOOKER_NEW_MODEL_NAME}`,
//       view:
//         type === 'pages'
//           ? 'keyword_page_report_and_paid_stats_combined'
//           : 'keyword_page_report_and_paid_stats_combined',
//       fields: [dimension],
//       filters: {
//         [filter]: `%${searchText}%`,
//       },
//       limit: 50,
//     };

//     // MVP-2566
//     // Add a filter for 'domain' for external users
//     const subscriberDomain = await getTestDriveDomain();

//     // if domain is available, append it to the filters
//     if (subscriberDomain) {
//       payload.filters['keyword_page_report_and_paid_stats_combined.domain_segment'] = subscriberDomain;
//     }

//     const res = await ApiService.post('summary_panel', { selected_schema: schemaName, params: payload });
//     let options = [];
//     if (type === 'pages') {
//       options = res.data
//         .map((obj) => {
//           return {
//             text: obj['keyword_page_report_and_paid_stats_combined.distinct_page']?.replace(/[[\]']+/g, ''),
//             value: obj['keyword_page_report_and_paid_stats_combined.distinct_page']?.replace(/[[\]']+/g, ''),
//             type: type,
//             filterString: obj['keyword_page_report_and_paid_stats_combined.distinct_page']?.replace(/[[\]']+/g, ''),
//           };
//         })
//         .filter((v, index, self) => index === self.findIndex((t) => t.text === v.text && t.value === v.value));
//     } else {
//       options = res.data
//         .map((obj) => {
//           return {
//             text: obj['keyword_page_report_and_paid_stats_combined.distinct_keyword']?.replace(/['"]+/g, ''),
//             value: obj['keyword_page_report_and_paid_stats_combined.distinct_keyword']?.replace(/['"]+/g, ''),
//             type: type,
//             filterString: obj['keyword_page_report_and_paid_stats_combined.distinct_keyword']?.replace(/['"]+/g, ''),
//           };
//         })
//         .filter((v) => !validURL(v.value));
//     }
//     return options;
//   } catch (err) {
//     console.error('getQueriesPagesData : err ', err);
//   }
// };

export const getTopQueriesORPages = async (type, searchText, applyOppositeFilter = false, schemaName) => {
  try {
    const payload = {
      model: `${process.env.NEXT_PUBLIC_LOOKER_NEW_MODEL_NAME}`,
      view: type === 'topPages' ? 'customer_search_pages' : 'keyword_page_report_and_paid_stats_combined',
      fields: [],
      filters: {},
      sorts: type === 'topPages' ? [`customer_search_pages.clicks_page_rank`] : [],
      limit: 50,
    };

    if (type === 'topPages') {
      payload.fields = [`${payload.view}.page`, `${payload.view}.clicks_page_rank`];
      if (applyOppositeFilter) {
        payload.filters = { [`${payload.view}.keyword`]: `${searchText}` };
      } else {
        payload.filters = { [`${payload.view}.page`]: `%${searchText}%` };
      }
    } else {
      payload.fields = [`${payload.view}.keyword`];
      if (applyOppositeFilter) {
        payload.filters = { [`${payload.view}.page`]: `${searchText}` };
      } else {
        payload.filters = { [`${payload.view}.keyword`]: `%${searchText}%` };
      }
    }

    const subscriberDomain = await getTestDriveDomain();

    // if domain is available, append it to the filters
    if (subscriberDomain) {
      payload.filters[`${payload.view}.domain_segment`] = subscriberDomain;
    }

    const res = await ApiService.post('summary_panel', { selected_schema: schemaName, params: payload });
    let options = [];
    if (type === 'topPages') {
      options = res.data
        .map((obj) => {
          return {
            text: obj[`${payload.view}.page`]?.replace(/[[\]']+/g, ''),
            value: obj[`${payload.view}.page`]?.replace(/[[\]']+/g, ''),
          };
        })
        .filter((v, index, self) => index === self.findIndex((t) => t.text === v.text && t.value === v.value));
    } else {
      options = res.data
        .map((obj) => {
          return {
            text: obj[`${payload.view}.keyword`]?.replace(/['"]+/g, ''),
            value: obj[`${payload.view}.keyword`]?.replace(/['"]+/g, ''),
          };
        })
        .filter((v) => !validURL(v.value));
    }
    if (applyOppositeFilter) {
      return { options, data: res.data };
    } else {
      return options;
    }
  } catch (err) {
    console.error('getTopQueriesORPages : err ', err);
  }
};

export const getFilterSegmentName = (key) => {
  switch (key) {
    case 'category_segment':
      return 'category';
    case 'country_segment':
      return 'country';
    case 'intent_segment':
      return 'intent';
    case 'query_language_segment':
      return 'language';
    case 'device_segment':
      return 'device';
    case 'domain_segment':
      return 'domain';
    case 'source_medium_selected':
      return 'sources';
    case 'keyword_segment':
      return 'queries';
    case 'page_segment':
      return 'pages';
    case 'keyword_serp_features':
      return 'keyword_serp_features';
    case 'search_type_segment':
      return 'distinct_search_type';
    case 'goals_concat':
      return 'goals_concat';
    case 'saved_segment':
      return 'saved_segment';
    case 'keyword_list_segment':
      return 'queries';
    case 'page_list_segment':
      return 'page_list_segment';
    case 'saved_comparison':
      return 'saved_comparison';
    case 'is_branded':
      return 'is_branded';
    case 'page_experience':
      return 'page_experience';
    case 'adgroup_name_segment':
      return 'adgroup_name';
    case 'campaign_name_segment':
      return 'campaign_name';
    case 'campaign_type_segment':
      return 'campaign_type';
    case 'market_share_segment':
      return 'market_share_segment';
    case 'rank_bucket_segment':
      return 'rank_bucket_segment';
    case 'keyword_city_segment':
      return 'keyword_city';
    case 'keyword_state_segment':
      return 'keyword_state';
    case 'keyword_country_segment':
      return 'keyword_country';
    case 'page_city_segment':
      return 'page_city';
    case 'page_state_segment':
      return 'page_state';
    case 'page_country_segment':
      return 'page_country';
  }
};

export const getLatestValueforUsabilityMetric = (
  filters,
  data,
  usabilityScore,
  isSiteDetail,
  isSegmentComparison,
  payload,
  viewToQueryTo
) => {
  let updatedData = [...data];
  let metric1 = filters.metric1Type.toLowerCase();
  let metric2 = filters.metric2Type.toLowerCase();
  let usabilityScoreDateAvailable = [];
  const isGoogleOrganic = isGoogleOrganicSelected(payload.filters, viewToQueryTo);

  if (isSegmentComparison) {
    let isInSelectedPeriod = [];
    if (
      SITE_USABILITY_METRICS.some((item) => metric1.includes(item)) &&
      SITE_USABILITY_METRICS.some((item) => metric2.includes(item))
    ) {
      usabilityScore.forEach((score) => {
        if (
          score.dynamic_timeframe &&
          !isNull(score.measure_1_wrapper) &&
          !isNull(score.measure_2_wrapper) &&
          !isNull(score.measure_3_wrapper) &&
          !isNull(score.measure_4_wrapper) &&
          score.is_in_selected_period === 'Yes'
        ) {
          isInSelectedPeriod.push(new Date(score.dynamic_timeframe));
        }
      });
    } else {
      usabilityScore.forEach((score) => {
        if (
          score.dynamic_timeframe &&
          !isNull(score.measure_1_wrapper) &&
          !isNull(score.measure_3_wrapper) &&
          !isNull(score.measure_5_wrapper) &&
          !isNull(score.measure_7_wrapper) &&
          score.is_in_selected_period === 'Yes'
        ) {
          isInSelectedPeriod.push(new Date(score.dynamic_timeframe));
        }
      });
    }
    let maxUsabilityScoreDateAvailable = isInSelectedPeriod.length ? max(isInSelectedPeriod) : null;
    let maxUsabilityScoreFormattedDateAvailable = maxUsabilityScoreDateAvailable
      ? format(maxUsabilityScoreDateAvailable, 'yyyy-MM-dd')
      : null;
    let maxScoreAvailable = maxUsabilityScoreFormattedDateAvailable
      ? usabilityScore.filter(
          (obj) => format(new Date(obj.dynamic_timeframe), 'yyyy-MM-dd') === maxUsabilityScoreFormattedDateAvailable
        )
      : [];
    data.forEach((compData, index) => {
      maxScoreAvailable.forEach((latestData) => {
        if (compData.is_in_selected_period === null && latestData.is_in_selected_period === 'Yes') {
          updatedData[index] = {
            is_in_selected_period: null,
            measure_1_wrapper: latestData.measure_1_wrapper,
            measure_2_wrapper: latestData.measure_2_wrapper,
            measure_3_wrapper: latestData.measure_3_wrapper,
            measure_4_wrapper: latestData.measure_4_wrapper,
            metric_1_segment_a_pop_change: latestData.metric_1_segment_a_pop_change,
            metric_1_segment_a_pop_percentage_change: latestData.metric_1_segment_a_pop_percentage_change,
            metric_1_segment_b_pop_change: latestData.metric_1_segment_b_pop_change,
            metric_1_segment_b_pop_percentage_change: latestData.metric_1_segment_b_pop_percentage_change,
            metric_1_segments_diff_in_change: latestData.metric_1_segments_diff_in_change,
            metric_1_segments_diff_in_percentage_change: latestData.metric_1_segments_diff_in_percentage_change,
            metric_2_segment_a_pop_change: latestData.metric_2_segment_a_pop_change,
            metric_2_segment_a_pop_percentage_change: latestData.metric_2_segment_a_pop_percentage_change,
            metric_2_segment_b_pop_change: latestData.metric_2_segment_b_pop_change,
            metric_2_segment_b_pop_percentage_change: latestData.metric_2_segment_b_pop_percentage_change,
            metric_2_segments_diff_in_change: latestData.metric_2_segments_diff_in_change,
            metric_2_segments_diff_in_percentage_change: latestData.metric_2_segments_diff_in_percentage_change,
          };
        }
        if (compData.is_in_selected_period === 'Yes' && latestData.is_in_selected_period === 'Yes') {
          if (
            SITE_USABILITY_METRICS.some((item) => metric2.includes(item)) &&
            !SITE_USABILITY_METRICS.some((item) => metric1.includes(item))
          ) {
            updatedData[index] = {
              is_in_selected_period: 'Yes',
              measure_1_wrapper: compData.measure_1_wrapper,
              measure_2_wrapper: compData.measure_2_wrapper,
              measure_3_wrapper: latestData.measure_3_wrapper,
              measure_4_wrapper: latestData.measure_4_wrapper,
              metric_1_segment_a_pop_change: compData.metric_1_segment_a_pop_change,
              metric_1_segment_a_pop_percentage_change: compData.metric_1_segment_a_pop_percentage_change,
              metric_1_segment_b_pop_change: compData.metric_1_segment_b_pop_change,
              metric_1_segment_b_pop_percentage_change: compData.metric_1_segment_b_pop_percentage_change,
              metric_1_segments_diff_in_change: compData.metric_1_segments_diff_in_change,
              metric_1_segments_diff_in_percentage_change: compData.metric_1_segments_diff_in_percentage_change,
              metric_2_segment_a_pop_change: latestData.metric_2_segment_a_pop_change,
              metric_2_segment_a_pop_percentage_change: latestData.metric_2_segment_a_pop_percentage_change,
              metric_2_segment_b_pop_change: latestData.metric_2_segment_b_pop_change,
              metric_2_segment_b_pop_percentage_change: latestData.metric_2_segment_b_pop_percentage_change,
              metric_2_segments_diff_in_change: latestData.metric_2_segments_diff_in_change,
              metric_2_segments_diff_in_percentage_change: latestData.metric_2_segments_diff_in_percentage_change,
            };
          } else if (
            SITE_USABILITY_METRICS.some((item) => metric1.includes(item)) &&
            !SITE_USABILITY_METRICS.some((item) => metric2.includes(item))
          ) {
            updatedData[index] = {
              is_in_selected_period: 'Yes',
              measure_1_wrapper: latestData.measure_1_wrapper,
              measure_2_wrapper: latestData.measure_2_wrapper,
              measure_3_wrapper: compData.measure_3_wrapper,
              measure_4_wrapper: compData.measure_4_wrapper,
              metric_1_segment_a_pop_change: latestData.metric_1_segment_a_pop_change,
              metric_1_segment_a_pop_percentage_change: latestData.metric_1_segment_a_pop_percentage_change,
              metric_1_segment_b_pop_change: latestData.metric_1_segment_b_pop_change,
              metric_1_segment_b_pop_percentage_change: latestData.metric_1_segment_b_pop_percentage_change,
              metric_1_segments_diff_in_change: latestData.metric_1_segments_diff_in_change,
              metric_1_segments_diff_in_percentage_change: latestData.metric_1_segments_diff_in_percentage_change,

              metric_2_segment_a_pop_change: compData.metric_2_segment_a_pop_change,
              metric_2_segment_a_pop_percentage_change: compData.metric_2_segment_a_pop_percentage_change,
              metric_2_segment_b_pop_change: compData.metric_2_segment_b_pop_change,
              metric_2_segment_b_pop_percentage_change: compData.metric_2_segment_b_pop_percentage_change,
              metric_2_segments_diff_in_change: compData.metric_2_segments_diff_in_change,
              metric_2_segments_diff_in_percentage_change: compData.metric_2_segments_diff_in_percentage_change,
            };
          } else {
            updatedData[index] = {
              is_in_selected_period: 'Yes',
              measure_1_wrapper: latestData.measure_1_wrapper,
              measure_2_wrapper: latestData.measure_2_wrapper,
              measure_3_wrapper: latestData.measure_3_wrapper,
              measure_4_wrapper: latestData.measure_4_wrapper,
              metric_1_segment_a_pop_change: latestData.metric_1_segment_a_pop_change,
              metric_1_segment_a_pop_percentage_change: latestData.metric_1_segment_a_pop_percentage_change,
              metric_1_segment_b_pop_change: latestData.metric_1_segment_b_pop_change,
              metric_1_segment_b_pop_percentage_change: latestData.metric_1_segment_b_pop_percentage_change,
              metric_1_segments_diff_in_change: latestData.metric_1_segments_diff_in_change,
              metric_1_segments_diff_in_percentage_change: latestData.metric_1_segments_diff_in_percentage_change,
              metric_2_segment_a_pop_change: latestData.metric_2_segment_a_pop_change,
              metric_2_segment_a_pop_percentage_change: latestData.metric_2_segment_a_pop_percentage_change,
              metric_2_segment_b_pop_change: latestData.metric_2_segment_b_pop_change,
              metric_2_segment_b_pop_percentage_change: latestData.metric_2_segment_b_pop_percentage_change,
              metric_2_segments_diff_in_change: latestData.metric_2_segments_diff_in_change,
              metric_2_segments_diff_in_percentage_change: latestData.metric_2_segments_diff_in_percentage_change,
            };
          }
        }

        if (compData.is_in_selected_period === 'No' && latestData.is_in_selected_period === 'No') {
          if (
            SITE_USABILITY_METRICS.some((item) => metric2.includes(item)) &&
            !SITE_USABILITY_METRICS.some((item) => metric1.includes(item))
          ) {
            updatedData[index] = {
              is_in_selected_period: 'No',
              measure_1_wrapper: latestData.measure_3_wrapper,
              measure_2_wrapper: latestData.measure_4_wrapper,
              measure_3_wrapper: latestData.measure_1_wrapper,
              measure_4_wrapper: latestData.measure_2_wrapper,
              metric_1_segment_a_pop_change: latestData.metric_1_segment_a_pop_change,
              metric_1_segment_a_pop_percentage_change: latestData.metric_1_segment_a_pop_percentage_change,
              metric_1_segment_b_pop_change: latestData.metric_1_segment_b_pop_change,
              metric_1_segment_b_pop_percentage_change: latestData.metric_1_segment_b_pop_percentage_change,
              metric_1_segments_diff_in_change: latestData.metric_1_segments_diff_in_change,
              metric_1_segments_diff_in_percentage_change: latestData.metric_1_segments_diff_in_percentage_change,
              metric_2_segment_a_pop_change: latestData.metric_2_segment_a_pop_change,
              metric_2_segment_a_pop_percentage_change: latestData.metric_2_segment_a_pop_percentage_change,
              metric_2_segment_b_pop_change: latestData.metric_2_segment_b_pop_change,
              metric_2_segment_b_pop_percentage_change: latestData.metric_2_segment_b_pop_percentage_change,
              metric_2_segments_diff_in_change: latestData.metric_2_segments_diff_in_change,
              metric_2_segments_diff_in_percentage_change: latestData.metric_2_segments_diff_in_percentage_change,
            };
          } else {
            updatedData[index] = {
              is_in_selected_period: 'No',
              measure_1_wrapper: latestData.measure_1_wrapper,
              measure_2_wrapper: latestData.measure_2_wrapper,
              measure_3_wrapper: latestData.measure_3_wrapper,
              measure_4_wrapper: latestData.measure_4_wrapper,
              metric_1_segment_a_pop_change: latestData.metric_1_segment_a_pop_change,
              metric_1_segment_a_pop_percentage_change: latestData.metric_1_segment_a_pop_percentage_change,
              metric_1_segment_b_pop_change: latestData.metric_1_segment_b_pop_change,
              metric_1_segment_b_pop_percentage_change: latestData.metric_1_segment_b_pop_percentage_change,
              metric_1_segments_diff_in_change: latestData.metric_1_segments_diff_in_change,
              metric_1_segments_diff_in_percentage_change: latestData.metric_1_segments_diff_in_percentage_change,
              metric_2_segment_a_pop_change: latestData.metric_2_segment_a_pop_change,
              metric_2_segment_a_pop_percentage_change: latestData.metric_2_segment_a_pop_percentage_change,
              metric_2_segment_b_pop_change: latestData.metric_2_segment_b_pop_change,
              metric_2_segment_b_pop_percentage_change: latestData.metric_2_segment_b_pop_percentage_change,
              metric_2_segments_diff_in_change: latestData.metric_2_segments_diff_in_change,
              metric_2_segments_diff_in_percentage_change: latestData.metric_2_segments_diff_in_percentage_change,
            };
          }

          updatedData[index] = {
            is_in_selected_period: 'No',
            measure_1_wrapper: latestData.measure_1_wrapper,
            measure_2_wrapper: latestData.measure_2_wrapper,
            measure_3_wrapper: latestData.measure_3_wrapper,
            measure_4_wrapper: latestData.measure_4_wrapper,
            metric_1_segment_a_pop_change: latestData.metric_1_segment_a_pop_change,
            metric_1_segment_a_pop_percentage_change: latestData.metric_1_segment_a_pop_percentage_change,
            metric_1_segment_b_pop_change: latestData.metric_1_segment_b_pop_change,
            metric_1_segment_b_pop_percentage_change: latestData.metric_1_segment_b_pop_percentage_change,
            metric_1_segments_diff_in_change: latestData.metric_1_segments_diff_in_change,
            metric_1_segments_diff_in_percentage_change: latestData.metric_1_segments_diff_in_percentage_change,
            metric_2_segment_a_pop_change: latestData.metric_2_segment_a_pop_change,
            metric_2_segment_a_pop_percentage_change: latestData.metric_2_segment_a_pop_percentage_change,
            metric_2_segment_b_pop_change: latestData.metric_2_segment_b_pop_change,
            metric_2_segment_b_pop_percentage_change: latestData.metric_2_segment_b_pop_percentage_change,
            metric_2_segments_diff_in_change: latestData.metric_2_segments_diff_in_change,
            metric_2_segments_diff_in_percentage_change: latestData.metric_2_segments_diff_in_percentage_change,
          };
        }
      });
    });
  } else {
    usabilityScore.forEach((score) => {
      if (
        score.dynamic_timeframe &&
        !isNull(score.measure_1_wrapper) &&
        !isNull(score.measure_3_wrapper) &&
        !isNull(score.measure_5_wrapper) &&
        !isNull(score.measure_7_wrapper)
      ) {
        usabilityScoreDateAvailable.push(new Date(score.dynamic_timeframe));
      }
    });
    let maxUsabilityScoreDateAvailable = usabilityScoreDateAvailable.length ? max(usabilityScoreDateAvailable) : null;
    let maxUsabilityScoreFormattedDateAvailable = maxUsabilityScoreDateAvailable
      ? format(maxUsabilityScoreDateAvailable, 'yyyy-MM-dd')
      : null;
    let maxScoreAvailable = maxUsabilityScoreFormattedDateAvailable
      ? usabilityScore.filter(
          (obj) => format(new Date(obj.dynamic_timeframe), 'yyyy-MM-dd') === maxUsabilityScoreFormattedDateAvailable
        )
      : [];
    if (maxScoreAvailable.length) {
      maxScoreAvailable[0] = {
        ...maxScoreAvailable[0],
        measure_1_wrapper: maxScoreAvailable[0].measure_1_wrapper
          ? parseFloat(maxScoreAvailable[0].measure_1_wrapper).toFixed(2)
          : 'N/A',
        measure_2_wrapper: maxScoreAvailable[0].measure_2_wrapper
          ? parseFloat(maxScoreAvailable[0].measure_2_wrapper).toFixed(2)
          : 'N/A',
        measure_3_wrapper: maxScoreAvailable[0].measure_3_wrapper
          ? parseFloat(maxScoreAvailable[0].measure_3_wrapper).toFixed(2)
          : 'N/A',
        measure_4_wrapper: maxScoreAvailable[0].measure_4_wrapper
          ? parseFloat(maxScoreAvailable[0].measure_4_wrapper).toFixed(2)
          : 'N/A',
        measure_5_wrapper: maxScoreAvailable[0].measure_5_wrapper
          ? parseFloat(maxScoreAvailable[0].measure_5_wrapper).toFixed(2)
          : 'N/A',
        measure_6_wrapper: maxScoreAvailable[0].measure_6_wrapper
          ? parseFloat(maxScoreAvailable[0].measure_6_wrapper).toFixed(2)
          : 'N/A',
        measure_7_wrapper: maxScoreAvailable[0].measure_7_wrapper
          ? parseFloat(maxScoreAvailable[0].measure_7_wrapper).toFixed(2)
          : 'N/A',
        measure_8_wrapper: maxScoreAvailable[0].measure_8_wrapper
          ? parseFloat(maxScoreAvailable[0].measure_8_wrapper).toFixed(2)
          : 'N/A',
      };
    }

    if (SITE_USABILITY_SUMMARY_METRIC.toLowerCase() === metric1 && maxScoreAvailable.length) {
      if (isSiteDetail) {
        updatedData[updatedData.length - 1] = {
          ...updatedData[updatedData.length - 1],
          measure_1_wrapper: maxScoreAvailable[0].measure_1_wrapper,
          measure_3_wrapper: maxScoreAvailable[0].measure_5_wrapper,
          measure_4_wrapper: maxScoreAvailable[0].measure_7_wrapper,
        };
      } else {
        updatedData[updatedData.length - 1] = {
          ...updatedData[updatedData.length - 1],
          measure_1_wrapper: maxScoreAvailable[0].measure_1_wrapper,
          measure_2_wrapper: maxScoreAvailable[0].measure_5_wrapper,
          measure_3_wrapper: maxScoreAvailable[0].measure_3_wrapper,
        };
      }

      if (SITE_USABILITY_METRICS.includes(metric2)) {
        if (metric2 === 'performance score') {
          if (maxScoreAvailable.length) {
            updatedData[updatedData.length - 1] = {
              ...updatedData[updatedData.length - 1],
              measure_4_wrapper: isGoogleOrganic ? maxScoreAvailable[0].measure_1_wrapper : null,
            };
          }
        } else if (metric2 === 'accessibility score') {
          if (maxScoreAvailable.length) {
            updatedData[updatedData.length - 1] = {
              ...updatedData[updatedData.length - 1],
              measure_4_wrapper: isGoogleOrganic ? maxScoreAvailable[0].measure_3_wrapper : null,
            };
          }
        } else if (metric2 === 'best practices score') {
          if (maxScoreAvailable.length) {
            updatedData[updatedData.length - 1] = {
              ...updatedData[updatedData.length - 1],
              measure_4_wrapper: isGoogleOrganic ? maxScoreAvailable[0].measure_5_wrapper : null,
            };
          }
        } else {
          if (maxScoreAvailable.length) {
            updatedData[updatedData.length - 1] = {
              ...updatedData[updatedData.length - 1],
              measure_4_wrapper: isGoogleOrganic ? maxScoreAvailable[0].measure_7_wrapper : null,
            };
          }
        }
      }
    } else {
      if (SITE_USABILITY_METRICS.some((item) => metric1.includes(item))) {
        // Both
        if (metric1 === 'performance score') {
          if (maxScoreAvailable.length) {
            const { delta, deltaPercentage } = calculatePop(
              maxScoreAvailable[0].measure_1_wrapper,
              maxScoreAvailable[0].measure_2_wrapper
            );

            updatedData[updatedData.length - 1] = {
              ...updatedData[updatedData.length - 1],
              measure_1_wrapper: maxScoreAvailable[0].measure_1_wrapper,
              measure_3_wrapper: deltaPercentage,
            };
          }
        } else if (metric1 === 'accessibility score') {
          if (maxScoreAvailable.length) {
            const { delta, deltaPercentage } = calculatePop(
              maxScoreAvailable[0].measure_3_wrapper,
              maxScoreAvailable[0].measure_4_wrapper
            );
            updatedData[updatedData.length - 1] = {
              ...updatedData[updatedData.length - 1],
              measure_1_wrapper: maxScoreAvailable[0].measure_3_wrapper,
              measure_3_wrapper: deltaPercentage,
            };
          }
        } else if (metric1 === 'best practices score') {
          if (maxScoreAvailable.length) {
            const { delta, deltaPercentage } = calculatePop(
              maxScoreAvailable[0].measure_5_wrapper,
              maxScoreAvailable[0].measure_6_wrapper
            );

            updatedData[updatedData.length - 1] = {
              ...updatedData[updatedData.length - 1],
              measure_1_wrapper: maxScoreAvailable[0].measure_5_wrapper,
              measure_3_wrapper: deltaPercentage,
            };
          }
        } else {
          if (maxScoreAvailable.length) {
            const { delta, deltaPercentage } = calculatePop(
              maxScoreAvailable[0].measure_7_wrapper,
              maxScoreAvailable[0].measure_8_wrapper
            );

            updatedData[updatedData.length - 1] = {
              ...updatedData[updatedData.length - 1],
              measure_1_wrapper: maxScoreAvailable[0].measure_7_wrapper,
              measure_3_wrapper: deltaPercentage,
            };
          }
        }
      }

      if (SITE_USABILITY_METRICS.some((item) => metric1.includes(item)) && metric2 === 'none') {
        // Only one
        if (metric1 === 'performance score') {
          if (maxScoreAvailable.length) {
            const { delta, deltaPercentage } = calculatePop(
              maxScoreAvailable[0].measure_1_wrapper,
              maxScoreAvailable[0].measure_2_wrapper
            );

            updatedData[updatedData.length - 1] = {
              ...updatedData[updatedData.length - 1],
              measure_1_wrapper: maxScoreAvailable[0].measure_1_wrapper,
              measure_2_wrapper: maxScoreAvailable[0].measure_2_wrapper,
              measure_3_wrapper: delta,
              measure_4_wrapper: deltaPercentage,
            };
          }
        } else if (metric1 === 'accessibility score') {
          if (maxScoreAvailable.length) {
            const { delta, deltaPercentage } = calculatePop(
              maxScoreAvailable[0].measure_3_wrapper,
              maxScoreAvailable[0].measure_4_wrapper
            );

            updatedData[updatedData.length - 1] = {
              ...updatedData[updatedData.length - 1],
              measure_1_wrapper: maxScoreAvailable[0].measure_3_wrapper,
              measure_2_wrapper: maxScoreAvailable[0].measure_4_wrapper,
              measure_3_wrapper: delta,
              measure_4_wrapper: deltaPercentage,
            };
          }
        } else if (metric1 === 'best practices score') {
          if (maxScoreAvailable.length) {
            const { delta, deltaPercentage } = calculatePop(
              maxScoreAvailable[0].measure_5_wrapper,
              maxScoreAvailable[0].measure_6_wrapper
            );

            updatedData[updatedData.length - 1] = {
              ...updatedData[updatedData.length - 1],
              measure_1_wrapper: maxScoreAvailable[0].measure_5_wrapper,
              measure_2_wrapper: maxScoreAvailable[0].measure_6_wrapper,
              measure_3_wrapper: delta,
              measure_4_wrapper: deltaPercentage,
            };
          }
        } else {
          if (maxScoreAvailable.length) {
            const { delta, deltaPercentage } = calculatePop(
              maxScoreAvailable[0].measure_7_wrapper,
              maxScoreAvailable[0].measure_8_wrapper
            );

            updatedData[updatedData.length - 1] = {
              ...updatedData[updatedData.length - 1],
              measure_1_wrapper: maxScoreAvailable[0].measure_7_wrapper,
              measure_2_wrapper: maxScoreAvailable[0].measure_8_wrapper,
              measure_3_wrapper: delta,
              measure_4_wrapper: deltaPercentage,
            };
          }
        }
      }

      if (SITE_USABILITY_METRICS.some((item) => metric2.includes(item))) {
        if (SITE_REPORT_SUMMARY.includes(metric1)) {
          // Second Metric
          if (metric2 === 'performance score') {
            if (maxScoreAvailable.length) {
              updatedData[updatedData.length - 1] = {
                ...updatedData[updatedData.length - 1],
                measure_4_wrapper: isGoogleOrganic ? maxScoreAvailable[0].measure_1_wrapper : null,
              };
            }
          } else if (metric2 === 'accessibility score') {
            if (maxScoreAvailable.length) {
              updatedData[updatedData.length - 1] = {
                ...updatedData[updatedData.length - 1],
                measure_4_wrapper: isGoogleOrganic ? maxScoreAvailable[0].measure_3_wrapper : null,
              };
            }
          } else if (metric2 === 'best practices score') {
            if (maxScoreAvailable.length) {
              updatedData[updatedData.length - 1] = {
                ...updatedData[updatedData.length - 1],
                measure_4_wrapper: isGoogleOrganic ? maxScoreAvailable[0].measure_5_wrapper : null,
              };
            }
          } else {
            if (maxScoreAvailable.length) {
              updatedData[updatedData.length - 1] = {
                ...updatedData[updatedData.length - 1],
                measure_4_wrapper: isGoogleOrganic ? maxScoreAvailable[0].measure_7_wrapper : null,
              };
            }
          }
        } else {
          // Second Metric
          if (metric2 === 'performance score') {
            if (maxScoreAvailable.length) {
              const { delta, deltaPercentage } = calculatePop(
                maxScoreAvailable[0].measure_1_wrapper,
                maxScoreAvailable[0].measure_2_wrapper
              );

              updatedData[updatedData.length - 1] = {
                ...updatedData[updatedData.length - 1],
                measure_2_wrapper: maxScoreAvailable[0].measure_1_wrapper,
                measure_4_wrapper: deltaPercentage,
              };
            }
          } else if (metric2 === 'accessibility score') {
            if (maxScoreAvailable.length) {
              const { delta, deltaPercentage } = calculatePop(
                maxScoreAvailable[0].measure_3_wrapper,
                maxScoreAvailable[0].measure_4_wrapper
              );

              updatedData[updatedData.length - 1] = {
                ...updatedData[updatedData.length - 1],
                measure_2_wrapper: maxScoreAvailable[0].measure_3_wrapper,
                measure_4_wrapper: deltaPercentage,
              };
            }
          } else if (metric2 === 'best practices score') {
            if (maxScoreAvailable.length) {
              const { delta, deltaPercentage } = calculatePop(
                maxScoreAvailable[0].measure_5_wrapper,
                maxScoreAvailable[0].measure_6_wrapper
              );

              updatedData[updatedData.length - 1] = {
                ...updatedData[updatedData.length - 1],
                measure_2_wrapper: maxScoreAvailable[0].measure_5_wrapper,
                measure_4_wrapper: deltaPercentage,
              };
            }
          } else {
            if (maxScoreAvailable.length) {
              const { delta, deltaPercentage } = calculatePop(
                maxScoreAvailable[0].measure_7_wrapper,
                maxScoreAvailable[0].measure_8_wrapper
              );

              updatedData[updatedData.length - 1] = {
                ...updatedData[updatedData.length - 1],
                measure_2_wrapper: maxScoreAvailable[0].measure_7_wrapper,
                measure_4_wrapper: deltaPercentage,
              };
            }
          }
        }
      }
    }
  }

  return updatedData;
};

export function isInverseMetricSelected(metric = '') {
  const inverseMetricKeys = [
    'POSITION',
    'AVERAGE RANK',
    'CUMULATIVE LAYOUT SHIFT (CLS)',
    'LARGEST CONTENTFUL PAINT (LCP)',
    'TIME TO INTERACTIVE (TTI)',
    'Interaction to Next Paint (INP)',
  ];
  return Boolean(inverseMetricKeys.includes(metric.toUpperCase()));
}

export const isGoogleOrganicSelected = (filters, viewToQueryTo) => {
  let sourceMediumA = [];
  let sourceMediumB = [];
  let updatedFilters = removeViewNameFromChartsData([{ ...filters }]);
  updatedFilters = updatedFilters[0];
  if (updatedFilters && updatedFilters[`source_medium_segmentA`]) {
    sourceMediumA = updatedFilters[`source_medium_segmentA`].split(',');
  }
  if (updatedFilters && updatedFilters[`source_medium_segmentB`]) {
    sourceMediumB = updatedFilters[`source_medium_segmentB`].split(',');
  }
  if (sourceMediumA.includes('google/organic') || sourceMediumB.includes('google/organic')) {
    return true;
  }
  return false;
};

export const getResolvedReason = (reason) => {
  const resolvedOption = RESOLVE_RECOMMENDATION_OPTIONS.filter((o) => o?.value === reason);
  if (resolvedOption.length) {
    return `${resolvedOption[0].text}`;
  }
};

export const getPageStatusValue = (reason) => {
  const resolvedOption = CR_CHANGE_STATUS.filter((o) => o?.value === reason);
  if (resolvedOption.length) {
    return `${resolvedOption[0].text}`;
  }
};

export const processAnnotationsData = (data, entityType, annotationType, date_granularity) => {
  // TODO - Refactor this method, this is called only once
  // with params entityType:'growth-trends' & annotationType:'note'
  const noteData = [];
  const eventsData = [];
  const eventDrillDownTabData = [];
  data.forEach((i) => {
    if (date_granularity === 'week') {
      i['old_date'] = i.date;
      const newDate = startOfWeek(new Date(i.date));
      i.date = format(new Date(newDate), 'yyyy-MM-dd') + 'T00:00:00.000Z';
    } else if (date_granularity === 'month') {
      i['old_date'] = i.date;
      const newDate = startOfMonth(new Date(i.date));
      i.date = format(new Date(newDate), 'yyyy-MM-dd') + 'T00:00:00.000Z';
    } else if (date_granularity === 'quarter') {
      i['old_date'] = i.date;
      const newDate = startOfQuarter(new Date(i.date));
      i.date = format(new Date(newDate), 'yyyy-MM-dd') + 'T00:00:00.000Z';
    }
    if (i.entity_type === entityType && i.annotation_type === annotationType) {
      noteData.push(i);
    } else {
      eventsData.push(i);
    }
  });
  noteData.forEach((i) => {
    eventDrillDownTabData.push({
      name: capitalizeFirstLetter(i.entity_type) + ' - ' + capitalizeFirstLetter(i.annotation_type),
      col1: capitalizeFirstLetter(i.annotation_subtype || ''),
      col2: i.annotation_desc,
      col3: i.old_date ? format(new Date(i.old_date), 'yyyy-MM-dd') : format(new Date(i.date), 'MM-dd-yyyy'),
      col4: { entity_type: i.entity_type, id: i.id, annotation_type: i.annotation_type },
    });
  });
  eventsData.forEach((i) => {
    const isCnpPage = i?.entity_type?.trim().toLowerCase() === 'new-page' || false;
    eventDrillDownTabData.push({
      name: capitalizeFirstLetter(i.entity_type) + ' - ' + capitalizeFirstLetter(i.annotation_type),
      col1: capitalizeFirstLetter(TrendsHelper.getEventSubtypeDisplayText(i.annotation_subtype || '', isCnpPage)),
      col2: i.annotation_desc,
      col3: i.old_date ? format(new Date(i.old_date), 'yyyy-MM-dd') : format(new Date(i.date), 'MM-dd-yyyy'),
      col4: {
        entity_type: i.entity_type,
        id: i.id,
        entity_id: i.entity_id,
        annotation_type: i.annotation_type,
        isCnpPage,
      },
    });
  });

  return { noteData, eventsData, eventDrillDownTabData };
};

export const getUniqueIssuesForMobileLHCategory = (issuesData) => {
  let issuesList = [];
  issuesData.forEach((issueList) => {
    issueList.forEach((issue) => {
      issuesList.push(issue);
    });
  });
  return uniq(issuesList);
};

export const removeNARowsFromTableData = (tableData) => {
  let updatedReturnedData = [];
  tableData.forEach((data, index) => {
    if (!(data.col1 === null && data.col2 === null && data.col3 === null && data.col4 === null)) {
      updatedReturnedData.push(data);
    }
  });
  return updatedReturnedData;
};

export const formatRecommendationType = (type) => {
  let splittedType = type ? type.split('_') : null;
  let recommendationType = splittedType ? splittedType[0] : null;
  return capitalize(recommendationType);
  // return type ? type.replace("_", " ").toUpperCase() : null;
};

export const formatAlignmentValue = (value) => {
  return parseInt(value) > 1 ? parseInt(value) : parseInt(value) > 0 && parseInt(value) <= 1 ? 1 : null;
};

export const getBarValue = (value) => {
  let updatedValue = parseInt(value);
  if (updatedValue >= 40 && updatedValue < 60) {
    return { barCount: 2, colorClass: 'low' };
  } else if (updatedValue >= 60 && updatedValue < 90) {
    return { barCount: 3, colorClass: 'medium' };
  } else if (updatedValue >= 90) {
    return { barCount: 4, colorClass: 'high' };
  } else {
    return { barCount: 1, colorClass: 'low' };
  }
};

export const getRecommendationStatus = (resolution) => {
  const resolutionOption = RECOMMENDATION_STATUS_OPTIONS.filter((o) => o.value === resolution);
  if (resolutionOption.length) {
    return `${resolutionOption[0].text}`;
  } else {
    return 'New';
  }
};

export const createAnExcelSheet = (name) => {
  const ExcelJSWorkbook = new ExcelJS.Workbook();
  const worksheet = ExcelJSWorkbook.addWorksheet(name);

  return {
    ExcelJSWorkbook,
    worksheet,
  };
};

export const downloadAnExcelSheet = (ExcelJSWorkbook, fileName) => {
  ExcelJSWorkbook.xlsx.writeBuffer().then(function (buffer) {
    saveAs(new Blob([buffer], { type: 'application/octet-stream' }), `${fileName}.xlsx`);
  });
};

export const downloadAnCsv = (ExcelJSWorkbook, fileName) => {
  ExcelJSWorkbook.csv.writeBuffer().then(function (buffer) {
    saveAs(new Blob([buffer], { type: 'text/csv;charset=utf-8;' }), `${fileName}.csv`);
  });
};

const showPublishedHistoryDetails = ({
  worksheet,
  recommendationId,
  url,
  published_history_by,
  published_history_at,
}) => {
  const { published_changes, top_header } = CONTENT_RECOMMENDATIONS_EXCEL_EXPORT_META;
  const { formatting } = top_header;
  worksheet.mergeCells(published_changes.start_cell, published_changes.end_cell);

  const topHeaderCell = worksheet.getCell(published_changes.start_cell);

  topHeaderCell.value = published_changes.header.title;
  topHeaderCell.font = formatting.font;
  topHeaderCell.fill = formatting.fill;
  topHeaderCell.border = BORDER_PROPERTIES;
  topHeaderCell.alignment = formatting.alignment;

  let val, cell, col;
  [1, 2, 3, 4].forEach((index) => {
    col = published_changes.header.columns[index - 1];
    cell = worksheet.getCell(col.start_cell);
    if (index === 1) {
      val = recommendationId;
    } else if (index === 2) {
      worksheet.mergeCells(col.start_cell, col.end_cell);
      worksheet.mergeCells(col.data_start_cell, col.data_end_cell);
      val = url;
    } else if (index === 3) {
      val = published_history_by;
    } else {
      val = published_history_at;
    }
    cell.value = col.name;

    cell.border = BORDER_PROPERTIES;
    cell.font = SUB_HEADER_PROPERTIES.font;
    cell.fill = SUB_HEADER_PROPERTIES.fill;
    cell.alignment = SUB_HEADER_PROPERTIES.alignment;

    cell = worksheet.getCell(col.data_start_cell);
    cell.value = val;

    cell.border = BORDER_PROPERTIES;
    cell.font = DATA_ROW_PROPERTIES.font;
    cell.alignment = DATA_ROW_PROPERTIES.alignment;
    cell.fill = DATA_ROW_PROPERTIES.fill;
  });

  worksheet.getRow(published_changes.row).height = 130;
};
const buildImplementationNote = ({ worksheet, implementationNote, added_by, added_on }) => {
  const { implementation_note, top_header } = CONTENT_RECOMMENDATIONS_EXCEL_EXPORT_META;
  const { formatting } = top_header;
  worksheet.mergeCells(implementation_note.start_cell, implementation_note.end_cell);

  const topHeaderCell = worksheet.getCell(implementation_note.start_cell);

  topHeaderCell.value = implementation_note.header.title;
  topHeaderCell.font = formatting.font;
  topHeaderCell.fill = formatting.fill;
  topHeaderCell.border = BORDER_PROPERTIES;
  topHeaderCell.alignment = formatting.alignment;

  let val, cell, col;
  [1, 2, 3, 4].forEach((index) => {
    col = implementation_note.header.columns[index - 1];
    cell = worksheet.getCell(col.start_cell);
    if (index === 1) {
      val = '-';
    } else if (index === 2) {
      worksheet.mergeCells(col.start_cell, col.end_cell);
      worksheet.mergeCells(col.data_start_cell, col.data_end_cell);
      val = implementationNote;
    } else if (index === 3) {
      val = added_by;
    } else {
      val = added_on;
    }
    cell.value = col.name;

    cell.border = BORDER_PROPERTIES;
    cell.font = SUB_HEADER_PROPERTIES.font;
    cell.fill = SUB_HEADER_PROPERTIES.fill;
    cell.alignment = SUB_HEADER_PROPERTIES.alignment;

    cell = worksheet.getCell(col.data_start_cell);
    cell.value = val;

    cell.border = BORDER_PROPERTIES;
    cell.font = DATA_ROW_PROPERTIES.font;
    cell.alignment = DATA_ROW_PROPERTIES.alignment;
    cell.fill = DATA_ROW_PROPERTIES.fill;
  });

  worksheet.getRow(implementation_note.row).height = 130;
};

const formatTopHeader = ({ worksheet, recommendationId }) => {
  const { top_header } = CONTENT_RECOMMENDATIONS_EXCEL_EXPORT_META;
  const { id, summary_title, formatting } = top_header;

  worksheet.mergeCells(id.cell, id.endCell);
  worksheet.getCell(id.cell).value = recommendationId;

  worksheet.mergeCells(summary_title.start_cell, summary_title.end_cell);

  worksheet.getCell(summary_title.start_cell).value = summary_title.text;

  // worksheet.getCell(summary_logo.cell).value = summary_logo.text;

  const row = worksheet.getRow(top_header.row);

  row.eachCell((cell) => {
    cell.border = BORDER_PROPERTIES;
    cell.font = formatting.font;
    cell.fill = formatting.fill;
    cell.alignment = formatting.alignment;
  });
};

const formatSummaryTable = ({
  worksheet,
  insight,
  current_alignment_score,
  projected_alignment_score,
  total_clicks,
  total_impressions,
  status,
  avg_current_relavance_score,
  avg_projected_relavance_score,
  currentCQScore,
  projectedCQScore,
}) => {
  const summaryTableHeaderColumns = [],
    summaryTableHeaderValues = [];
  const { summary_table } = CONTENT_RECOMMENDATIONS_EXCEL_EXPORT_META;
  const { formatting, columns, row } = summary_table;
  let width = DEFAULT_COLUMN_WIDTH;

  columns.forEach((obj) => {
    if (['Monthly Clicks', 'Monthly Impressions'].includes(obj.name)) width = DATA_COLUMN_WIDTH;
    summaryTableHeaderColumns.push({ key: obj.id, width });
    summaryTableHeaderValues.push(obj.name);
  });

  worksheet.columns = summaryTableHeaderColumns;

  worksheet.getRow(row).values = summaryTableHeaderValues;

  let tempRow = worksheet.getRow(row);
  tempRow.height = SUMMARY_TABLE_HEADER_HEIGHT;
  tempRow.eachCell((cell) => {
    cell.border = BORDER_PROPERTIES;
    cell.font = SUB_HEADER_PROPERTIES.font;
    cell.fill = SUB_HEADER_PROPERTIES.fill;
    cell.alignment = SUB_HEADER_PROPERTIES.alignment;
  });
  tempRow = worksheet.addRow({
    col1: insight,
    col2: isValidScore(avg_current_relavance_score) ? Math.ceil(avg_current_relavance_score) : 'NA',
    col3: isValidScore(avg_projected_relavance_score) ? Math.ceil(avg_projected_relavance_score) : 'NA',
    col4: isValidScore(currentCQScore) ? Math.ceil(currentCQScore) : 'NA',
    col5: isValidScore(projectedCQScore) ? Math.ceil(projectedCQScore) : 'NA',
    col6: isValidScore(total_clicks) ? numberFormatter(total_clicks) : 'NA',
    col7: isValidScore(total_impressions) ? numberFormatter(total_impressions) : 'NA',
    col8: '',
    col9: '',
    col10: status,
  });

  tempRow.height = SUMMARY_TABLE_ROW_HEIGHT;

  tempRow.eachCell((cell) => {
    cell.border = BORDER_PROPERTIES;
    cell.font = DATA_ROW_PROPERTIES.font;
    cell.fill = DATA_ROW_PROPERTIES.fill;
    cell.alignment = DATA_ROW_PROPERTIES.alignment;
  });
};

export const numberToLetter = (number) => {
  // Convert the number to its corresponding ASCII character code
  const asciiCode = number + 64; // 'A' has ASCII code 65, so add 64 to start from 'A'

  // Convert the ASCII code to the corresponding letter
  const letter = String.fromCharCode(asciiCode);

  return letter;
};

export const exportAsExcel = async (
  {
    recommendationId,
    insight,
    url,
    current_alignment_score,
    projected_alignment_score,
    total_clicks,
    total_impressions,
    status,
    meta,
    headings,
    links,
    images,
    implementationNote,
    added_by,
    added_on,
    structured_data,
    body,
    topicsArr,
    tdmTopicsData,
    topBarDetails,
    avg_current_relavance_score,
    avg_projected_relavance_score,
    currentCQScore,
    projectedCQScore,
    topicsData,
    published_history_by,
    published_history_at,
  },
  session,
  isPublishHistory = false,
  dateValue = ''
) => {
  let columns = [],
    rows = [],
    current,
    improved = '-',
    cell,
    height,
    isTopicRecord,
    rank = 0,
    topicRecordStartIndex,
    topicRowEndIndex,
    noOfHtmlContentInTopic,
    topicRecordFirstElementPosition;
  const topicsExcellCells = [];

  const { ExcelJSWorkbook, worksheet } = createAnExcelSheet(
    isPublishHistory ? `Page Revision History` : 'Keyword Recommendation'
  );

  worksheet.properties.defaultRowHeight = DEFAULT_ROW_HEIGHT;

  const { tab_data, top_header } = CONTENT_RECOMMENDATIONS_EXCEL_EXPORT_META;
  const { formatting } = top_header;

  formatTopHeader({ worksheet, recommendationId });

  addUrl(worksheet, url, formatting);

  formatSummaryTable({
    worksheet,
    insight: `${insight}
  ${url}`,
    current_alignment_score,
    projected_alignment_score,
    total_clicks,
    total_impressions,
    status,
    avg_current_relavance_score,
    avg_projected_relavance_score,
    currentCQScore,
    projectedCQScore,
  });

  buildImplementationNote({ worksheet, implementationNote, added_by, added_on });

  if (isPublishHistory) {
    showPublishedHistoryDetails({ worksheet, recommendationId, url, published_history_by, published_history_at });
  }

  worksheet.mergeCells(tab_data.top_header.start_cell, tab_data.top_header.end_cell);

  const topHeaderCell = worksheet.getCell(tab_data.top_header.start_cell);

  topHeaderCell.value = tab_data.top_header.title;

  topHeaderCell.font = formatting.font;
  topHeaderCell.fill = formatting.fill;
  topHeaderCell.border = BORDER_PROPERTIES;
  topHeaderCell.alignment = formatting.alignment;

  let tableStartRowIndex = DATA_TABLE_START_INDEX,
    row,
    tableDataLastIndex;

  row = worksheet.getRow(tableStartRowIndex - 1);
  row.height = SUMMARY_TABLE_HEADER_HEIGHT;

  const allTableData = [
    { key: 'meta', data: meta },
    { key: 'headings', data: headings },
    { key: 'links', data: links },
    { key: 'images', data: images },
    { key: 'body', data: body },
    { key: 'structured_data', data: structured_data },
    { key: 'topics', data: topicsData },
  ];

  allTableData.forEach((obj) => {
    (columns = []), (rows = []);

    if (obj.data && obj.data.length) {
      worksheet.mergeCells(
        `A${tableStartRowIndex - 1}`,
        `${numberToLetter(tab_data[obj.key]?.table_header?.columns?.length)}${tableStartRowIndex - 1}`
      );

      const topHeaderCell = worksheet.getCell(`A${tableStartRowIndex - 1}`);

      worksheet.getRow(tableStartRowIndex - 1).height = TABLE_DATA_ROW_HEIGHT;

      topHeaderCell.value = capitalizeFirstLetter(obj.key);

      topHeaderCell.font = SUB_HEADER_PROPERTIES.font;
      topHeaderCell.fill = SUB_HEADER_PROPERTIES.fill;
      topHeaderCell.border = BORDER_PROPERTIES;
      topHeaderCell.alignment = SUB_HEADER_PROPERTIES.alignment;

      tab_data[obj.key].table_header.columns.forEach((o) => {
        columns.push({ name: o.name });
      });

      const editableColumn = 'text';
      isTopicRecord = ['topics'].includes(obj.key);
      topicRecordStartIndex = tableStartRowIndex;
      topicRecordFirstElementPosition = topicRecordStartIndex;
      obj.data.forEach((dataObj) => {
        // if suggested copy then set current as empty and improve as suggested copy
        current = dataObj.isSuggested
          ? '-'
          : dataObj[`${editableColumn}_original`]
          ? dataObj[`${editableColumn}_original`]
          : dataObj[`${editableColumn}`];
        improved = dataObj.isSuggested
          ? dataObj[editableColumn]
          : dataObj[`${editableColumn}_original`]
          ? dataObj[`${editableColumn}`]
          : '-';
        if (isTopicRecord && rank === 0) {
          forEach(topicsData, (topicObj) => {
            rank++;
            topicRowEndIndex = topicRecordStartIndex;
            if (topicObj.headings.length) {
              let headingIndexStart = topicRecordStartIndex;
              let headingMergeDetails = [];
              topicObj.headings.forEach((contentData) => {
                const topicRowEndIndexStartPosition = topicRowEndIndex + 1;
                let topicRowEndIndexEndPosition = topicRowEndIndexStartPosition;
                if (contentData.body && contentData.body.length) {
                  let bodyLength = 0;
                  contentData.body.forEach((bodyContent) => {
                    const statusText =
                      (bodyContent.isEdited && !bodyContent.isSuggested) ||
                      (contentData.isEdited && !contentData.isSuggested)
                        ? 'Improved'
                        : bodyContent.isSuggested || contentData.isSuggested
                        ? 'Proposed'
                        : null;
                    rows.push([
                      rank,
                      topicObj.topic_name,
                      topicObj.topic_importance_score,
                      contentData.heading_tag,
                      contentData?.heading_content?.replaceAll('&nbsp;', ' ')?.replaceAll('&amp;', '&'),
                      bodyContent.body_tag,
                      bodyContent?.body_text?.replaceAll('&nbsp;', ' ')?.replaceAll('&amp;', '&'),
                      statusText,
                    ]);
                    bodyLength++;
                  });
                  worksheet.mergeCells(`E${topicRowEndIndex + 1}:E${topicRowEndIndex + bodyLength} `);
                  worksheet.mergeCells(`D${topicRowEndIndex + 1}:D${topicRowEndIndex + bodyLength} `);
                  // worksheet.mergeCells(`C${topicRowEndIndex + 1}:C${topicRowEndIndex + bodyLength} `);
                  // worksheet.mergeCells(`B${topicRowEndIndex + 1}:B${topicRowEndIndex + bodyLength} `);
                  // worksheet.mergeCells(`A${topicRowEndIndex + 1}:A${topicRowEndIndex + bodyLength} `);
                  topicRowEndIndexEndPosition += bodyLength;
                  topicRowEndIndex += bodyLength;
                } else {
                  const statusText =
                    contentData.isEdited && !contentData.isSuggested
                      ? 'Improved'
                      : contentData.isSuggested
                      ? 'Proposed'
                      : '';
                  rows.push([
                    rank,
                    topicObj.topic_name,
                    topicObj.topic_importance_score,
                    contentData.heading_tag,
                    contentData.heading_content,
                    '',
                    '',
                    statusText,
                  ]);
                  topicRowEndIndex++;
                }
              });
            } else {
              // const statusText = topicObj.isEdited && !topicObj.isSuggested ? "Improved" : topicObj.isSuggested ? "Proposed" : '';
              rows.push([rank, topicObj.topic_name, topicObj.topic_importance_score, '', '', '', '', '']);
              topicRowEndIndex++;
            }
            topicsExcellCells.push(topicRowEndIndex);
            topicRecordStartIndex = topicRowEndIndex;
          });
        } else if (['links'].includes(obj.key)) {
          rows.push([recommendationId, dataObj.tag, '', current, improved, dataObj.link || '', '']);
        } else if (['images'].includes(obj.key)) {
          rows.push([recommendationId, dataObj.tag, '', current, improved, dataObj.link || '']);
        } else if (['structured_data'].includes(obj.key)) {
          rows.push([recommendationId, dataObj.tag, current, improved]);
        } else if (!isTopicRecord) {
          rows.push([recommendationId, dataObj.tag, '', current, improved]);
        }
      });

      worksheet.addTable({
        name: obj.key,
        ref: `A${tableStartRowIndex}`,
        columns: columns,
        rows: rows,
      });

      tableDataLastIndex = tableStartRowIndex + rows.length + 1;

      row = worksheet.getRow(tableStartRowIndex);

      row.height = TABLE_DATA_ROW_HEIGHT;
      row.eachCell((cell) => {
        cell.border = BORDER_PROPERTIES;
        cell.font = { ...SUB_HEADER_PROPERTIES.font, color: { argb: 'FF000000' } };
        cell.fill = { ...SUB_HEADER_PROPERTIES.fill, fgColor: { argb: 'FFDBDBDB' } };
        cell.alignment = SUB_HEADER_PROPERTIES.alignment;
      });

      for (let i = tableStartRowIndex + 1; i < tableDataLastIndex; i++) {
        row = worksheet.getRow(i);
        // cell = worksheet.getCell(isTopicRecord ? `G${i}` : `C${i}`); // for topic, actual html content exists in G column, for other tab it exists in C column
        // height = cell.value?.toString()?.trim()?.length;
        // if (isTopicRecord) {
        //   // adjust height by Topic name or html content column
        //   let topicContentHeight = worksheet.getCell(`B${i}`)?.value?.toString()?.trim()?.length;
        //   if (topicContentHeight > height) {
        //     height = topicContentHeight;
        //   }
        //   topicContentHeight = worksheet.getCell(`E${i}`)?.value?.toString()?.trim()?.length;
        //   if (topicContentHeight > height) {
        //     height = topicContentHeight;
        //   }
        // }
        row.height = 80;
        row.eachCell((cell) => {
          cell.border = BORDER_PROPERTIES;
          cell.fill = { ...DATA_ROW_PROPERTIES.fill };
        });
        row.font = { ...SUB_HEADER_PROPERTIES.font, bold: false, color: { argb: 'FF000000' } };
        row.alignment = DATA_ROW_PROPERTIES.alignment;
      }

      tableStartRowIndex = tableDataLastIndex + 2;
    }
  });
  if (topicsExcellCells.length) {
    if (topicsExcellCells.length === 1) {
      worksheet.mergeCells('A' + (topicRecordFirstElementPosition + 1), 'A' + topicsExcellCells[0]);
      worksheet.mergeCells('B' + (topicRecordFirstElementPosition + 1), 'B' + topicsExcellCells[0]);
      worksheet.mergeCells('C' + (topicRecordFirstElementPosition + 1), 'C' + topicsExcellCells[0]);
    }
    for (let i = 0; i < topicsExcellCells.length - 1; i++) {
      if (i === 0) {
        worksheet.mergeCells('A' + (topicRecordFirstElementPosition + 1), 'A' + topicsExcellCells[i]);
        worksheet.mergeCells('B' + (topicRecordFirstElementPosition + 1), 'B' + topicsExcellCells[i]);
        worksheet.mergeCells('C' + (topicRecordFirstElementPosition + 1), 'C' + topicsExcellCells[i]);
      }
      worksheet.mergeCells('A' + (topicsExcellCells[i] + 1), 'A' + topicsExcellCells[i + 1]);
      worksheet.mergeCells('B' + (topicsExcellCells[i] + 1), 'B' + topicsExcellCells[i + 1]);
      worksheet.mergeCells('C' + (topicsExcellCells[i] + 1), 'C' + topicsExcellCells[i + 1]);
    }
  }

  const schemaName = await getSchema(session);

  const fileName = isPublishHistory
    ? `Page-Revision-History-${dateValue}-${recommendationId}`
    : `Keyword-Recommendations-${format(new Date(), 'MM-dd-yyyy')}-${recommendationId}`;

  downloadAnExcelSheet(ExcelJSWorkbook, fileName);
};
export const getFilterPlaceHolderText = (selectedFilters, type, filtersArr, isFromContentBrief = false) => {
  if (selectedFilters && selectedFilters[type]?.length) {
    if ((filtersArr && filtersArr?.length > 4) || isFromContentBrief) {
      switch (type) {
        case 'domain':
          return `Domain`;
        case 'category':
          return `Category`;
        case 'page_experience':
          return `Page`;
        case 'audit_type':
          return `Audit Type`;
        case 'performance_metrics':
          return `Performance Metrics`;
        case 'createdby':
          return `Added By`;
        default:
          return capitalizeFirstLetter(type);
      }
    } else {
      return type;
    }
  }
};

export const improvementOpportunity = (source, orgClicks, paidClicks, orgImpression, paidImpression) => {
  let finalObj = {};
  const arrImpClicks = [orgClicks, paidClicks, orgImpression, paidImpression];
  const totalPerf = Math.floor(arrImpClicks.reduce((total, obj) => obj + total, 0));
  if (source.toUpperCase() === 'ORG') {
    return totalPerf > 0
      ? Math.floor(paidImpression) > 2 * Math.floor(orgImpression + 10) &&
        Math.floor(paidClicks) > 2 * Math.floor(orgClicks + 10)
        ? (finalObj = {
            improvementText: !KEYWORD_DATA_SOURCE?.paidRecommendation?.improvementText?.isHide
              ? `${KEYWORD_DATA_SOURCE?.paidRecommendation?.improvementText?.text}`
              : null,
            improvementInfo: !KEYWORD_DATA_SOURCE?.paidRecommendation?.improvementInfo?.isHide
              ? `${KEYWORD_DATA_SOURCE?.paidRecommendation?.improvementInfo?.availableImpClicks}`
              : null,
          })
        : Math.floor(paidImpression) > 2 * Math.floor(orgImpression + 10) &&
          Math.floor(paidClicks) < 2 * Math.floor(orgClicks + 10)
        ? (finalObj = {
            improvementText: !KEYWORD_DATA_SOURCE?.paidRecommendation?.improvementText?.isHide
              ? `${KEYWORD_DATA_SOURCE?.paidRecommendation?.improvementText?.text}`
              : null,
            improvementInfo: !KEYWORD_DATA_SOURCE?.paidRecommendation?.improvementInfo?.isHide
              ? `${KEYWORD_DATA_SOURCE?.paidRecommendation?.improvementInfo?.availableImp}`
              : null,
          })
        : Math.floor(paidImpression) < 2 * Math.floor(orgImpression + 10) &&
          Math.floor(paidClicks) > 2 * Math.floor(orgClicks + 10)
        ? (finalObj = {
            improvementText: !KEYWORD_DATA_SOURCE?.paidRecommendation?.improvementText?.isHide
              ? `${KEYWORD_DATA_SOURCE?.paidRecommendation?.improvementText?.text}`
              : null,
            improvementInfo: !KEYWORD_DATA_SOURCE?.paidRecommendation?.improvementInfo?.isHide
              ? `${KEYWORD_DATA_SOURCE?.paidRecommendation?.improvementInfo?.availableClicks}`
              : null,
          })
        : null
      : null;
  } else {
    return totalPerf > 0
      ? Math.floor(orgImpression) > 2 * Math.floor(paidImpression + 10) &&
        Math.floor(orgClicks) > 2 * Math.floor(paidClicks + 10)
        ? (finalObj = {
            improvementText: !KEYWORD_DATA_SOURCE?.organicRecommendation?.improvementText?.isHide
              ? `${KEYWORD_DATA_SOURCE?.organicRecommendation?.improvementText?.text}`
              : null,
            improvementInfo: !KEYWORD_DATA_SOURCE?.organicRecommendation?.improvementInfo?.isHide
              ? `${KEYWORD_DATA_SOURCE?.organicRecommendation?.improvementInfo?.availableImpClicks}`
              : null,
          })
        : Math.floor(orgImpression) > 2 * Math.floor(paidImpression + 10) &&
          Math.floor(orgClicks) < 2 * Math.floor(paidClicks + 10)
        ? (finalObj = {
            improvementText: !KEYWORD_DATA_SOURCE?.organicRecommendation?.improvementText?.isHide
              ? `${KEYWORD_DATA_SOURCE?.organicRecommendation?.improvementText?.text}`
              : null,
            improvementInfo: !KEYWORD_DATA_SOURCE?.organicRecommendation?.improvementInfo?.isHide
              ? `${KEYWORD_DATA_SOURCE?.organicRecommendation?.improvementInfo?.availableImp}`
              : null,
          })
        : Math.floor(orgImpression) < 2 * Math.floor(paidImpression + 10) &&
          Math.floor(orgClicks) > 2 * Math.floor(paidClicks + 10)
        ? // eslint-disable-next-line @typescript-eslint/no-unused-vars
          (finalObj = {
            improvementText: !KEYWORD_DATA_SOURCE?.organicRecommendation?.improvementText?.isHide
              ? `${KEYWORD_DATA_SOURCE?.organicRecommendation?.improvementText?.text}`
              : null,
            improvementInfo: !KEYWORD_DATA_SOURCE?.organicRecommendation?.improvementInfo?.isHide
              ? `${KEYWORD_DATA_SOURCE?.organicRecommendation?.improvementInfo?.availableClicks}`
              : null,
          })
        : null
      : null;
  }
};

export const convetUnderScoreToNormalText = (text) => {
  if (text && text.split('_')) {
    return text.split('_').join(' ');
  } else {
    return 'N/A';
  }
};

export const validURL = (str) => {
  try {
    new URL(str);
    return true;
  } catch (_) {
    return false;
  }
};

export const getUuidForPageContent = async (finalUrl, schema) => {
  try {
    const payLoad = {
      model: process.env.NEXT_PUBLIC_LOOKER_MODEL_NAME,
      view: CONTENT_RECOMMENDATION_EXPLORE,
      fields: [
        `${CONTENT_RECOMMENDATION_EXPLORE}.uuid`,
        `${CONTENT_RECOMMENDATION_EXPLORE}.finalurl`,
        `${CONTENT_RECOMMENDATION_EXPLORE}.updated_date`,
      ],
      filters: {
        [`${CONTENT_RECOMMENDATION_EXPLORE}.finalurl`]: finalUrl,
      },
    };

    const response = await ApiService.post('summary_panel', { selected_schema: schema, params: payLoad });
    return response.data;
  } catch (error) {
    console.log('common : getUuidForPageContent err', error);
  }
};

export const findExistingCRpageDetails = async (pageUrl) => {
  try {
    const checkUrlExistOrNot = await ApiService.post(
      `${process.env.NEXT_PUBLIC_QUATTR_API_URL}/api/master-data/check-url-exist`,
      {
        pageUrl,
      }
    );
    if (checkUrlExistOrNot && checkUrlExistOrNot?.existingRecord) {
      return checkUrlExistOrNot?.existingRecord;
    }
    return null;
  } catch (error) {
    console.error('common : findUrlIsExist err', error);
    throw error;
  }
};

export function checkValueExists(value) {
  return value || value === 0;
}

export function generateHash(str, seed = 0) {
  let h1 = 0xdeadbeef ^ seed,
    h2 = 0x41c6ce57 ^ seed;
  for (let i = 0, ch; i < str.length; i++) {
    ch = str.charCodeAt(i);
    h1 = Math.imul(h1 ^ ch, 2654435761);
    h2 = Math.imul(h2 ^ ch, 1597334677);
  }
  h1 = Math.imul(h1 ^ (h1 >>> 16), 2246822507) ^ Math.imul(h2 ^ (h2 >>> 13), 3266489909);
  h2 = Math.imul(h2 ^ (h2 >>> 16), 2246822507) ^ Math.imul(h1 ^ (h1 >>> 13), 3266489909);
  return 4294967296 * (2097151 & h2) + (h1 >>> 0);
}

export const getToolTipDetails = (heading) => {
  if (heading === 'KEYWORD IMPORTANCE') {
    return 'Keyword Importance is an off page score that indicates the importance of a Keyword. Higher Keyword Importance score indicates the Keyword is getting a lot of impressions and clicks.';
  } else if (heading === 'KEYWORD RELEVANCE') {
    return 'Indicates how well the Keyword is covered and emphasized within the content on the page. The Quattr platform analyzes all the text on a page relative to the Keyword.';
  } else if (heading === 'RELEVANCE RANK') {
    return 'Total number of competitors who have higher Keyword Relevance score.';
  } else if (heading === 'COMPETITOR PREVALENCE') {
    return 'Number of competitors covering the Topic. Important topics are widely covered by competitors and have high prevalence scores.';
  } else if (heading === 'RANK') {
    return 'Topic Rank is used to indicate which Topic on a page needs the most attention. The rank is calculated using Topic Importance, My Relevance, and Competitor Relevance. Topics that have high importance, low relevance and high prevalence have higher rank as they need attention.';
  } else if (heading === 'TOPIC IMPORTANCE') {
    return 'The topic importance score indicates how closely the content for the Topic is related to the primary keyword on the page.';
  } else if (heading === 'MARKET RELEVANCE') {
    return 'The score is used to measure the coverage and relevance of a specific Topic on competitor pages.';
  } else if (heading === 'MY RELEVANCE') {
    return 'The score is used to measure the relevance of a specific Topic on your page.';
  } else {
    return false;
  }
};

// already moved in cr-utill file please use for new code from there
export const getTagLabel = (tag) => {
  let updatedTag = tag.toLowerCase();
  switch (updatedTag) {
    case 'a':
    case 'A':
      return { label: 'ANCHOR TAG - <A>', tagGroup: 'LINKS' };

    case 'H1':
    case 'h1':
      return { label: 'HEADING - <H1>', tagGroup: 'META' };

    case 'H2':
    case 'h2':
      return { label: 'HEADING - <H2>', tagGroup: 'HEADINGS' };

    case 'H3':
    case 'h3':
      return { label: 'HEADING - <H3>', tagGroup: 'HEADINGS' };

    case 'H4':
    case 'h4':
      return { label: 'HEADING - <H4>', tagGroup: 'HEADINGS' };

    case 'H5':
    case 'h5':
      return { label: 'HEADING - <H5>', tagGroup: 'HEADINGS' };

    case 'H6':
    case 'h6':
      return { label: 'HEADING - <H6>', tagGroup: 'HEADINGS' };

    case 'IMG':
    case 'img':
      return { label: 'IMAGE - <IMG>', tagGroup: 'IMAGES' };

    case 'P':
    case 'p':
      return { label: 'PARAGRAPH - <P>', tagGroup: 'BODY' };

    case 'DIV':
    case 'div':
      return { label: 'DIVIDER - <DIV>', tagGroup: 'BODY' };

    case 'UL':
    case 'ul':
      return { label: 'UNORDERED LIST - <UL>', tagGroup: 'BODY' };

    case 'LI':
    case 'li':
      return { label: 'ORDERED LIST - <LI>', tagGroup: 'BODY' };

    case 'SPAN':
    case 'span':
      return { label: 'SPAN - <SPAN>', tagGroup: 'BODY' };

    case 'PRE':
    case 'pre':
      return { label: 'PREFORMATTED - <PRE>', tagGroup: 'BODY' };

    case 'TITLE':
    case 'title':
      return { label: tag, tagGroup: 'META' };
    case 'DESCRIPTION':
    case 'description':
    case 'meta description':
      return { label: tag, tagGroup: 'META' };

    default:
      return { label: tag, tagGroup: tag };
  }
};

export const getCustomerInfo = async (customerInfo = [], QwaSession) => {
  const schemaName = await getSchema(QwaSession);
  const customerData = customerInfo.find((o) => o.cust_code === schemaName);
  return customerData;
};

export function convertNumber({ value, decimal = 2, prefix = '', suffix = '', inToPercentage = 1 }) {
  // inToPercentage means if want to convert value in % then we need to multiply it by 100 then send

  // if(isNaN(value)){
  //   if(value.includes("|")){
  //     const  values = value.split("|");
  //     const formatedValues =  values.map(v=> formatedValue(Math.ceil(v)));
  //     return formatedValues.join(" | ")

  //   }else {
  //     return value;
  //   }
  // }
  let formattedValue = 0;
  if (value) {
    formattedValue =
      Math.abs(Number(value)) >= 1.0e9
        ? ((Math.round((Number(value) / 1.0e9) * 100) / 100) * inToPercentage).toFixed(decimal) + 'B'
        : // Six Zeroes for Millions
        Math.abs(Number(value)) >= 1.0e6
        ? ((Math.round((Number(value) / 1.0e6) * 100) / 100) * inToPercentage).toFixed(decimal) + 'M'
        : // Three Zeroes for Thousands
        Math.abs(Number(value)) >= 1.0e3
        ? ((Math.round((Number(value) / 1.0e3) * 100) / 100) * inToPercentage).toFixed(decimal) + 'K'
        : Number((Number(value) * inToPercentage).toFixed(decimal));
    // : Math.round(Number(value) * 10 * decimals) / (10 * decimals);
  }

  return `${prefix}${formattedValue}${suffix}`;
}

export const getComparator = (order, orderBy) => {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
};

const descendingComparator = (a, b, orderBy) => {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
};

export const sortArrays = (array, comparator) => {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  return stabilizedThis.map((el) => el[0]);
};

export const sortArrayByKey = (array = [], order, orderBy) => {
  const compareValue = (v) => {
    if (isKFormatedValue(v)) {
      return reversKFormatter(v);
    }
    return v; //isNaN(array[0][orderBy]) ? v : parseFloat(v);
  };
  const data = array.sort((a1, a2) => {
    const a = compareValue(a1[orderBy]);
    const b = compareValue(a2[orderBy]);
    if (a === b) {
      return 0;
    }
    // nulls sort after anything else
    else if (a === null || a === undefined) {
      return 1;
    } else if (b === null || b === undefined) {
      return -1;
    }
    // otherwise, if we're ascending, lowest sorts first
    else if (order === 'asc') {
      return a < b ? -1 : 1;
    }
    // if descending, highest sorts first
    else {
      return a < b ? 1 : -1;
    }
  });
  return array;
};

export const extractUUIDFromString = (str) => {
  return str?.substring(4)?.replace(/^(.{8})(.{4})(.{4})(.{4})(.{12})$/, '$1-$2-$3-$4-$5');
};
export const getUrlDetails = (url = '') => {
  const details = new URL(url);
  const path = details.pathname;
  return {
    host: details.host ? details.host : ' ',
    // path: path && path.length > 1 ? details.pathname : details.host,
    path: path && path.length > 1 ? details?.pathname + details?.search + details?.hash : details?.host,
  };
};

export const getTagGroupKey = (tab) => {
  switch (tab) {
    case 'Meta Description':
    case 'Meta':
      return 'META';
    case 'HEADINGS':
      return 'HEADINGS';
    case 'LINKS':
      return 'LINK_ANCHOR';
    case 'IMAGES':
      return 'IMAGES';
    case 'BODY':
      return 'BODY';
    case 'STRUCTURED DATA':
      return 'STRUCTURED_DATA';
    default:
      return tab.toUpperCase();
  }
};

export const getPercentageDiffByTwoValue = (a = 0, b = 0) => {
  const diff = Math.abs(a - b);
  const avg = (a + b) / 2;
  const pDiff = (diff / avg) * 100;
  return { percentageDiff: pDiff, isFirstBig: a > b };
};
export const getCarretPosition = (element) => {
  let position = 0;
  const isSupported = typeof window.getSelection !== 'undefined';
  if (isSupported) {
    const selection = window.getSelection();
    // Check if there is a selection (i.e. cursor in place)
    if (selection.rangeCount !== 0) {
      // Store the original range
      const range = window.getSelection().getRangeAt(0);
      // Clone the range
      const preCaretRange = range.cloneRange();
      // Select all textual contents from the contenteditable element
      preCaretRange.selectNodeContents(element);
      // And set the range end to the original clicked position
      preCaretRange.setEnd(range.endContainer, range.endOffset);
      // Return the text length from contenteditable start to the range end
      position = preCaretRange.toString().length;
    }
  }
  return position;
};

export const API_METHOD = {
  POST: 'post',
  PUT: 'put',
  DELETE: 'delete',
  GET: 'get',
};

export const isValidScreen = (customWidth, screenWidth) => {
  // only for >1440px then true
  if (!customWidth || !screenWidth) return true;
  if (screenWidth <= customWidth) return false;
  return true;
};

export const isValidScore = (score) => score >= 0 && score != null && score != undefined;
export const isValidScoreCrListView = (score) => score > 0 && score != null && score !== undefined;
export const getCurrentDateFromCacheRangeWhenRefresh = (dateRanges) => {
  let updatedDateRange = {};
  // console.log("lableDate object -->", DATE_RANGE_META)
  if (dateRanges.selected.label != 'Custom') {
    let lableDate = DATE_RANGE_META.filter((x) => x.label === dateRanges.selected.label);

    // in case the cache has bad data, use a sane default
    if (!lableDate || lableDate.length === 0) {
      lableDate = DATE_RANGE_META.filter((x) => x.label === 'Last 12 Complete Weeks');
    }

    if (!lableDate || lableDate.length === 0) {
      console.warn(`lableDate looks empty, even after trying to set a default`, { dateRanges, lableDate });
    }

    const calculatedDates = calculatePreviousDateRange(lableDate[0], dateRanges.comparison.label);

    updatedDateRange = {
      selected: lableDate[0],
      comparison: {
        startDate: calculatedDates.startDate,
        endDate: calculatedDates.endDate,
      },
    };
  } else {
    updatedDateRange = {
      selected: {
        startDate: new Date(dateRanges.selected.startDate),
        endDate: new Date(dateRanges.selected.endDate),
      },
      comparison: {
        startDate: new Date(dateRanges.comparison.startDate),
        endDate: new Date(dateRanges.comparison.endDate),
      },
    };
  }

  return updatedDateRange;
};

export const getRank = (rank, showPipe = true) => {
  if (isValidScore(rank) || rank == '>4') {
    const toShow =
      rank === 100
        ? ''
        : rank == 1
        ? 'Best'
        : rank == 2
        ? '2nd Best'
        : rank == 3
        ? '3rd Best'
        : rank == 4
        ? '4th Best'
        : 'Not in Top 4';
    return (
      <div style={{ marginTop: '11px', display: 'flex', alignItems: 'unset' }}>
        {showPipe && <span style={{ margin: '1px 10px 0 8px' }}>|</span>}
        <span style={{ lineHeight: '20px' }}>{toShow}</span>
      </div>
    );
  }

  return <></>;
};

const calculatePreviousDateRange = (dateRange, comparisonPeriodLabel = '') => {
  // logic similar to updateComparisonPeriod in src/components/formElements/src/DateRangePicker.js Need Refactoring
  const isPrevYearSamePeriod = comparisonPeriodLabel.includes('Previous Year Same Period');
  const isPrevPeriod = comparisonPeriodLabel.includes('Previous Period');

  const diff = differenceInCalendarDays(
    has(dateRange, 'endDate') ? dateRange?.endDate : new Date(),
    dateRange?.startDate
  );

  const isCompleteWeeksSelected = dateRange.label && dateRange.label.includes('Complete Weeks');
  const isCompleteMonthsSelected = dateRange.label && dateRange.label.includes('Complete Months');

  let startOfPrevPeriod,
    endOfPrevPeriod = null;
  if (isCompleteWeeksSelected && isPrevYearSamePeriod) {
    const weekIndex = getWeekOfMonth(dateRange.startDate);
    const previousYearDate = subYears(dateRange.startDate, 1);
    const startOfPrevMonth = startOfMonth(previousYearDate);
    const weekDayOfPrevMonth = addWeeks(startOfPrevMonth, weekIndex - 1);
    startOfPrevPeriod = startOfWeek(weekDayOfPrevMonth);
    const noOfWeeks = Math.abs(
      utility.getDiffAsPerGranularityType(
        'week',
        dateRange.startDate,
        addDays(has(dateRange, 'endDate') ? dateRange.endDate : new Date(), 1)
      )
    );
    endOfPrevPeriod = subDays(addWeeks(startOfPrevPeriod, noOfWeeks), 1);
  }
  if (isPrevPeriod && isCompleteMonthsSelected && !isPrevYearSamePeriod) {
    const noOfMonths = Math.abs(
      utility.getDiffAsPerGranularityType(
        'month',
        dateRange.startDate,
        addDays(has(dateRange, 'endDate') ? dateRange.endDate : new Date(), 1)
      )
    );
    startOfPrevPeriod = startOfMonth(subMonths(dateRange.startDate, noOfMonths + 1)); // adding a month to avoid ongoing month
    endOfPrevPeriod = endOfMonth(subMonths(dateRange.startDate, 1));
  }
  const startDate =
    isPrevYearSamePeriod || (isPrevPeriod && isCompleteMonthsSelected)
      ? startOfPrevPeriod || subYears(dateRange.startDate, 1)
      : subDays(dateRange.startDate, diff + 1);
  const endDate =
    isPrevYearSamePeriod || isCompleteMonthsSelected
      ? endOfPrevPeriod || subYears(has(dateRange, 'endDate') ? dateRange.endDate : new Date(), 1)
      : subDays(dateRange.startDate, 1);

  return {
    startDate: startDate,
    endDate: endDate,
  };
};

export const generateColorCode = () => {
  return [
    'aqua',
    'black',
    'blue',
    'fuchsia',
    'gray',
    'green',
    'lime',
    'maroon',
    'navy',
    'olive',
    'orange',
    'purple',
    'red',
    'silver',
    'teal',
    'white',
    'yellow',
  ];
};

export const localTimeZone = (date, format = 'YYYY-MM-DD HH:mm:ss', timezone = true) => {
  const data = timezone
    ? moment.utc(date).local().format(format) + ' ' + moment.tz(moment.tz.guess()).format('z')
    : moment.utc(date).local().format(format);
  return data;
};

/**
 * Function extract from code, for easier unit testing
 * @param {any[]} countryOptions
 * @param countryCodes
 * @returns {any[]}
 */
export const getCountryOptionFilters = (countryOptions, countryCodes = COUNTRY_CODES) => {
  let result = countryOptions;

  result = result.map((i) => {
    const country = countryCodes.find((j) => j?.alpha === i?.value);
    return {
      ...i,
      filterString: `${country ? country.alpha + country.name : ''}`,
      text: country ? country.name : '',
    };
  });
  result = result.filter((i) => i?.text);

  return result;
};

// Common function for get filter Data in multiple places
export const getFilterMeta = async (
  dispatch,
  filterData,
  KeywordsUploads = [],
  PagesUploads = [],
  isForInternalLinking = false
) => {
  const tempFilters = {},
    options = [
      'domain',
      'device',
      'intent',
      'country',
      'sources',
      'pages',
      'queries',
      'distinct_search_type',
      'keyword_serp_features',
      'goals_concat',
      'language',
      'adgroup_name',
      'campaign_name',
      'campaign_type',
      'keyword_city',
      'keyword_state',
      'keyword_country',
      'page_city',
      'page_state',
      'page_country',
      'page_tag_canonical_url_tag',
      'page_tag_parameterized',
      'page_tag_language_code',
      'page_tag_paginated',
      'page_tag_last_modified',
      'page_tag_mime_type',
      'page_tag_author',
      'page_tag_hreflang_tag',
    ];
  const testDriveDomain = (await getTestDriveDomain()) || '';

  prepareFiltersOptions({ options, filterData, filters: tempFilters });
  const categories = filterData?.category?.map((cat) => {
    return {
      ...(cat || {}),
      totalclicks: cat?.totalclicks ? parseInt(cat?.totalclicks) : 0,
    };
  });
  // const sortedCategoryData = sortArrayByKey(categories || [], 'desc', 'totalclicks');
  const categoriesData = categories?.length ? prepareCategoriesData(categories, '-', isForInternalLinking) : [];

  tempFilters.category = { ...SEGMENT_FILTER_META.category, options: categoriesData };
  tempFilters.keyword_list_segment = SEGMENT_FILTER_META.keyword_list_segment;
  tempFilters.page_list_segment = SEGMENT_FILTER_META.page_list_segment;

  tempFilters.keyword_list_segment.options = KeywordsUploads.map((i) => {
    return { text: i.list_name, value: i.id, type: 'keyword_list_segment' };
  });
  tempFilters.page_list_segment.options = PagesUploads.map((i) => {
    return { text: i.list_name, value: i.id, type: 'page_list_segment' };
  });

  tempFilters.country = tempFilters.country || SEGMENT_FILTER_META.country;
  tempFilters.country.options = getCountryOptionFilters(tempFilters.country.options);

  tempFilters.device = SEGMENT_FILTER_META.device;
  tempFilters.keyword_serp_features = SEGMENT_FILTER_META.keyword_serp_features;
  tempFilters.distinct_search_type = tempFilters.distinct_search_type || SEGMENT_FILTER_META.distinct_search_type;
  tempFilters.goals_concat = tempFilters.goals_concat || SEGMENT_FILTER_META.goals_concat;
  if (tempFilters.sources && tempFilters.sources.options) {
    let totalclicks = 0;
    tempFilters.sources.options.forEach((i) => (totalclicks += Number(i.totalclicks)));
    tempFilters.sources.options.unshift({
      text: 'All traffic sources',
      value: 'allsources',
      type: 'sources',
      totalclicks: totalclicks,
    });
  }
  tempFilters.sources = tempFilters.sources || SEGMENT_FILTER_META.sources;
  tempFilters.page_experience = SEGMENT_FILTER_META.page_experience;
  // setting pages and queries empty, loading values on runtime
  tempFilters.pages = SEGMENT_FILTER_META.pages;
  tempFilters.queries = SEGMENT_FILTER_META.queries;
  tempFilters.adgroup_name = tempFilters.adgroup_name || SEGMENT_FILTER_META.adgroup_name;
  tempFilters.campaign_name = tempFilters.campaign_name || SEGMENT_FILTER_META.campaign_name;
  tempFilters.campaign_type = tempFilters.campaign_type || SEGMENT_FILTER_META.campaign_type;
  tempFilters.keyword_city = tempFilters.keyword_city || SEGMENT_FILTER_META.keyword_city;
  tempFilters.keyword_state = tempFilters.keyword_state || SEGMENT_FILTER_META.keyword_state;
  tempFilters.keyword_country = tempFilters.keyword_country || SEGMENT_FILTER_META.keyword_country;
  tempFilters.page_city = tempFilters.page_city || SEGMENT_FILTER_META.page_city;
  tempFilters.page_state = tempFilters.page_state || SEGMENT_FILTER_META.page_state;
  tempFilters.page_country = tempFilters.page_country || SEGMENT_FILTER_META.page_country;
  tempFilters.language = {
    ...SEGMENT_FILTER_META.language,
    options:
      tempFilters.language && tempFilters.language.options
        ? tempFilters.language.options
        : SEGMENT_FILTER_META.language.options,
  };
  tempFilters.is_branded = { ...SEGMENT_FILTER_META.is_branded };
  let marketShareSegment = [];
  const rankingBucket = [];
  if (filterData.rank_bucket_segment) {
    RANK_BUCKETS_FILTERS.forEach((i) => {
      // HotFix for PPP-123
      const foundData = filterData.rank_bucket_segment.find((j) => j.top_data === i);
      if (foundData) {
        const data = get(foundData, 'top_data');
        rankingBucket.push({ text: foundData.top_data.split('_').join(' '), value: data });
      }
    });
  }
  if (filterData.market_share_segment) {
    if (!testDriveDomain) {
      // normal user
      filterData.market_share_segment.forEach((i) => {
        marketShareSegment.push({ text: i['segment_name'], value: i['segment_id'], type: 'market_share_segment' });
      });
    } else {
      // external user
      marketShareSegment = [{ text: testDriveDomain, value: testDriveDomain, type: 'market_share_segment' }];
    }
  }

  if (testDriveDomain && tempFilters.domain) {
    tempFilters.domain.options = tempFilters.domain.options.filter((i) => i.value === testDriveDomain);
  }
  tempFilters.rank_bucket_segment = { ...SEGMENT_FILTER_META.rank_bucket_segment, options: rankingBucket };
  tempFilters.market_share_segment = {
    ...SEGMENT_FILTER_META.market_share_segment,
    options: marketShareSegment,
    additionaldata: filterData.market_share_segment ? filterData.market_share_segment : [],
  };

  let savedSegment = [];
  let savedComparisions = [];

  try {
    savedSegment = dispatchGetSegmentDataWithType(dispatch, 'segment');
    savedComparisions = dispatchGetSegmentDataWithType(dispatch, 'comparison');
    [savedSegment, savedComparisions] = await Promise.all([savedSegment, savedComparisions]);
  } catch (err) {
    console.log(err);
  }

  tempFilters.saved_segment = { ...SEGMENT_FILTER_META.saved_segment, options: savedSegment };
  tempFilters.saved_comparison = { ...SEGMENT_FILTER_META.saved_comparison, options: savedComparisions };
  // setOptions(tempFilters);
  return tempFilters;
};

export const fetchSavedSegmentData = (type) => {
  return new Promise((resolve, reject) => {
    try {
      ApiService.get(`${process.env.NEXT_PUBLIC_QUATTR_API_URL}/api/segment?type=${type}`)
        .then((response) => {
          const data = response.data.map((obj) => {
            return {
              text: obj.name,
              value: obj.name,
              definition: obj.definition,
              additional_info: obj.additional_info,
              id: obj.id,
            };
          });

          resolve(data);
        })
        .catch((err) => {
          console.log(`Error in fetching saved ${type}`, err);
          resolve([]);
        });
    } catch (error) {
      console.log('fetchSavedSegmentData:: Error ', error);
      resolve([]);
    }
  });
};
export const isElementVisible = (element) => {
  if (element?.offsetWidth || element?.offsetHeight || element?.getClientRects()?.length) return true;
  else return false;
};

export function isValidDate(d) {
  return d instanceof Date && !isNaN(d);
}

function isNumeric(value) {
  return /^-?\d+$/.test(value);
}
export const createAllCategoryHierarchy = (json) => {
  const arrayUniqueByKey = [...new Map(json.map((item) => [item['category'], item])).values()]; //qunique category
  const arrayCategoryList = [];
  for (let a = 0; a < arrayUniqueByKey.length; a++) {
    //subcategory 1
    arrayCategoryList.push({ text: arrayUniqueByKey[a].category, value: arrayUniqueByKey[a].category });
  }
  return arrayCategoryList;
};
export const createAllSubCategoryHierarchy = (json) => {
  const arrayUniqueByKey = [...new Map(json.map((item) => [item['category'], item])).values()]; //qunique category
  const arrayCategoryList = [];
  for (let a = 0; a < arrayUniqueByKey.length; a++) {
    //subcategory 1
    const categories = [];
    for (let b = 0; b < json.length; b++) {
      if (arrayUniqueByKey[a].category === json[b].category) {
        categories.push({ ...json[b], subMenuItems: [] });
      }
    }
    const arrayUniqueBySubCategory1 = [
      ...new Map(
        categories.map((item) => [item['subcategory1'], { text: item.subcategory1, value: item.subcategory1 }])
      ).values(),
    ]; // qunique subcategory
    for (let c = 0; c < arrayUniqueBySubCategory1.length; c++) {
      const i = arrayCategoryList.findIndex((x) => x.text === arrayUniqueBySubCategory1[c].text);
      if (i <= -1) {
        arrayCategoryList.push({ text: arrayUniqueBySubCategory1[c].text, value: arrayUniqueBySubCategory1[c].value });
      }
    }
  }
  return arrayCategoryList;
};
export const createAllSub2CategoryHierarchy = (json) => {
  const arrayUniqueByKey = [...new Map(json.map((item) => [item['category'], item])).values()]; //qunique category
  const arrayCategoryList = [];
  const arraySubCategoryList = [];
  for (let a = 0; a < arrayUniqueByKey.length; a++) {
    //subcategory 1
    const categories = [];
    for (let b = 0; b < json.length; b++) {
      if (arrayUniqueByKey[a].category === json[b].category) {
        categories.push({ ...json[b], subMenuItems: [] });
      }
    }
    const arrayUniqueBySubCategory1 = [
      ...new Map(
        categories.map((item) => [
          item['subcategory1'],
          {
            text: item.subcategory1,
            value: item.subcategory1 + '-' + item.category,
            category: item.category,
            subMenuItems: item.subMenuItems,
          },
        ])
      ).values(),
    ]; // qunique subcategory
    arrayCategoryList.push({
      text: arrayUniqueByKey[a].category,
      value: arrayUniqueByKey[a].category,
      subMenuItems: arrayUniqueBySubCategory1,
    });
  }
  for (let a = 0; a < arrayCategoryList.length; a++) {
    //subcategory 2
    for (let b = 0; b < arrayCategoryList[a].subMenuItems.length; b++) {
      const categories = [];
      for (let c = 0; c < json.length; c++) {
        if (
          arrayCategoryList[a].subMenuItems[b].text === json[c].subcategory1 &&
          arrayCategoryList[a].subMenuItems[b].category === json[c].category
        ) {
          if (json[c].subcategory2 != 'NA') {
            categories.push({ text: json[c].subcategory2, value: json[c].subcategory2 });
          }
        }
      }
      arraySubCategoryList.push(...categories);
    }
  }
  return arraySubCategoryList;
};
export const createDropDownCategoryHierarchy = (json) => {
  const arrayUniqueByKey = [...new Map(json.map((item) => [item['category'], item])).values()]; //qunique category
  const arrayCategoryList = [];
  for (let a = 0; a < arrayUniqueByKey.length; a++) {
    //subcategory 1
    const categories = [];
    for (let b = 0; b < json.length; b++) {
      if (arrayUniqueByKey[a].category === json[b].category) {
        categories.push({ ...json[b], subMenuItems: [] });
      }
    }
    const arrayUniqueBySubCategory1 = [
      ...new Map(
        categories.map((item) => [
          item['subcategory1'],
          {
            text: item.subcategory1,
            value: item.subcategory1 + '-' + item.category,
            category: item.category,
            subMenuItems: item.subMenuItems,
          },
        ])
      ).values(),
    ]; // qunique subcategory
    arrayCategoryList.push({
      text: arrayUniqueByKey[a].category,
      value: arrayUniqueByKey[a].category,
      subMenuItems: arrayUniqueBySubCategory1,
    });
  }
  for (let a = 0; a < arrayCategoryList.length; a++) {
    //subcategory 2
    for (let b = 0; b < arrayCategoryList[a].subMenuItems.length; b++) {
      const categories = [];
      for (let c = 0; c < json.length; c++) {
        if (
          arrayCategoryList[a].subMenuItems[b].text === json[c].subcategory1 &&
          arrayCategoryList[a].subMenuItems[b].category === json[c].category
        ) {
          categories.push({
            text: json[c].subcategory2,
            value: json[c].subcategory2 + '-' + json[c].subcategory1 + '-' + json[c].category,
          });
        }
      }
      arrayCategoryList[a].subMenuItems[b].subMenuItems = categories;
    }
  }
  return arrayCategoryList;
};
export const createCategoryHierarchy = (json) => {
  const arrayUniqueByKey = [...new Map(json.map((item) => [item['category'], item])).values()]; //qunique category

  const arrayCategoryList = [];

  for (let a = 0; a < arrayUniqueByKey.length; a++) {
    //subcategory 1
    const categories = [];
    for (let b = 0; b < json.length; b++) {
      if (arrayUniqueByKey[a].category === json[b].category) {
        categories.push({ ...json[b], categories: [] });
      }
    }
    const arrayUniqueBySubCategory1 = [...new Map(categories.map((item) => [item['subcategory1'], item])).values()]; // qunique subcategory 1
    arrayCategoryList.push({ ...arrayUniqueByKey[a], categories: arrayUniqueBySubCategory1, type: 'main' });
  }

  for (let a = 0; a < arrayCategoryList.length; a++) {
    //subcategory 2
    for (let b = 0; b < arrayCategoryList[a].categories.length; b++) {
      const categories = [];
      for (let c = 0; c < json.length; c++) {
        if (
          arrayCategoryList[a].categories[b].subcategory1 === json[c].subcategory1 &&
          arrayCategoryList[a].categories[b].category === json[c].category
        ) {
          categories.push({ ...json[c], type: 'sub2' });
        }
      }
      const getCalculatedValues = getCategoryData(categories);
      arrayCategoryList[a].categories[b].categories = categories;
      arrayCategoryList[a].categories[b].monthly_avg_clicks = getCalculatedValues.monthly_avg_clicks;
      arrayCategoryList[a].categories[b].monthly_avg_clicks_percentage =
        getCalculatedValues.monthly_avg_clicks_percentage;
      arrayCategoryList[a].categories[b].monthly_avg_impressions = getCalculatedValues.monthly_avg_impressions;
      arrayCategoryList[a].categories[b].monthly_avg_impressions_percentage =
        getCalculatedValues.monthly_avg_impressions_percentage;
      arrayCategoryList[a].categories[b].monthly_avg_paid_clicks_percentage =
        getCalculatedValues.monthly_avg_paid_clicks_percentage;
      arrayCategoryList[a].categories[b].monthly_avg_paid_impressions_percentage =
        getCalculatedValues.monthly_avg_paid_impressions_percentage;
      arrayCategoryList[a].categories[b].monthly_avg_paid_clicks = getCalculatedValues.monthly_avg_paid_clicks;
      arrayCategoryList[a].categories[b].monthly_avg_paid_impressions =
        getCalculatedValues.monthly_avg_paid_impressions;
      arrayCategoryList[a].categories[b].no_of_pages = getCalculatedValues.no_of_pages;
    }
  }
  for (let index = 0; index < arrayCategoryList.length; index++) {
    // all data calculation with subcategory1 and subcategory2
    const getCalculatedValues = getCategoryData(arrayCategoryList[index].categories);
    arrayCategoryList[index].monthly_avg_clicks = getCalculatedValues.monthly_avg_clicks;
    arrayCategoryList[index].monthly_avg_clicks_percentage = getCalculatedValues.monthly_avg_clicks_percentage;
    arrayCategoryList[index].monthly_avg_impressions = getCalculatedValues.monthly_avg_impressions;
    arrayCategoryList[index].monthly_avg_impressions_percentage =
      getCalculatedValues.monthly_avg_impressions_percentage;
    arrayCategoryList[index].monthly_avg_paid_clicks_percentage =
      getCalculatedValues.monthly_avg_paid_clicks_percentage;
    arrayCategoryList[index].monthly_avg_paid_impressions_percentage =
      getCalculatedValues.monthly_avg_paid_impressions_percentage;
    arrayCategoryList[index].monthly_avg_paid_clicks = getCalculatedValues.monthly_avg_paid_clicks;
    arrayCategoryList[index].monthly_avg_paid_impressions = getCalculatedValues.monthly_avg_paid_impressions;
    arrayCategoryList[index].no_of_pages = getCalculatedValues.no_of_pages;
  }
  // console.log("unique22222222121", arrayCategoryList)
  return arrayCategoryList;
};

const getCategoryData = (categoryArray) => {
  const category = {
    monthly_avg_clicks: categoryArray.reduce((a, b) => +a + +b.monthly_avg_clicks, 0),
    monthly_avg_clicks_percentage: categoryArray.reduce((a, b) => +a + +b.monthly_avg_clicks_percentage, 0),
    monthly_avg_impressions: categoryArray.reduce((a, b) => +a + +b.monthly_avg_impressions, 0),
    monthly_avg_impressions_percentage: categoryArray.reduce((a, b) => +a + +b.monthly_avg_impressions_percentage, 0),
    monthly_avg_paid_clicks: categoryArray.reduce((a, b) => +a + +b.monthly_avg_paid_clicks, 0),
    monthly_avg_paid_clicks_percentage: categoryArray.reduce((a, b) => +a + +b.monthly_avg_paid_clicks_percentage, 0),
    monthly_avg_paid_impressions: categoryArray.reduce((a, b) => +a + +b.monthly_avg_paid_impressions, 0),
    monthly_avg_paid_impressions_percentage: categoryArray.reduce(
      (a, b) => +a + +b.monthly_avg_paid_impressions_percentage,
      0
    ),
    no_of_pages: categoryArray.reduce((a, b) => +a + +b.no_of_pages, 0),
  };
  return category;
};

export const replaceSpecialCharacters = (str) => {
  const replacelist = [
    { replace: /&gt;/g, with: '>' },
    { replace: /&lt;/g, with: '<' },
    { replace: /&amp;/g, with: '&' },
  ];

  replacelist?.forEach((item) => {
    str = str?.replace(item?.replace, item?.with);
  });
  return str;
};

export const resolvePreviewMetaUrls = (htmlContent, baseUrl) => {
  if (!htmlContent || typeof htmlContent !== 'string') {
    console.error('Invalid HTML content provided.');
    return htmlContent;
  }

  if (!baseUrl || typeof baseUrl !== 'string') {
    console.error('Invalid base URL provided.');
    return htmlContent;
  }

  try {
    const doc = new DOMParser().parseFromString(htmlContent, 'text/html');
    if (!doc) {
      console.error('Failed to parse HTML content.');
      return htmlContent;
    }
    const urlAttributes = {
      link: ['href'],
      script: ['src'],
      img: ['src', 'srcset'],
      a: ['href'],
      iframe: ['src'],
      source: ['src', 'srcset'],
      video: ['src', 'poster'],
      audio: ['src'],
      track: ['src'],
      embed: ['src'],
      object: ['data'],
    };

    Object.entries(urlAttributes).forEach(([tag, attributes]) => {
      const elements = doc.getElementsByTagName(tag);
      for (const element of elements) {
        attributes.forEach((attr) => {
          if (element[attr] && typeof element[attr] === 'string' && !element[attr].startsWith('http')) {
            try {
              element[attr] = new URL(element[attr], baseUrl).href;
            } catch (error) {
              console.warn(`Failed to resolve ${attr} for ${tag} element:`, error);
            }
          }
          if (attr === 'srcset' && element[attr]) {
            try {
              const srcset = element[attr]
                .split(',')
                .map((src) => {
                  const [url, descriptor] = src.trim().split(' ');
                  if (!url.startsWith('http')) {
                    return `${new URL(url, baseUrl).href}${descriptor ? ` ${descriptor}` : ''}`;
                  }
                  return src;
                })
                .join(', ');
              element[attr] = srcset;
            } catch (error) {
              console.warn(`Failed to resolve srcset for ${tag} element:`, error);
            }
          }
        });
      }
    });
    const updatedHtml = new XMLSerializer().serializeToString(doc);
    if (!updatedHtml) {
      console.error('Failed to serialize updated HTML content.');
      return htmlContent;
    }
    return updatedHtml;
  } catch (error) {
    console.error('Unexpected error in resolvePreviewMetaUrls:', error?.message);
    return htmlContent;
  }
};

export const mapPaidAndOrgData = (crListData = []) => {
  let orgData = [],
    paidData = [];

  crListData.forEach((crData) => {
    const dataSource = crData?.data_source ? crData?.data_source.toUpperCase() : null;
    const updated_date = crData?.pageUpdatedInfo?.date || crData?.created_date || crData?.created_on;
    const { id, ...rest } = crData;
    const orgCrData = { ...rest, data_source: 'ORG', cr_list_id: uuidv4(), updated_date };
    const paidCrData = { ...rest, data_source: 'PAID', cr_list_id: uuidv4(), updated_date };
    if (dataSource === 'ORG & PAID') {
      orgData.push(orgCrData);
      paidData.push(paidCrData);
    } else if (dataSource === 'ORG') {
      orgData.push({ ...rest, data_source: 'ORG', cr_list_id: uuidv4(), updated_date });
    } else if (dataSource === 'PAID') {
      paidData.push({ ...rest, data_source: 'PAID', cr_list_id: uuidv4(), updated_date });
    }
  });

  orgData = sortArrayByKey(orgData, 'desc', 'updated_date');
  paidData = sortArrayByKey(paidData, 'desc', 'updated_date');

  return [...orgData, ...paidData];
};

export const isKFormatedValue = (kformattedNumber) => {
  return (
    /\d/.test(kformattedNumber) &&
    /[a-zA-Z]/.test(kformattedNumber) &&
    (kformattedNumber.charAt(kformattedNumber.length - 1) === 'K' ||
      kformattedNumber.charAt(kformattedNumber.length - 1) === 'B' ||
      kformattedNumber.charAt(kformattedNumber.length - 1) === 'M')
  );
};

export function reversKFormatter(val) {
  const multiplier = val.substr(-1).toLowerCase();
  if (multiplier === 'k') return parseFloat(val) * 1000;
  else if (multiplier === 'm') return parseFloat(val) * 1000000;
  else if (multiplier === 'b') return parseFloat(val) * 1000000000;
}

export const showSortingIcons = (isActive, order) => {
  const isAsc = order === 'asc';
  const isDesc = order === 'desc';
  return (
    <div className="flex-column shorting-icons">
      <ArrowDropUpIcon style={{ display: isActive ? (isAsc ? 'block' : 'none') : 'block' }} />
      <ArrowDropDownIcon style={{ display: isActive ? (isDesc ? 'block' : 'none') : 'block' }} />
    </div>
  );
};

export const removeValueFromArray = (arrayList = [], value) => {
  const index = arrayList?.indexOf(value);
  if (index > -1) {
    // only splice array when item is found
    arrayList.splice(index, 1); // 2nd parameter means remove one item only
  }
  return arrayList;
};

export const htmlToJson = (htmlString) => {
  const parser = new DOMParser();
  const htmlDoc = parser.parseFromString(htmlString, 'text/html');

  function nodeToJson(node) {
    const json = {
      tag: node.tagName,
      attributes: {},
      children: [],
    };
    for (let i = 0; i < node.attributes.length; i++) {
      const attribute = node.attributes[i];
      json.attributes[attribute.name] = attribute.value;
    }
    for (let i = 0; i < node.childNodes.length; i++) {
      const childNode = node.childNodes[i];
      if (childNode.nodeType === 1) {
        json.children.push(nodeToJson(childNode));
      } else if (childNode.nodeType === 3) {
        const text = childNode.nodeValue;
        if (text.trim().length > 0) {
          json.children.push(text);
        }
      }
    }
    return json;
  }

  return nodeToJson(htmlDoc.body);
};

export const jsonToHtml = (jsonObj) => {
  const tag = jsonObj.tag;
  const attributes = jsonObj.attributes || {};
  const children = jsonObj.children || [];

  const attrsStr = Object.entries(attributes)
    .map(([k, v]) => `${k}="${v}"`)
    .join(' ');

  const childrenStr = children.map((child) => (typeof child === 'string' ? child : jsonToHtml(child))).join('');
  if (tag === 'HEAD') {
    return `<${tag} ${attrsStr}>${childrenStr}</${tag}>`;
  } else if (tag === 'BODY') {
    return childrenStr;
  } else if (tag?.toUpperCase() === 'BR' || tag?.toUpperCase() === ' BR') {
    return `<${tag} ${attrsStr}>${childrenStr}`; // do not close br tag i.e <br></br> as tinyMce automatically will convert closing br i.e</br>  to <br> so its increase the counts
  } else {
    return `<${tag} ${attrsStr}>${childrenStr}</${tag}>`;
  }
};

export const fetchHeadingAndUrl = (data, creatingPageFrom) => {
  let pageHeading = '';
  let pageUrl = '';
  let existingPageURL = data?.pageUrl || '';
  if (existingPageURL && existingPageURL.endsWith('/')) {
    existingPageURL = existingPageURL.slice(0, -1);
  }
  const pathname = new URL(existingPageURL).pathname; // Get the path portion of the URL
  const folders = pathname.split('/'); // Split the path by "/"
  folders.shift();
  folders.pop();
  const finalFolders = folders;
  const lengthExisting = data?.selectedRowDataForPageCreation.length;
  if (lengthExisting > 0) {
    if (lengthExisting === 1) {
      const keyword =
        creatingPageFrom === CREATE_NEW_PAGE_USING.FROM_KEYWORD_GAP
          ? data?.selectedRowDataForPageCreation[0]?.['Keyword Cluster']?.props?.clusterName
          : data?.selectedRowDataForPageCreation[0]?.['Keyword Cluster'];
      const heading = keyword ? keyword[0].toUpperCase() + keyword.slice(1) : '';
      const urlEnd = keyword?.toLowerCase()?.split(' ')?.join('-');
      pageHeading = heading;
      pageUrl = finalFolders.length ? finalFolders.join('/') + '/' + urlEnd : urlEnd;
    } else {
      // eslint-disable-next-line
      const arrayKeyword = data?.selectedRowDataForPageCreation;
      const sortedKeyword = sortArrayByKey(
        arrayKeyword,
        'desc',
        creatingPageFrom === CREATE_NEW_PAGE_USING.FROM_KEYWORD_GAP ? 'keyword_importance' : 'Keyword Importance'
      );
      const keyword =
        creatingPageFrom === CREATE_NEW_PAGE_USING.FROM_KEYWORD_GAP
          ? sortedKeyword[0]?.['Keyword Cluster']?.props?.clusterName
          : sortedKeyword[0]?.['Keyword Cluster'];
      const heading = keyword ? keyword[0].toUpperCase() + keyword.slice(1) : '';
      const urlEnd = keyword?.toLowerCase()?.split(' ')?.join('-');
      pageHeading = heading;
      pageUrl = finalFolders.length ? finalFolders.join('/') + '/' + urlEnd : urlEnd;
    }
  }
  return { pageHeading, pageUrl };
};

export const getCRFilterData = () => {
  //get CR filter data
  if (typeof sessionStorage !== 'undefined' || typeof localStorage !== 'undefined') {
    const data =
      sessionStorage.getItem(`contentrecommendation-listpage-filters`) ||
      localStorage.getItem(`contentrecommendation-listpage-filters`);

    const parsedData = safelyParse(data);
    const date1 = new Date(parsedData?.savedOn);
    const date2 = new Date('2023-07-31'); //// YY-MM-DD check new release data here
    if (date1 < date2) {
      //// THIS IS HANDLE OR USEFULL WHEN WE CHANGED OR ADDED SOMETHING NEW INSIDE STORING DATA, so delete old storage from user browser
      localStorage.removeItem('contentrecommendation-listpage-filters');
      sessionStorage.removeItem(`contentrecommendation-listpage-filters`);
      localStorage.removeItem('content-recommendations-urls');
    }
    return (
      parsedData?.filterdata || {
        filterdata: { domain: [], category: [], status: [], intent: [], page: [], createdby: [] },
      }
    );
  }
};
export const setCRFilterData = (filterdata) => {
  //set CR filter data
  const stringifiedFiltersData = JSON.stringify({
    savedOn: new Date(),
    filterdata,
  });
  if (typeof sessionStorage !== 'undefined' || typeof localStorage !== 'undefined') {
    sessionStorage.setItem(`contentrecommendation-listpage-filters`, stringifiedFiltersData);
    localStorage.setItem(`contentrecommendation-listpage-filters`, stringifiedFiltersData);
  } else {
    localStorage.setItem(`contentrecommendation-listpage-filters`, stringifiedFiltersData);
  }
};

export const isValidUrl = (url) => {
  const isValid =
    /^(?:(?:(?:https?|ftp):)?\/\/)(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:[/?#]\S*)?$/i.test(
      url
    );
  return isValid;
};

export const getDomainFromUrl = (url) => {
  const hostname = new URL(url).hostname;
  return hostname.startsWith('www.') ? hostname.slice(4) : hostname;
};

export const urlValidation = (listFields = [], validationFor = 'competitor') => {
  const errors = listFields.map((listField, index) => {
    // Check if the current URL is valid
    if (!isValidUrl(listField)) {
      return `Please enter a valid ${validationFor} URL in the format https://www.example.com.`;
    }

    // Check if any other URL in the list has the same domain as the current URL
    const currentDomain = getDomainFromUrl(listField);
    for (let i = 0; i < listFields.length; i++) {
      if (i !== index && isValidUrl(listFields[i])) {
        const domain = getDomainFromUrl(listFields[i]);
        if (currentDomain === domain) {
          return `Please enter a unique ${validationFor} URL`;
        }
      }
    }

    return '';
  });

  let hasError = false;
  if (errors.some((error) => error?.trim() != '')) {
    console.error('AddFeilds::urlValidation::errors', errors);
    hasError = true;
  }

  return {
    errorsList: errors,
    hasError: hasError,
  };
};

export const duplicateRecords = (listFields = [], validationFor = 'keyword') => {
  const errors = listFields.map((listField, index) => {
    // Check if any other text in the list has the same text as the current text
    const currentText = listField?.toLowerCase();
    for (let i = 0; i < listFields.length; i++) {
      if (i !== index) {
        const otherText = listFields[i]?.toLowerCase();
        if (currentText === otherText) {
          return `Please enter a unique ${validationFor}`;
        }
      }
    }
    return '';
  });
  let hasError = false;
  if (errors.some((error) => error?.trim() != '')) {
    console.error('AddFeilds::urlValidation::errors', errors);
    hasError = true;
  }
  return {
    errorsList: errors,
    hasError: hasError,
  };
};

export const resetCaptcha = () => {
  try {
    if (window.grecaptcha) {
      window.grecaptcha.reset();
    }
  } catch (error) {
    // do nothing if captcha is not present
  }
};

export function processSubscriptionData(data) {
  try {
    const subscriptionDetails = data.SubscriberUserDetails;
    const customer = subscriptionDetails.customer;
    const subscription =
      subscriptionDetails.subscriptions.find((sub) => sub.status !== 'cancelled') ||
      subscriptionDetails.subscriptions[0];

    // Flags initialization
    let isInTrial = false;
    let trialDaysRemaining = 0;
    let hasCardAdded = false;
    let isSubscriptionCancelled = false;
    let subscriptionPlan = '';
    let pricing = undefined;
    let billingPeriod = '';
    let customer_id = '';

    // Check if the subscription is in trial
    if (subscription?.status === 'in_trial') {
      isInTrial = true;
      const currentDate = new Date();
      // Convert the current date to UTC
      const currentUTCDate = new Date(
        Date.UTC(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate())
      );

      const trialEndDate = new Date(subscription.trial_end * 1000); // Convert UNIX timestamp to Date
      // Convert trial end date to UTC
      const trialEndUTCDate = new Date(
        Date.UTC(trialEndDate.getFullYear(), trialEndDate.getMonth(), trialEndDate.getDate())
      );

      trialDaysRemaining = Math.ceil((trialEndUTCDate - currentUTCDate) / (1000 * 60 * 60 * 24));
    }

    // Check if a card has been added
    if (customer?.card_status !== 'no_card') {
      hasCardAdded = true;
    }

    // Check if the subscription is cancelled
    if (subscription?.status === 'cancelled' || subscription?.status === 'paused') {
      isSubscriptionCancelled = true;
    }

    if (subscription?.subscription_items) {
      pricing = subscription?.subscription_items[0]?.unit_price / 100;
      subscriptionPlan = (subscription?.subscription_items[0]?.item_price_id || '').split('-')[0] || '';
      billingPeriod = subscription.billing_period_unit;
    }
    if (customer) {
      customer_id = customer.id;
    }
    return {
      isInTrial,
      trialDaysRemaining,
      hasCardAdded,
      isSubscriptionCancelled,
      pricing,
      subscriptionPlan,
      billingPeriod,
      customer_id,
    };
  } catch (error) {
    console.log('error in processing subscription data');
  }
}

export const _RESOLUTION_ENTITY_TYPE = RESOLUTION_ENTITY_TYPE; // to avoide circular dependancy i have added here to use this constant from this file to another

export const getTopicsDataFormated = (mappedTopicsData) => {
  let pageLevelTopicArray = mappedTopicsData.pageLevelTopicsData || [];

  return pageLevelTopicArray;
};

export const parsedJSONLDData = (parsedResult = [], jsonldElements) => {
  parsedResult = [...parsedResult.filter((n) => n)];
  let type;
  parsedResult.forEach((obj) => {
    type = obj['@type'];
    if (obj['@graph'] && parsedResult.length == 1) {
      this.parsedJSONLDData(obj['@graph'], jsonldElements);
    } else if (type == 'FAQPage') {
      obj.mainEntity &&
        isArray(obj.mainEntity) &&
        obj.mainEntity.forEach((eleObj) => {
          if (eleObj) {
            jsonldElements.push({
              id: eleObj.id,
              '@type': eleObj['@type'],
              description: eleObj.name,
              parentType: type,
            });

            if (eleObj.acceptedAnswer) {
              jsonldElements.push({
                id: eleObj.acceptedAnswer.id,
                '@type': eleObj.acceptedAnswer['@type'],
                description: eleObj.acceptedAnswer.text,
              });
            }
          }
        });
    } else if (type == 'Question') {
      if (obj) {
        jsonldElements.push({
          id: obj.id,
          '@type': obj['@type'],
          description: obj.name,
          parentType: null,
        });

        if (obj.acceptedAnswer) {
          jsonldElements.push({
            id: obj.acceptedAnswer.id,
            '@type': obj.acceptedAnswer['@type'],
            description: obj.acceptedAnswer.text,
          });
        }
      }
    } else if (type == 'BreadcrumbList') {
      obj.itemListElement &&
        isArray(obj.itemListElement) &&
        obj.itemListElement.forEach((eleObj, i) => {
          if (eleObj && eleObj.item) {
            jsonldElements.push({
              id: eleObj.id,
              '@type': eleObj['@type'],
              description: eleObj.item.name,
              name: eleObj.item['@id'],
              parentType: i == 0 ? type : null,
            });
          }
        });
    } else if (type == 'Product') {
      if (obj) {
        jsonldElements.push({
          id: obj.id,
          '@type': type,
          description: obj.description,
          name: obj.name,
          rating: obj.aggregateRating && obj.aggregateRating.ratingValue ? obj.aggregateRating.ratingValue : null,
        });

        obj.review &&
          isArray(obj.review) &&
          obj.review.forEach((eleObj, i) => {
            jsonldElements.push({
              id: eleObj.id,
              '@type': eleObj['@type'],
              description: eleObj.description,
              name: eleObj.author,
              rating: eleObj.reviewRating && eleObj.reviewRating.ratingValue ? eleObj.reviewRating.ratingValue : null,
              parentType: i == 0 ? type : null,
            });
          });
      }
    } else if (type && obj) {
      const { name, text } = this.getDayKey(type);

      jsonldElements.push({
        id: obj.id,
        '@type': type,
        name: obj[name],
        description: obj[text],
      });
    }
  });
};

export const combineLiveandImprovedHtml = (dataArr, dbData, parseJSONLD) => {
  const outputResultArr = [],
    multiValueTags = [
      'title',
      'description',
      'h1',
      'h2',
      'h3',
      'h4',
      'h5',
      'h6',
      'images',
      'links',
      'jsonld',
      'p',
      'div',
      'li',
      'span',
      'pre',
      'label',
    ];

  let genericData = dataArr;

  let tempObj = {};
  let parsedResult;
  let key;
  let parsedObj;
  let dbMatchedRecord;
  let id;
  let duplicateHtmlElementIds;
  let tagDataArr = [];

  let dataObj = genericData;
  tempObj = {};
  tempObj.uuid = dataObj.uuid;
  tempObj.created_at = dataObj.created_at;
  tempObj.url = dataObj.url;
  tempObj.s3_key = dataObj.s3_key;
  tempObj.s3_object_url = dataObj.s3_object_url;

  multiValueTags.forEach((tag) => {
    tagDataArr = [];

    duplicateHtmlElementIds = (dataObj.html_template && JSON.parse(dataObj.html_template)[tag.toUpperCase()]) || [];

    parsedResult = ['title', 'description'].includes(tag)
      ? dataObj[tag]
        ? dataObj[tag]
        : []
      : dataObj[tag]
      ? dataObj[tag]
      : [];

    if (tag == 'jsonld') {
      if (parseJSONLD) {
        const outputArr = [];
        parsedJSONLDData(parsedResult, outputArr);
        parsedResult = outputArr;
      } else {
        parsedResult = (parsedResult && parsedResult[0] && parsedResult[0]['@graph']) || [];
      }
    }

    parsedResult = parsedResult.filter((o) => !duplicateHtmlElementIds.includes(o.id));

    parsedResult = parsedResult.map((o) => {
      if (duplicateHtmlElementIds.includes(o.id)) {
        o.is_duplicate = true;
      } else {
        o.is_duplicate = false;
      }
      return o;
    });

    const getTagText = (tag, obj) => {
      switch (tag) {
        case 'images':
          return 'alt';
        case 'jsonld':
          return 'description';
        default:
          return 'text';
      }
    };
    parsedResult.forEach((v) => {
      key = getTagText(tag, v);
      id = v && v.id ? v.id : '';
      dbMatchedRecord = dbData.find((d) => d.element_id == id);
      let updatedInfo = {};
      if (dbMatchedRecord) {
        updatedInfo = {
          created_on: dbMatchedRecord.created_on,
          updated_on: dbMatchedRecord.updated_on,
          created_by: dbMatchedRecord.created_by,
          updated_by: dbMatchedRecord.updated_by,
        };
      }
      if (!(['p', 'div', 'li', 'pre', 'label', 'span'].includes(tag) && !v[key])) {
        const siblingsData =
          v.siblingIds && v.siblingIds.length ? v.siblingIds : v.siblings && v.siblings.length ? v.siblings : [];
        tagDataArr.push({
          param: tag,
          id: id,
          text: v[key],
          siblings: siblingsData,
          is_duplicate: v.is_duplicate,
          cr_topic_id: dbMatchedRecord && dbMatchedRecord.cr_topic_id,
          url: tag == 'images' ? v.src : v.href,
          modified_data: dbMatchedRecord && dbMatchedRecord.data,
          structured_data: v.name,
          markup_attribute: v['@type'],
          parent_type: v['parentType'],
          rating: v.rating,
          ...updatedInfo,
        });
      }
    });

    tempObj[tag] = tagDataArr;
  });
  outputResultArr.push({
    ...tempObj,
  });

  let suggestedCopy = dbData.filter((d) => d.is_suggested_copy == true);
  for (let i = 0; i < suggestedCopy.length; i++) {
    let obj = {
      id: suggestedCopy[i]?.element_id,
      text: suggestedCopy[i]?.data.value,
      data: suggestedCopy[i]?.data,
      isSuggested: true,
      siblings: suggestedCopy[i]?.data?.siblings ? JSON.parse(suggestedCopy[i].data.siblings) : [],
      updated_by: suggestedCopy[i]?.updated_by,
      updated_on: suggestedCopy[i]?.updated_on,
      created_by: suggestedCopy[i]?.created_by,
      created_on: suggestedCopy[i]?.created_on,
    };

    if (suggestedCopy[i].element_tag == 'H1') {
      obj = { param: 'h1', ...obj };

      outputResultArr[0]['h1'] = [...outputResultArr[0]['h1'], obj];
    }
    if (suggestedCopy[i].element_tag == 'Title') {
      obj = { param: 'title', ...obj };

      outputResultArr[0]['title'] = [...outputResultArr[0]['title'], obj];
    }
    if (suggestedCopy[i].element_tag == 'Meta Description') {
      obj = { param: 'description', ...obj };

      outputResultArr[0]['description'] = [...outputResultArr[0]['description'], obj];
    }
    if (suggestedCopy[i]?.element_tag == 'H2') {
      obj = { param: 'h2', ...obj };

      outputResultArr[0]['h2'] = [...outputResultArr[0]['h2'], obj];
    }
    if (suggestedCopy[i].element_tag == 'H3') {
      obj = { param: 'h3', ...obj };

      outputResultArr[0]['h3'] = [...outputResultArr[0]['h3'], obj];
    }
    if (suggestedCopy[i].element_tag == 'H4') {
      obj = { param: 'h4', ...obj };

      outputResultArr[0]['h4'] = [...outputResultArr[0]['h4'], obj];
    }
    if (suggestedCopy[i].element_tag == 'H5') {
      obj = { param: 'h5', ...obj };

      outputResultArr[0]['h5'] = [...outputResultArr[0]['h5'], obj];
    }
    if (suggestedCopy[i].element_tag == 'H6') {
      obj = { param: 'h6', ...obj };

      outputResultArr[0]['h6'] = [...outputResultArr[0]['h6'], obj];
    }
    if (suggestedCopy[i].element_tag == 'p') {
      obj = { param: 'p', ...obj };

      outputResultArr[0]['p'] = [...outputResultArr[0]['p'], obj];
    }
    if (suggestedCopy[i].element_tag == 'div') {
      obj = { param: 'div', ...obj };

      outputResultArr[0]['div'] = [...outputResultArr[0]['div'], obj];
    }
    if (suggestedCopy[i].element_tag == 'pre') {
      obj = { param: 'pre', ...obj };

      outputResultArr[0]['pre'] = [...outputResultArr[0]['pre'], obj];
    }
    if (suggestedCopy[i].element_tag == 'li') {
      obj = { param: 'li', ...obj };

      outputResultArr[0]['li'] = [...outputResultArr[0]['li'], obj];
    }
    if (suggestedCopy[i].element_tag == 'span') {
      obj = { param: 'span', ...obj };

      outputResultArr[0]['span'] = [...outputResultArr[0]['span'], obj];
    }
    if (suggestedCopy[i].element_tag == 'label') {
      obj = { param: 'label', ...obj };

      outputResultArr[0]['label'] = [...outputResultArr[0]['label'], obj];
    }
    if (suggestedCopy[i].element_tag == 'a') {
      obj = {
        param: 'links',
        id: suggestedCopy[i].element_id,
        url: suggestedCopy[i].data.url,
        ...obj,
      };
      outputResultArr[0]['links'] = [...outputResultArr[0]['links'], obj];
    }
  }

  return outputResultArr;
};

export const downloadDataAsExcel = (
  apiExcelData,
  value,
  exportEditedOnly,
  topBarDetails,
  isBrandedIncluded,
  resolvedRecommendation,
  implementationNote,
  implementationNoteDetails,
  session
) => {
  const topicsArr = [];
  const replaceNbsp = (elements) => {
    return (
      elements?.map((element) => {
        return { ...element, text: element?.text?.replaceAll('&nbsp;', ' ')?.replaceAll('&amp;', '&') };
      }) || []
    );
  };

  let topicDataArr = apiExcelData.live_topics_data || [];
  if (apiExcelData.projected_topics_content_quality_score[0]?.page_draft_topic_data) {
    topicDataArr = apiExcelData.projected_topics_content_quality_score[0]?.page_draft_topic_data;
  }

  const combinedTopicsData = getCombinedTopicsData({
    fetchedJSONData: topicDataArr,
    editedHtmlData: apiExcelData.improved_html,
    url: topBarDetails.url,
    contentQualityScores: apiExcelData.projected_topics_content_quality_score,
    getImprovedTopicDetails: apiExcelData.updated_topics_data,
  });

  const combinedHtmlData = combineLiveandImprovedHtml(
    apiExcelData.live_site_html_data[0],
    apiExcelData.improved_html,
    true
  );

  const mappedTopicsData = mappedPageLevelAndKeywordTopics(combinedTopicsData.TOPICS);

  const { tabData, allHTMLData } = formatAllTabData(combinedHtmlData[0]);
  let meta = tabData.META || [];
  let headings = tabData.HEADINGS || [];
  let links = tabData.LINKS || [];
  let images = tabData.IMAGES || [];
  let structuredData = tabData['STRUCTURED DATA'] || [];
  let body = tabData.BODY || [];

  try {
    if (mappedTopicsData) {
      mappedTopicsData.pageLevelTopicsData &&
        mappedTopicsData.pageLevelTopicsData.forEach((k) => {
          topicsArr.push({
            topic: k.TOPIC,
            my_emphasis: Math.ceil(k.TOPIC_EMPHASIS),
            market_emphasis: Math.ceil(k.COMPETITOR_EMPHASIS),
            rank: k.rank,
            note: '-',
            topic_importance: Math.ceil(k.TOPIC_IMPORTANCE),
            content: k.CONTENT,
          });
        });
    }

    const topicsData = topicsDataForExcel(getTopicsDataFormated, allHTMLData, mappedTopicsData, true);
    let finalTopicsdata = [];

    if (exportEditedOnly) {
      meta = replaceNbsp(meta.filter((o) => o.text_original || o.isSuggested));
      headings = replaceNbsp(headings.filter((o) => o.text_original || o.isSuggested));
      links = replaceNbsp(links.filter((o) => o.text_original || o.isSuggested));
      images = replaceNbsp(images.filter((o) => o.text_original || o.isSuggested || o.text));
      structuredData = replaceNbsp(structuredData.filter((o) => o.text_original || o.isSuggested));
      body = replaceNbsp(body.filter((o) => o.text_original || o.isSuggested));

      if (topicsData?.length) {
        topicsData.forEach((topic) => {
          const newTopicObject = {};
          newTopicObject.topic_id = topic.topic_id;
          newTopicObject.topic_name = topic.topic_name;
          newTopicObject.topic_importance_score = topic.topic_importance_score;
          newTopicObject.text_original = topic.text_original;
          newTopicObject.isSuggested = topic.isSuggested;
          newTopicObject.isEdited = topic.isEdited;
          const newHeadingArray = [];
          if (topic?.headings?.length) {
            topic.headings.forEach((heading) => {
              const bodyList = heading.body.filter((o) => o.updateStatus);
              const shouldAdd = bodyList?.length ? true : heading.updateStatus;
              if (shouldAdd) {
                const newHeadingObject = {};
                newHeadingObject.heading_tag = heading.heading_tag;
                newHeadingObject.heading_content = heading.heading_content;
                newHeadingObject.url = heading.url;
                newHeadingObject.text_original = heading.text_original;
                newHeadingObject.isSuggested = heading.isSuggested;
                newHeadingObject.isEdited = heading.isEdited;
                newHeadingObject.body = bodyList;
                newHeadingArray.push(newHeadingObject);
              }
            });
          }
          newTopicObject.headings = newHeadingArray;
          //Need to check
          if (newHeadingArray?.length) {
            finalTopicsdata.push(newTopicObject);
          }
        });
      }
    } else {
      finalTopicsdata = topicsData;
    }

    const obj = {
      recommendationId: value?.page_id,
      insight: topBarDetails.title,
      url: topBarDetails.url,
      current_alignment_score: isBrandedIncluded
        ? Math.floor(+value?.keyword_alignment_score)
        : Math.floor(+value?.non_branded_keyword_alignment_score),
      projected_alignment_score: isBrandedIncluded
        ? Math.floor(+value?.projected_keyword_alignment_score)
        : Math.floor(+value?.projected_non_branded_keyword_alignment_score),
      total_clicks: apiExcelData.overall_scores[0]['content_recommendations.monthly_clicks'],
      total_impressions: apiExcelData.overall_scores[0]['content_recommendations.monthly_impressions'],
      status:
        resolvedRecommendation && resolvedRecommendation[0]
          ? getPageStatusValue(resolvedRecommendation[0].reason)
          : 'NEW',
      meta: meta,
      headings: headings,
      links: links,
      images: images,
      structured_data: structuredData,
      body: body,
      implementationNote: implementationNote,
      ...implementationNoteDetails,
      topicsArr: topicsArr,
      tdmTopicsData: combinedTopicsData,
      topBarDetails: topBarDetails,
      currentCQScore: value?.content_quality_score,
      projectedCQScore: value?.projected_content_quality_score,
      avg_current_relavance_score: isBrandedIncluded
        ? Math.floor(+value?.keyword_alignment_score)
        : Math.floor(+value?.non_branded_keyword_alignment_score),
      avg_projected_relavance_score: isBrandedIncluded
        ? Math.floor(+value?.projected_keyword_alignment_score)
        : Math.floor(+value?.projected_non_branded_keyword_alignment_score),
      topicsData: finalTopicsdata,
      published_history_by: value?.user_full_name || '',
      published_history_at: value?.published_at ? format(new Date(value?.published_at), 'MM/dd/yyyy') : '',
    };
    const dateValue = format(new Date(value?.published_at), 'MM-dd-yyyy');
    exportAsExcel(obj, session, true, dateValue);
  } catch (err) {
    console.error('exportContentRecommendation : err', err);
  }
};

export const shortenUrl = (fullUrl, skip = false) => {
  return fullUrl?.length > 30 && !skip ? `${fullUrl.substring(0, 30)}...` : fullUrl;
};
export const customJSONParser = (data, requiredArray = false) => {
  let newData = data;
  if (!data) {
    return data;
  }
  try {
    newData = JSON.parse(data);
  } catch (err) {
    if (requiredArray && !isArray(data)) {
      newData = [];
    } else {
      newData = data;
    }
  }
  return newData;
};

export const getCombinedTopicsData = ({
  fetchedJSONData,
  editedHtmlData,
  url,
  contentQualityScores = [],
  getImprovedTopicDetails = [],
}) => {
  const updatedTopicsList = [];
  const updatedTdmData = {
    CREATED_AT: fetchedJSONData?.CREATED_AT,
    URL: fetchedJSONData.URL || null,
    TOPICS: [],
    contentQuality: { CURRENT: null, PROJECTED: null },
    contentQualityRaw: fetchedJSONData.CONTENT_QUALITY_RAW ? { ...fetchedJSONData.CONTENT_QUALITY_RAW } : null,
    contentUniqueness: fetchedJSONData.CONTENT_UNIQUENESS ? { ...fetchedJSONData.CONTENT_UNIQUENESS } : null,
    contentUniquenessRaw: fetchedJSONData.CONTENT_UNIQUENESS_RAW ? { ...fetchedJSONData.CONTENT_UNIQUENESS_RAW } : null,
  };

  if ('CREATED_AT' in fetchedJSONData && 'URL' in fetchedJSONData) {
    updatedTdmData.contentQuality = {
      CURRENT: { ...fetchedJSONData.CONTENT_QUALITY },
      PROJECTED: contentQualityScores.length ? { ...contentQualityScores[0].page_level_scores } : null, // TODO:: projected from our DB
    };
    const childElementIds = [];
    editedHtmlData.forEach((editedObj) => {
      if (editedObj?.data && editedObj?.data?.siblings) {
        const siblingsData = customJSONParser(editedObj.data.siblings, true);
        siblingsData.forEach((k) => childElementIds.push(k.id));
      }
    });

    const isValidScore = (score) => score >= 0 && score != null && score != undefined;
    if (fetchedJSONData.TOPICS && fetchedJSONData.TOPICS.length) {
      fetchedJSONData.TOPICS.forEach((topicData) => {
        const updatedTopicsData = {
          ...topicData,
        };
        const editedTopicDetails = getImprovedTopicDetails.find(
          (imporvedTopic) => imporvedTopic.id == topicData.TOPIC_ID
        );
        const matchedTopicEditedContents = editedHtmlData.filter(
          (editedData) =>
            editedData.cr_topic_id == topicData.TOPIC_ID && !childElementIds.includes(editedData.element_id)
        );
        let newHeadings = []; // for suggested
        matchedTopicEditedContents.forEach((editedHtml) => {
          if (editedHtml.is_suggested_copy === true && topicData.TOPIC_ID === editedHtml.cr_topic_id) {
            newHeadings.push({
              name: editedHtml.data.value,
              flag: 1,
              url,
              html_tag: editedHtml.element_tag,
              html_id: editedHtml.element_id,
            });
          }
        });
        const topicKeysList = Object.keys(topicData.TOPICS); // like=> page-level, keyword1, keyword2
        for (let keyWiseTopicData of topicKeysList) {
          if (topicData?.TOPICS?.[keyWiseTopicData]) {
            const updatedContents = [];
            const exitingContents = topicData?.TOPICS?.[keyWiseTopicData]?.CONTENT || [];
            const topicAllContents = newHeadings.length ? [...exitingContents, ...newHeadings] : exitingContents;
            topicAllContents.forEach((tc) => {
              const updatedTc = { ...tc };
              const findEditedTc = matchedTopicEditedContents.find((editedHtml) => {
                return editedHtml.element_id === tc.html_id;
              });
              if (findEditedTc) {
                updatedTc.name = findEditedTc.data.value;
              }
              if (isValidScore(editedTopicDetails?.sentences_per_elements?.[tc.html_id])) {
                updatedTc.num_sents = editedTopicDetails.sentences_per_elements[tc.html_id];
              }
              updatedContents.push(updatedTc);
            });
            if (updatedTopicsData.TOPICS[keyWiseTopicData]) {
              updatedTopicsData.TOPICS[keyWiseTopicData].CONTENT = updatedContents;
            } else {
              updatedTopicsData.TOPICS[keyWiseTopicData] = {
                CONTENT: updatedContents,
              };
            }

            if (isValidScore(editedTopicDetails?.number_of_sentences)) {
              updatedTopicsData.TOPICS[keyWiseTopicData].NUM_SENTS_CUSTOMER = editedTopicDetails.number_of_sentences;
              updatedTopicsData.TOPICS[keyWiseTopicData].NUM_SENTS =
                editedTopicDetails.number_of_sentences +
                updatedTopicsData.TOPICS[keyWiseTopicData].NUM_SENTS_COMPETITORS;
            }

            if (isValidScore(editedTopicDetails?.topic_importance?.[keyWiseTopicData])) {
              updatedTopicsData.TOPICS[keyWiseTopicData].TOPIC_IMPORTANCE =
                editedTopicDetails.topic_importance[keyWiseTopicData];
            }
            if (isValidScore(editedTopicDetails?.topic_importance_raw?.[keyWiseTopicData])) {
              updatedTopicsData.TOPICS[keyWiseTopicData].TOPIC_IMPORTANCE_RAW =
                editedTopicDetails.topic_importance_raw[keyWiseTopicData];
            }
          }
        }
        updatedTopicsList.push(updatedTopicsData);
      });
    }
    updatedTdmData.TOPICS = updatedTopicsList;
  }
  return updatedTdmData;
};

export const generateInitials = (name) => {
  // Split the name into words
  const words = name.split(' ');

  if (words.length === 1) {
    // If only one word, return the first two characters
    return name.slice(0, 2).toUpperCase();
  } else {
    // If more than one word, take the first character of the first two words
    return words
      .slice(0, 2)
      .map((word) => word[0].toUpperCase())
      .join('');
  }
};

export function toTitleCase(str = '') {
  return str?.toLowerCase().replace(/(?:^|\s|-)\w/g, function (match) {
    return match.toUpperCase();
  });
}
export const USER_CLASSIFICATION = {
  AI_SEO_SUITE: 'AI_SEO_SUITE',
  CONTENT_AI: 'CONTENT_AI',
  QWA_TOOLS: 'QWA_TOOLS',
};

export const chargebeeAiToolsPaidPlans = {
  dev: {
    STARTER_USD_MONTHLY: { id: 'Starter-USD-Monthly', price: 3.99 },
    STARTER_USD_YEARLY: { id: 'Starter-USD-Yearly', price: 39 },
    LITE_USD_MONTHLY: { id: 'Lite-USD-Monthly', price: 9.99 },
    LITE_USD_YEARLY: { id: 'Lite-USD-Yearly', price: 99 },
    PRO_USD_MONTHLY: { id: 'Quattr-Tools-Pro-USD-Monthly', price: 29.99 },
    PRO_USD_YEARLY: { id: 'Quattr-Tools-Pro-USD-Yearly', price: 299 },
    ULTRA_USD_MONTHLY: { id: 'Quattr-AI-tools-Ultra-USD-Monthly', price: 49.99 },
    ULTRA_USD_YEARLY: { id: 'Quattr-AI-tools-Ultra-USD-Yearly', price: 499 },
  },
  prod: {
    STARTER_USD_MONTHLY: { id: 'Quattr-AI-Tools-Starter-USD-Monthly', price: 3.99 },
    STARTER_USD_YEARLY: { id: 'Quattr-AI-Tools-Starter-USD-Yearly', price: 39 },
    LITE_USD_MONTHLY: { id: 'Quattr-AI-Tools-Lite-USD-Monthly', price: 9.99 },
    LITE_USD_YEARLY: { id: 'Quattr-AI-Tools-Lite-USD-Yearly', price: 99 },
    PRO_USD_MONTHLY: { id: 'Quattr-AI-Tools-Pro-USD-Monthly', price: 29.99 },
    PRO_USD_YEARLY: { id: 'Quattr-AI-Tools-Pro-USD-Yearly', price: 299 },
    ULTRA_USD_MONTHLY: { id: 'Quattr-AI-Tools-Ultra-USD-Monthly', price: 49.99 },
    ULTRA_USD_YEARLY: { id: 'Quattr-AI-Tools-Ultra-USD-Yearly', price: 499 },
  },
};

export const PAID_TOOLS_PROMPT_FOR = {
  TITLE_GENERATOR: 'PUBLIC_UTILITY.WRITE_TITLE_TAG',
  H1_HEADING_GENERATOR: 'PUBLIC_UTILITY.GENERATE_HEADINGS',
  SEO_FRIENDLY_URL_GENERATOR: 'PUBLIC_UTILITY.GENERATE_SEO_FRIENDLY_URL',
  META_DESCRIPTION_GENERATOR: 'PUBLIC_UTILITY.GENERATE_META_DESCRIPTIONS',
  PARAGRAPH_GENERATOR: 'PUBLIC_UTILITY.WRITE_PARAGRAPH',
  AI_TEXT_GENERATOR: 'PUBLIC_UTILITY.AI_TEXT_GENERATOR',
  PARAGRAPH_REWRITER: 'PUBLIC_UTILITY.REWRITE_PARA',
  CONTENT_BRIEF_GENERATOR: 'PUBLIC_UTILITY.CONTENT_BRIEF',
  PARAPHRASER: 'PUBLIC_UTILITY.PARAPHRASE_TEXT',
  SUMMARY_GENERATOR: 'PUBLIC_UTILITY.SUMMARIZE_TEXT',
  ACTIVE_PASSIVE_CONVETER: 'PUBLIC_UTILITY.CHANGE_VOICE',
  SETPWISE_INSTRUCTIONS_GENERATOR: 'PUBLIC_UTILITY.GENERATE_STEP_BY_STEP_INSTRUCTIONS',
  HEADING_REWRITER: 'PUBLIC_UTILITY.REWRITE_HEADING',
  DISCOVER_TOPICS: 'PUBLIC_UTILITY.DISCOVER_TOPICS',
  IMAGE_ALT_TEXT_GENERATOR: 'PUBLIC_UTILITY.GENERATE_ALT_TEXT',
  ANCHOR_TEXT_GENERATOR: 'PUBLIC_UTILITY.GENERATE_ANCHOR_TEXT',
  KEYWORD_RESEARCH_TOOL: 'DISCOVER_KEYWORDS.KEYWORDS_LIST',
  KEYWORD_STATISTICS: 'PUBLIC_UTILITY.GET_KEYWORD_STATS',
  CLUSTER_KEYWORDS: 'PUBLIC_UTILITY.CLUSTER_KEYWORDS',
};

export const getToolsUsageCreditsNeeded = (toolName, toolDetails) => {
  const premiumTones = ['Authoritative', 'Conversational', 'Persuasive', 'Business Formal', 'Creative / Descriptive'];
  const premiumContentBrief = [''];
  const premiumTempGroupBy = ['Entities', 'Entity Types', 'Brand Names', 'Number Of Words', 'Custom'];
  const premiumClusterKeyword = ['Landing Page H1', 'Entities', 'Brand Names'];
  switch (toolName) {
    // Grouping cases that return the same value based on toolDetails.noOf
    case PAID_TOOLS_PROMPT_FOR.TITLE_GENERATOR:
    case PAID_TOOLS_PROMPT_FOR.H1_HEADING_GENERATOR:
    case PAID_TOOLS_PROMPT_FOR.SEO_FRIENDLY_URL_GENERATOR:
    case PAID_TOOLS_PROMPT_FOR.META_DESCRIPTION_GENERATOR:
    case PAID_TOOLS_PROMPT_FOR.DISCOVER_TOPICS:
    case PAID_TOOLS_PROMPT_FOR.ANCHOR_TEXT_GENERATOR:
      return toolDetails?.noOf > 3 ? 2 : 1;

    // Case for alt text generator
    case PAID_TOOLS_PROMPT_FOR.IMAGE_ALT_TEXT_GENERATOR:
      return toolDetails?.noOf > 3 || toolDetails?.image_link ? 2 : 1;

    // Case with specific check for premium tones
    case PAID_TOOLS_PROMPT_FOR.PARAGRAPH_REWRITER:
      return premiumTones.includes(toolDetails?.tone) ? 2 : 1;

    // Case with specific checks for paragraph generator and ai text generator tool
    case PAID_TOOLS_PROMPT_FOR.PARAGRAPH_GENERATOR:
    case PAID_TOOLS_PROMPT_FOR.AI_TEXT_GENERATOR:
      return toolDetails?.isContinueWriting === true
        ? 1
        : premiumTones.includes(toolDetails?.tone)
        ? 2
        : toolDetails?.specialInstructions?.length > 0
        ? 2
        : toolDetails?.noOf > 5
        ? 2
        : 1;

    // Case with specific check for selected options content brief
    case PAID_TOOLS_PROMPT_FOR.CONTENT_BRIEF_GENERATOR:
      return toolDetails?.selectedOptions?.includes('images') ||
        toolDetails?.selectedOptions?.includes('schema') ||
        toolDetails?.targetAudience
        ? 4
        : 2;

    // Case with multiple conditions for keyword research tool
    case PAID_TOOLS_PROMPT_FOR.KEYWORD_RESEARCH_TOOL:
      return toolDetails.numKeywords > 50 || premiumTempGroupBy.includes(toolDetails.tempGroupBy) ? 4 : 2;

    // Simple return case
    case PAID_TOOLS_PROMPT_FOR.KEYWORD_STATISTICS:
      return 2;

    // Case with specific check for premium cluster keywords
    case PAID_TOOLS_PROMPT_FOR.CLUSTER_KEYWORDS:
      return premiumClusterKeyword.includes(toolDetails.cluster_by) ? 4 : 2;

    // Default case
    default:
      return 1;
  }
};

export const STARTER_USD_MONTHLY = isProductionEnv
  ? chargebeeAiToolsPaidPlans.prod.STARTER_USD_MONTHLY.id
  : chargebeeAiToolsPaidPlans.dev.STARTER_USD_MONTHLY.id;
export const LITE_USD_MONTHLY = isProductionEnv
  ? chargebeeAiToolsPaidPlans.prod.LITE_USD_MONTHLY.id
  : chargebeeAiToolsPaidPlans.dev.LITE_USD_MONTHLY.id;
export const PRO_USD_MONTHLY = isProductionEnv
  ? chargebeeAiToolsPaidPlans.prod.PRO_USD_MONTHLY.id
  : chargebeeAiToolsPaidPlans.dev.PRO_USD_MONTHLY.id;
export const ULTRA_USD_MONTHLY = isProductionEnv
  ? chargebeeAiToolsPaidPlans.prod.ULTRA_USD_MONTHLY.id
  : chargebeeAiToolsPaidPlans.dev.ULTRA_USD_MONTHLY.id;

export const STARTER_USD_YEARLY = isProductionEnv
  ? chargebeeAiToolsPaidPlans.prod.STARTER_USD_YEARLY.id
  : chargebeeAiToolsPaidPlans.dev.STARTER_USD_YEARLY.id;
export const LITE_USD_YEARLY = isProductionEnv
  ? chargebeeAiToolsPaidPlans.prod.LITE_USD_YEARLY.id
  : chargebeeAiToolsPaidPlans.dev.LITE_USD_YEARLY.id;
export const PRO_USD_YEARLY = isProductionEnv
  ? chargebeeAiToolsPaidPlans.prod.PRO_USD_YEARLY.id
  : chargebeeAiToolsPaidPlans.dev.PRO_USD_YEARLY.id;
export const ULTRA_USD_YEARLY = isProductionEnv
  ? chargebeeAiToolsPaidPlans.prod.ULTRA_USD_YEARLY.id
  : chargebeeAiToolsPaidPlans.dev.ULTRA_USD_YEARLY.id;

export const handleGenerateOutput = (
  creditsRemaining,
  creditsNeeded,
  isQwaDashboard,
  session,
  qttr_tools_daypass_auth,
  setShowMinimumCreditsNeededMsg,
  setShowBuyOnePass,
  handleWriteTitleTag,
  trackAnalyticsEvent,
  freeToolsUsage = 0,
  showFreeToolsUsage = false,
  isGenerateMore = false
) => {
  const hasActiveToolsPlan = [
    SUBSCRIPTION_STATUS.SUBSCRIPTION_ACTIVATED,
    SUBSCRIPTION_STATUS.SUBSCRIPTION_CREATED,
    SUBSCRIPTION_STATUS.SUBSCRIPTION_RESUMED,
    SUBSCRIPTION_STATUS.SUBSCRIPTION_REACTIVATED,
  ]?.includes(session?.session?.user?.qwa_tools_subscription_status);
  const hasPlanId = session?.session?.user?.planId;

  if (creditsRemaining < creditsNeeded && hasActiveToolsPlan && !qttr_tools_daypass_auth && !showFreeToolsUsage) {
    setShowMinimumCreditsNeededMsg(creditsRemaining <= 0 ? false : true);
    setShowBuyOnePass(true);
    if (creditsRemaining <= 0) {
      trackAnalyticsEvent({
        eventName: 'Consumed Daily Credits',
        payload: {
          label: 'Consumed Daily Credits',
          creditsRemaining: creditsRemaining,
          creditsNeeded: creditsNeeded,
        },
      });
    } else {
      trackAnalyticsEvent({
        eventName: 'Less Limits Remaining',
        payload: {
          label: 'Less Limits Remaining',
          creditsRemaining: creditsRemaining,
          creditsNeeded: creditsNeeded,
        },
      });
    }
  } else if (
    !hasActiveToolsPlan &&
    showFreeToolsUsage &&
    !qttr_tools_daypass_auth &&
    freeToolsUsage < creditsNeeded &&
    freeToolsUsage !== 0 &&
    !isGenerateMore
  ) {
    setShowMinimumCreditsNeededMsg(freeToolsUsage <= 0 ? false : true);
    setShowBuyOnePass(true);
  } else if (qttr_tools_daypass_auth && creditsNeeded > 0 && creditsNeeded > creditsRemaining) {
    setShowMinimumCreditsNeededMsg(true);
    setShowBuyOnePass(true);
  } else {
    handleWriteTitleTag(isGenerateMore);
  }
};

export const formatUnixDate = (unixTimestamp) => {
  try {
    if (!unixTimestamp) return '';
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const date = new Date(unixTimestamp * 1000);
    const options = {
      timeZone: timezone,
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: 'numeric',
      minute: 'numeric',
      second: 'numeric',
    };
    return new Intl.DateTimeFormat('en-US', options).format(date) || '';
  } catch (error) {
    console.error('Error formatting unix timestamp:', error);
    return '';
  }
};

export const formatToEnUsDate = (date) => {
  const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const receivedDate = new Date(date);
  const options = {
    timeZone: timezone,
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
    second: 'numeric',
  };
  return new Intl.DateTimeFormat('en-US', options).format(receivedDate) || '';
};

export const MsSvg = ({ size = 18 }) => {
  return (
    <svg width={size} height={size} viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_2767_2710)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9.75 0H10.5C14.6425 0 18 3.35754 18 7.5V8.25H9.75V0Z"
          fill="#3D3D3D"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 10.5C0 6.35754 3.35754 3 7.5 3H8.25V9.75H15V10.5C15 14.6425 11.6425 18 7.5 18C3.35754 18 0 14.6425 0 10.5ZM6.75 4.54641C3.79002 4.91541 1.5 7.43996 1.5 10.5C1.5 13.814 4.18596 16.5 7.5 16.5C10.56 16.5 13.0846 14.21 13.4536 11.25H6.75V4.54641Z"
          fill="#3D3D3D"
        />
      </g>
      <defs>
        <clipPath id="clip0_2767_2710">
          <rect width="18" height="18" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const getBadgeSize = (value = 0) => {
  const length = value.toString().length;

  if (length === 1) {
    return 'small'; // 1-digit numbers
  } else if (length === 2 || length === 3) {
    return 'medium'; // 2-3 digit numbers
  } else {
    return 'large'; // 4 or more digits
  }
};

export const getDomainFromEmail = (email) => {
  const nonCorporateDomains = [
    'gmail.com',
    'outlook.com',
    'hotmail.com',
    'yahoo.com',
    'me.com',
    'icloud.com',
    'msn.com',
    'live.com',
    'proton.me',
    '.edu',
    'ac.in',
  ];

  if (!email || !email.includes('@')) throw new Error('Invalid email');
  const domain = email.split('@')[1].toLowerCase();

  // Check if the domain is in the non-corporate list or matches any suffixes
  if (nonCorporateDomains.some((nd) => domain.endsWith(nd))) return null;

  return domain;
};

export const getAiToolsUrl = (urlPath) => {
  // Define a mapping of paths to their corresponding ai-tools URLs
  const pathMapping = {
    '/free-tools/title-generator': '/app/ai-tools/title-generator',
    '/free-tools/heading-generator': '/app/ai-tools/h1-heading-generator',
    '/free-tools/seo-url-generator': '/app/ai-tools/seo-friendly-url-generator',
    '/free-tools/meta-description-generator': '/app/ai-tools/meta-description-generator',
    '/free-tools/paragraph-generator': '/app/ai-tools/paragraph-generator',
    '/free-tools/ai-rewriter': '/app/ai-tools/paragraph-rewriter',
    '/free-tools/content-brief-generator': '/app/ai-tools/content-brief-generator',
    '/free-tools/paraphraser': '/app/ai-tools/paraphraser',
    '/free-tools/summary-generator': '/app/ai-tools/summary-generator',
    '/free-tools/active-passive-changer': '/app/ai-tools/active-passive-converter',
    '/free-tools/step-wise-instructions': '/app/ai-tools/step-wise-instructions-generator',
    '/free-tools/heading-rewriter': '/app/ai-tools/heading-rewriter',
    '/free-tools/topic-discovery': '/app/ai-tools/discover-topics',
    '/free-tools/image-alt-text-generator': '/app/ai-tools/image-alt-text-generator',
    '/free-tools/anchor-text-generator': '/app/ai-tools/anchor-text-generator',
    '/free-tools/keyword-research': '/app/ai-tools/keyword-research-tool',
    '/free-tools/keyword-statistics': '/app/ai-tools/keyword-statistics',
    '/free-tools/keyword-clustering': '/app/ai-tools/cluster-keywords',
    '/free-tools/ai-text-generator': '/app/ai-tools/ai-text-generator',
  };

  // Return the corresponding ai-tools URL or null if no match is found
  return pathMapping[urlPath] || null;
};

export const formatInternalLinkingDate = (dateString) => {
  try {
    if (!dateString) {
      return '';
    }
    if (dateString.includes('_')) {
      // Replace the first underscore with a space (between date and time)
      // and the remaining underscores with colons
      dateString = dateString.replace('_', ' ').replace(/_/g, ':');
    }
    const normalizedDateString = dateString.replace('_', '-').replace(/_/g, ':');
    const date = new Date(normalizedDateString);
    const options = {
      month: '2-digit',
      day: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: true,
    };
    return new Intl.DateTimeFormat('en-US', options).format(date);
  } catch (error) {
    return '';
  }
};

export const mapSnowflakeLinkingData = (snowflakeData = [], moduleIdExistAtS3Runs = []) => {
  const fromatedData = [];
  for (const ilData of snowflakeData) {
    const moduleDetails = ilData?.MODULE_DETAILS || ilData?.MODULE_DETAILS_DRAFT;
    const publishedName = ilData?.MODULE_DETAILS?.['Overall Metrics']?.Module_Name;
    const draftName = ilData?.MODULE_DETAILS_DRAFT?.['Overall Metrics']?.Module_Name;
    if (!moduleIdExistAtS3Runs?.includes(ilData?.MODULE_ID)) {
      const updatedOverAllMetrics = {
        module_id: ilData?.MODULE_ID,
        'Total Source URLs': moduleDetails?.['Overall Metrics']?.['Source_Criteria']?.Internal_Linking_Url_Count,
        'Total Target URLs': moduleDetails?.['Overall Metrics']?.['Target_Criteria']?.Internal_Linking_Url_Count,
        // 'Source Categories': sourceList,
        // 'Target Categories': TargetList,
        // "Total Target Clicks": 4035,
        // "Total Target Impression": 28885,
        // "Total Internal Links Predicted": 9,
        // "Total Source Metrics": 4,
        // "Total Target Metrics": 9,
        'Individual File Location': ilData?.MODULE_ID + '.json',
        'CSV File Location': ilData?.MODULE_ID + '.csv',
        // "File Creation Date": "",
        'Job Name': ilData?.MODULE_NAME,
        Status: ilData?.STATUS,
        Id: ilData?.JOB_ID,
        isNew: true,
        modifiedDate: formatInternalLinkingDate(ilData?.UPDATED_AT || ilData?.CREATED_AT),
        createdBy: ilData?.CREATED_BY,
        updatedBy: ilData?.UPDATED_BY,
        currentUsedName: {
          publishedName,
          draftName,
        },
      };
      const finalRunMetrics = {
        ...moduleDetails,
        'Overall Metrics': {
          ...(moduleDetails?.['Overall Metrics'] || {}),
          ...(updatedOverAllMetrics || {}),
        },
      };
      fromatedData.push(finalRunMetrics);
    }
  }
  return fromatedData || [];
};

export const hasAnyValuesForAnyKeys = (obj = {}) => {
  for (const key in obj) {
    for (const subKey in obj[key]) {
      if (obj[key][subKey].length > 0) {
        return true;
      }
    }
  }
  return false;
};

export const setCriteriaIds = ({ id, isAnySourceCriteriaPresent, isAnyTargetCriteriaPresent }) => {
  const criteriaId = id?.replace(/-/g, '');
  return {
    src_criteria_id_draft: isAnySourceCriteriaPresent ? `DSRC${criteriaId}` : undefined,
    src_criteria_id_published: isAnySourceCriteriaPresent ? `PSRC${criteriaId}` : undefined,
    target_criteria_id_draft: isAnyTargetCriteriaPresent ? `DTRG${criteriaId}` : undefined,
    target_criteria_id_published: isAnyTargetCriteriaPresent ? `PTRG${criteriaId}` : undefined,
  };
};

export const getDateByFormat = (date, formating = '') => {
  if (!date) {
    return null;
  }
  try {
    if (formating) {
      const formattedDate = format(new Date(date), formating);
      if (isNaN(new Date(date).getTime())) {
        throw new Error('getDateByFormat: Invalid Date');
      }
      return formattedDate;
    }
    return new Date(date);
  } catch (error) {
    console.error('getDateByFormat: Date formatting error for:', { date, formating });
    console.error('getDateByFormat Date formatting error:', error.message);
    return null;
  }
};

export const validateIlModuleName = (ilModuleName) => {
  if (!ilModuleName?.trim()) {
    return 'Please provide a valid name for the Linking Module to proceed.';
  }
  if (ilModuleName?.length < 3) {
    return 'The Linking Module Name must be at least 3 characters long.';
  }
  if (ilModuleName?.length > 50) {
    return 'The Linking Module Name cannot exceed 50 characters.';
  }
  if (/[^a-zA-Z0-9\s_-]/.test(ilModuleName)) {
    return 'The Linking Module Name can only contain letters, numbers, and spaces.';
  }
  if (/\s{2,}/.test(ilModuleName)) {
    return 'The Linking Module Name cannot have consecutive spaces.';
  }
  if (ilModuleName !== ilModuleName.trim()) {
    return 'The Linking Module Name cannot have leading or trailing spaces.';
  }
  return '';
};

export const omitNestedKeys_old = (
  data,
  keysToOmit = ['Overall Metrics.Module_Name', 'Overall Metrics.Job Name', 'Overall Metrics.Instructions']
) => {
  return keysToOmit?.reduce((result, key) => {
    return omit(result, key);
  }, data);
};

export const omitNestedKeys = (
  data,
  keysToOmit = ['Overall Metrics.Module_Name', 'Overall Metrics.Job Name', 'Overall Metrics.Instructions'],
  emptyKeysToOmit = ['Overall Metrics.Selected_Tag', 'Overall Metrics.Selected_Tag_Group']
) => {
  let result = keysToOmit?.reduce((result, key) => {
    return omit(result, key);
  }, data);

  if (emptyKeysToOmit?.length > 0) {
    result = emptyKeysToOmit.reduce((res, key) => {
      const value = get(res, key);
      if (value === '' || value === undefined) {
        return omit(res, key);
      }
      return res;
    }, result);
  }
  return result;
};

export const pagTagGroupWiseTagGroups = (tagGroupObjList = []) => {
  const mainGroupWiseGrouping = {};
  for (const data of tagGroupObjList || []) {
    const groupName = data?.findTagGroupDetails?.groupName;
    const mappedObj = {
      text: data?.findTagGroupDetails?.text || data?.title,
      tagKeyName: data?.findTagGroupDetails?.value || data?.filterKey,
      value: data?.findTagGroupDetails?.value || data?.filterKey,
    };
    if (mainGroupWiseGrouping?.[groupName]) {
      mainGroupWiseGrouping[groupName].children.push(mappedObj);
    } else {
      mainGroupWiseGrouping[groupName] = {
        groupName: groupName,
        label: groupName,
        children: [mappedObj],
      };
    }
  }
  return Object.values(mainGroupWiseGrouping || {});
};

export const replaceIfStartsWithPageTag = (input = '') => {
  if (input?.toLowerCase()?.startsWith('page_tag')) {
    return input?.toLowerCase()?.replace('page_tag', '');
  }
  return input;
};

export const removeTOCFromJSON = (node) => {
  if (node?.children && Array.isArray(node?.children)) {
    node.children = node?.children
      .filter((child) => !(child?.tag === 'DIV' && child?.attributes?.class === 'mce-toc'))
      .map(removeTOCFromJSON);
  }
  return node;
};

export const removeDivWithClass = (html, className) => {
  const parser = new DOMParser();
  const doc = parser.parseFromString(html, 'text/html');
  const tocDiv = doc.querySelector(`div.${className}`);
  let isTocFound = false;
  if (tocDiv) {
    tocDiv.remove();
    isTocFound = true;
  }
  return {
    htmlContent: doc.body.innerHTML,
    isTocFound,
  };
};

export const updateTinyMceJsonChildreenText = (json, targetElementId, newValue) => {
  try {
    if (!json || typeof json !== 'object') {
      throw new Error('updateTinyMceJsonChildreenText: Invalid JSON structure');
    }

    if (json.children && Array.isArray(json.children)) {
      json.children = json.children.map((child) => {
        try {
          if (typeof child === 'string' && Number(json.attributes?.element_id) === Number(targetElementId)) {
            return newValue;
          } else if (typeof child === 'object') {
            return updateTinyMceJsonChildreenText(child, targetElementId, newValue);
          }
          return child;
        } catch (childError) {
          console.error('updateTinyMceJsonChildreenText: Error processing child:', childError);
          return child; // Return the original child if an error occurs
        }
      });
    }
    return json;
  } catch (error) {
    console.error('updateTinyMceJsonChildreenText: Error updating JSON:', error);
    return json; // Return the original JSON if an error occurs
  }
};

const addInlineStylesToHtmlString = (htmlString, className = 'giga-suggested-content-wrapper') => {
  const parser = new DOMParser();
  const doc = parser.parseFromString(htmlString, 'text/html');

  doc.querySelectorAll('[data-giga-new="true"]').forEach((el) => {
    el.style.borderWidth = '1px';
    el.style.borderRadius = '5px';
    el.style.background = 'linear-gradient(90deg, rgba(59, 0, 137, 0.1) 0%, rgba(0, 74, 179, 0.1) 100%)';
    el.style.padding = '5px 10px';
  });

  return doc.body.innerHTML; // Convert back to string
};

export const downloadCOntentTabOutput = (htmlContent, fileName = 'download.html') => {
  const htmlContentWithInlineStyles = addInlineStylesToHtmlString(htmlContent, 'giga-suggested-content-wrapper');
  const blob = new Blob([htmlContentWithInlineStyles], { type: 'text/html' });
  const url = URL.createObjectURL(blob);

  const a = document.createElement('a');
  a.href = url;
  a.download = fileName;
  document.body.appendChild(a);
  a.click();

  URL.revokeObjectURL(url);
  document.body.removeChild(a);
};

export const isMoreThan24Hours = (givenDate) => {
  try {
    const givenTime = new Date(givenDate).getTime();
    const currentTime = new Date().getTime();
    const diffInMs = currentTime - givenTime;
    const diffInHours = diffInMs / (1000 * 60 * 60);
    return diffInHours > 24;
  } catch (error) {
    console.error('isMoreThan24Hours: Error checking if date is more than 24 hours:', error);
    return true;
  }
};
